// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.capitalExpenditure_capitalExpenditureContainer__QFLet {
  padding: 20px;
  font-family: "Arial", sans-serif;
  background-color: #f8f9fa;
  min-height: 100vh;
  box-sizing: border-box;
}

.capitalExpenditure_header__01PDc {
  text-align: center;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.capitalExpenditure_universityTitle__UMlaw {
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 12px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.capitalExpenditure_currentYearBanner__EBHiz {
  display: inline-flex;
  align-items: baseline;
  gap: 10px;
  margin: 0 auto 18px;
  padding: 8px 18px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  color: #fff;
}

.capitalExpenditure_currentYearLabel__6EThY {
  font-size: 13px;
  letter-spacing: 0.4px;
  opacity: 0.9;
}

.capitalExpenditure_currentYearValue__4v6\\+V {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.capitalExpenditure_navButtons__zEVZ8 {
  display: flex;
  gap: 15px;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.capitalExpenditure_navButton__ssAwr {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 0 220px !important;
  box-sizing: border-box;
}

.capitalExpenditure_navButton__ssAwr:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

.capitalExpenditure_navButton__ssAwr.capitalExpenditure_active__o\\+vnK {
  background: rgba(255, 255, 255, 0.3);
  border-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.capitalExpenditure_navButton__ssAwr.capitalExpenditure_activeTab__ToyLT {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border-color: #28a745;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  position: relative;
}

.capitalExpenditure_navButton__ssAwr.capitalExpenditure_activeTab__ToyLT::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #28a745, #20c997);
  border-radius: 0 0 6px 6px;
}

.capitalExpenditure_navButton__ssAwr.capitalExpenditure_logoutButton__UY6yH {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  margin-left: auto;
}
.capitalExpenditure_navButton__ssAwr.capitalExpenditure_logoutButton__UY6yH:hover {
  background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);
}

.capitalExpenditure_tabButton__XOWV4 {
  background: #ffffff;
  color: #495057;
  border: 2px solid #dee2e6;
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 5px;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-bottom: none;
  min-width: 160px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.capitalExpenditure_tabButton__XOWV4:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_tabButton__XOWV4.capitalExpenditure_activeTab__ToyLT {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border-color: #007bff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  position: relative;
  z-index: 10;
}

.capitalExpenditure_tabButton__XOWV4.capitalExpenditure_activeTab__ToyLT::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #007bff, #0056b3);
  border-radius: 0 0 8px 8px;
}

.capitalExpenditure_tabButton__XOWV4:not(.capitalExpenditure_activeTab__ToyLT) {
  background: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
}

.capitalExpenditure_tabButton__XOWV4:not(.capitalExpenditure_activeTab__ToyLT):hover {
  background: #e9ecef;
  color: #495057;
  border-color: #adb5bd;
}

.capitalExpenditure_formInput__1GSMK {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  background-color: #ffffff;
  box-sizing: border-box;
}

.capitalExpenditure_formInput__1GSMK:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.capitalExpenditure_formInput__1GSMK::placeholder {
  color: #adb5bd;
  font-style: italic;
}

.capitalExpenditure_formSelect__0Qiyk {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  background-color: #ffffff;
  cursor: pointer;
  box-sizing: border-box;
}

.capitalExpenditure_formSelect__0Qiyk:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.capitalExpenditure_formRow__QCC9C {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.capitalExpenditure_formRow__QCC9C label {
  min-width: 120px;
  font-weight: 600;
  color: #495057;
}

.capitalExpenditure_formRow__QCC9C span {
  flex: 1 1;
  padding: 10px 12px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color: #495057;
  font-size: 14px;
}

.capitalExpenditure_modeIndicator__5o6Kp {
  margin-bottom: 15px;
}
.capitalExpenditure_modeIndicator__5o6Kp .capitalExpenditure_viewMode__vd6i8, .capitalExpenditure_modeIndicator__5o6Kp .capitalExpenditure_editMode__9NJy3 {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_modeIndicator__5o6Kp .capitalExpenditure_viewMode__vd6i8 {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
}
.capitalExpenditure_modeIndicator__5o6Kp .capitalExpenditure_editMode__9NJy3 {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
  color: #212529;
}

.capitalExpenditure_officeDropdownContainer__XJtsy {
  position: relative;
  margin: 0 0 8px 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 15px;
  justify-content: center;
}

.capitalExpenditure_refreshButton__5DgQo {
  background: linear-gradient(135deg, #ffc107 0%, #ff8c00 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  transition: all 0.3s ease;
  border: none;
  min-width: 140px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.capitalExpenditure_refreshButton__5DgQo:hover {
  background: linear-gradient(135deg, #e0a800 0%, #e67e00 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.capitalExpenditure_refreshButton__5DgQo:active {
  transform: translateY(0);
}

.capitalExpenditure_refreshButton__5DgQo:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  opacity: 0.6;
}

.capitalExpenditure_modalOverlay__35Ny6 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(3px);
}
.capitalExpenditure_modalOverlay__35Ny6 .capitalExpenditure_popupMessage__5f4NT {
  position: relative;
  z-index: 10000;
  animation: capitalExpenditure_modalSlideIn__fCD6P 0.3s ease-out;
  margin: 20px;
  max-width: 90vw;
}

@keyframes capitalExpenditure_modalSlideIn__fCD6P {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
.capitalExpenditure_refresh__zWQ2\\+ {
  background: linear-gradient(135deg, #ffc107 0%, #ff8c00 100%);
  color: white;
  max-width: 500px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  border-radius: 12px;
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupHeader__ItWQo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupHeader__ItWQo h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupBody__cEiQB p {
  margin: 0 0 20px 0;
  font-size: 14px;
  line-height: 1.5;
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupActions__ujuMt {
  display: flex;
  gap: 15px;
  justify-content: center;
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupActions__ujuMt .capitalExpenditure_confirmButton__fy16w, .capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupActions__ujuMt .capitalExpenditure_cancelButton__eUZxV {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupActions__ujuMt .capitalExpenditure_confirmButton__fy16w {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupActions__ujuMt .capitalExpenditure_confirmButton__fy16w:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-1px);
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupActions__ujuMt .capitalExpenditure_cancelButton__eUZxV {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}
.capitalExpenditure_refresh__zWQ2\\+ .capitalExpenditure_refreshPopupActions__ujuMt .capitalExpenditure_cancelButton__eUZxV:hover {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-1px);
}

.capitalExpenditure_uploadSection__CPIBj {
  margin-top: 15px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  max-width: 400px;
}

.capitalExpenditure_uploadLabel__cOE-S {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
  color: white;
  text-align: center;
}

.capitalExpenditure_uploadInputContainer__Z3QVI {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.capitalExpenditure_uploadInput__DlWBo {
  position: absolute;
  left: -9999px;
  opacity: 0;
  pointer-events: none;
}

.capitalExpenditure_uploadButton__X5JcD {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  transition: all 0.3s ease;
  border: none;
  min-width: 120px;
  display: inline-block;
}

.capitalExpenditure_uploadButton__X5JcD:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.capitalExpenditure_uploadButton__X5JcD:active {
  transform: translateY(0);
}

.capitalExpenditure_uploadButton__X5JcD:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  opacity: 0.6;
}

.capitalExpenditure_downloadTemplateButton__Ai2Ic {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  transition: all 0.3s ease;
  border: none;
  min-width: 120px;
  display: inline-block;
  margin-left: 10px;
}

.capitalExpenditure_downloadTemplateButton__Ai2Ic:hover {
  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.capitalExpenditure_downloadTemplateButton__Ai2Ic:active {
  transform: translateY(0);
}

.capitalExpenditure_downloadTemplateButton__Ai2Ic:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
}

.capitalExpenditure_selectedFileInfo__DcgOD {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 8px 12px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  font-size: 14px;
}

.capitalExpenditure_clearFileButton__geccq {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}

.capitalExpenditure_clearFileButton__geccq:hover {
  background: #c82333;
}

.capitalExpenditure_uploadingNote__WBFS8 {
  display: block;
  color: #ffc107;
  font-weight: bold;
  text-align: center;
  margin: 10px 0;
  font-size: 14px;
}

.capitalExpenditure_uploadWarning__ixjuH {
  margin-bottom: 20px;
  padding: 15px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  font-size: 14px;
  color: #856404;
}
.capitalExpenditure_uploadWarning__ixjuH strong {
  color: #856404;
}
.capitalExpenditure_uploadWarning__ixjuH ul {
  margin: 10px 0 0 20px;
  padding: 0;
}
.capitalExpenditure_uploadWarning__ixjuH ul li {
  margin: 5px 0;
  line-height: 1.4;
}

.capitalExpenditure_uploadHint__oB38J {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  text-align: center;
  line-height: 1.4;
  margin-top: 10px;
}

.capitalExpenditure_settingsContainer__zrlJ2 {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.capitalExpenditure_settingsTitle__wdE5k {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}

.capitalExpenditure_subTabNavigation__bfJpT {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #e0e0e0;
}

.capitalExpenditure_subTabButton__E9qFQ {
  background: none;
  border: none;
  padding: 15px 30px;
  margin: 0 10px;
  font-size: 16px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
}
.capitalExpenditure_subTabButton__E9qFQ:hover {
  color: #007bff;
}
.capitalExpenditure_subTabButton__E9qFQ.capitalExpenditure_activeSubTab__d3nDF {
  color: #007bff;
  border-bottom-color: #007bff;
}

.capitalExpenditure_listSettingsContent__i6cnu {
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_listSettingsContent__i6cnu .capitalExpenditure_uploadWarning__ixjuH {
  margin-bottom: 20px;
  padding: 15px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  font-size: 14px;
  color: #856404;
}
.capitalExpenditure_listSettingsContent__i6cnu .capitalExpenditure_uploadWarning__ixjuH strong {
  color: #856404;
}
.capitalExpenditure_listSettingsContent__i6cnu .capitalExpenditure_uploadWarning__ixjuH ul {
  margin: 10px 0 0 20px;
  padding: 0;
}
.capitalExpenditure_listSettingsContent__i6cnu .capitalExpenditure_uploadWarning__ixjuH ul li {
  margin: 5px 0;
  line-height: 1.4;
}
.capitalExpenditure_listSettingsContent__i6cnu .capitalExpenditure_uploadHint__oB38J {
  color: #666;
  font-size: 12px;
  text-align: center;
  line-height: 1.4;
  margin-top: 10px;
}

.capitalExpenditure_tokenSettingsContent__hDtPc {
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-height: 500px;
}

.capitalExpenditure_selectionInfo__YItRo {
  margin-bottom: 25px;
}

.capitalExpenditure_infoBox__0U68v {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 20px;
  color: #856404;
}
.capitalExpenditure_infoBox__0U68v h4 {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 600;
}
.capitalExpenditure_infoBox__0U68v p {
  margin: 8px 0;
  line-height: 1.5;
}
.capitalExpenditure_infoBox__0U68v ul {
  margin: 10px 0;
  padding-left: 20px;
}
.capitalExpenditure_infoBox__0U68v ul li {
  margin: 5px 0;
  line-height: 1.4;
}
.capitalExpenditure_infoBox__0U68v strong {
  font-weight: 600;
}

.capitalExpenditure_masterItemsSection__-5CY\\+ {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 2px solid #e0e0e0;
}
.capitalExpenditure_masterItemsSection__-5CY\\+ h3 {
  color: #333;
  font-size: 18px;
  margin-bottom: 20px;
  text-align: center;
}

.capitalExpenditure_masterItemsTable__fH7PN {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.capitalExpenditure_masterItemsHeader__xseE1 {
  display: grid;
  grid-template-columns: 50px 120px 1fr 200px 120px;
  gap: 15px;
  background: #f8f9fa;
  padding: 15px;
  font-weight: bold;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  font-size: 14px;
}

.capitalExpenditure_headerCheckbox__VqEbV {
  text-align: center;
  width: 50px;
  flex-shrink: 0;
}
.capitalExpenditure_headerCheckbox__VqEbV input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #007bff;
}
.capitalExpenditure_headerCheckbox__VqEbV input[type=checkbox]:hover {
  transform: scale(1.1);
}

.capitalExpenditure_headerCode__gVq8i {
  font-weight: bold;
  color: #495057;
}

.capitalExpenditure_headerTitle__Y4bIW {
  font-weight: bold;
  color: #495057;
}

.capitalExpenditure_headerType__AAvn5 {
  font-weight: bold;
  color: #495057;
}

.capitalExpenditure_headerActions__S8EFw {
  font-weight: bold;
  color: #495057;
  text-align: center;
}

.capitalExpenditure_masterItemsList__Zf45x {
  max-height: 400px;
  overflow-y: auto;
}

.capitalExpenditure_masterItem__DGs9h {
  display: grid;
  grid-template-columns: 50px 120px 1fr 200px 120px;
  gap: 15px;
  align-items: center;
  padding: 15px;
  background: white;
  border-bottom: 1px solid #e9ecef;
  transition: all 0.2s ease;
}
.capitalExpenditure_masterItem__DGs9h:hover {
  background: #f8f9fa;
}
.capitalExpenditure_masterItem__DGs9h:last-child {
  border-bottom: none;
}

.capitalExpenditure_itemCode__kdNIP {
  background: #007bff;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  min-width: 80px;
  text-align: center;
}

.capitalExpenditure_itemTitle__1BdIc {
  flex: 1 1;
  font-weight: 500;
  color: #333;
}

.capitalExpenditure_itemType__j8\\+pH {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.capitalExpenditure_itemType__j8\\+pH.capitalExpenditure_capital__LJS4p {
  background: #28a745;
  color: white;
}
.capitalExpenditure_itemType__j8\\+pH.capitalExpenditure_operational__d\\+FP4 {
  background: #ffc107;
  color: #212529;
}

.capitalExpenditure_itemCheckbox__kaQ6D {
  text-align: center;
  width: 50px;
  flex-shrink: 0;
}
.capitalExpenditure_itemCheckbox__kaQ6D input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #007bff;
}
.capitalExpenditure_itemCheckbox__kaQ6D input[type=checkbox]:hover {
  transform: scale(1.1);
}

.capitalExpenditure_itemActions__33Pw1 {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.capitalExpenditure_successBox__c5HxQ {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 8px;
  padding: 20px;
  color: #155724;
}
.capitalExpenditure_successBox__c5HxQ h4 {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 600;
}
.capitalExpenditure_successBox__c5HxQ p {
  margin: 8px 0;
  line-height: 1.5;
}

.capitalExpenditure_officeDropdown__3vzAz {
  background: rgba(255, 255, 255, 0.95);
  color: #000000;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.capitalExpenditure_officeDropdown__3vzAz:hover {
  background: rgb(255, 255, 255);
  border-color: #2a5298;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_officeDropdown__3vzAz.capitalExpenditure_required__hp26l {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.capitalExpenditure_officeDropdown__3vzAz.capitalExpenditure_required__hp26l:hover {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.2);
}

.capitalExpenditure_selectedOffice__Qahw4 {
  flex: 1 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.capitalExpenditure_dropdownArrow__tm1yu {
  margin-left: 10px;
  font-size: 12px;
  transition: transform 0.3s ease;
}

.capitalExpenditure_officeDropdownMenu__6yp0r {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  margin-top: 5px;
  max-height: 400px;
  overflow: hidden;
  animation: capitalExpenditure_slideDown__b2SfC 0.3s ease-out;
}

.capitalExpenditure_searchContainer__4nM-0 {
  padding: 15px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.capitalExpenditure_officeSearchInput__EVy7L {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  color: #000000;
  transition: border-color 0.2s ease;
}

.capitalExpenditure_officeSearchInput__EVy7L:focus {
  outline: none;
  border-color: #2a5298;
  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);
}

.capitalExpenditure_officeOptionsList__vsEPR {
  max-height: 300px;
  overflow-y: auto;
}

.capitalExpenditure_officeOption__SMLoi {
  padding: 12px 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f1f3f4;
  font-size: 14px;
  line-height: 1.4;
  color: #000000;
}

.capitalExpenditure_officeOption__SMLoi:hover {
  background-color: #f8f9fa;
}

.capitalExpenditure_officeOption__SMLoi.capitalExpenditure_selected__Dxo2F {
  background-color: #e3f2fd;
  color: #000000;
  font-weight: 600;
}

.capitalExpenditure_noResults__WeQG\\+ {
  padding: 20px;
  text-align: center;
  color: #000000;
  font-style: italic;
}

.capitalExpenditure_categoryDropdownContainer__lZsnM {
  position: relative;
  width: 100%;
}

.capitalExpenditure_categoryDropdown__lrKkn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  min-height: 38px;
  transition: border-color 0.2s;
}
.capitalExpenditure_categoryDropdown__lrKkn:hover {
  border-color: #007bff;
}

.capitalExpenditure_selectedCategory__qrU1P {
  color: #333;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.capitalExpenditure_categoryDropdownMenu__RuYqw {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 300px;
  overflow: hidden;
  animation: capitalExpenditure_slideDown__b2SfC 0.2s ease-out;
}

.capitalExpenditure_categoryOptionsList__8VsWi {
  max-height: 250px;
  overflow-y: auto;
}

.capitalExpenditure_categoryOption__DbuAd {
  padding: 8px 12px;
  cursor: pointer;
  color: #000000;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}
.capitalExpenditure_categoryOption__DbuAd:hover {
  background-color: #f8f9fa;
}
.capitalExpenditure_categoryOption__DbuAd.capitalExpenditure_selected__Dxo2F {
  background-color: #e3f2fd;
  color: #000000;
  font-weight: 600;
}

.capitalExpenditure_categorySearchInput__p6UAT {
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-bottom: 1px solid #ddd;
  outline: none;
  font-size: 14px;
  color: #000000;
  background: transparent;
}
.capitalExpenditure_categorySearchInput__p6UAT::placeholder {
  color: #999;
}

@keyframes capitalExpenditure_slideDown__b2SfC {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.capitalExpenditure_fiscalYear__uykQQ {
  font-size: 18px;
  margin: 0;
  font-weight: 500;
}

.capitalExpenditure_message__7yyix {
  padding: 15px 20px;
  margin: 20px 0;
  border-radius: 6px;
  font-weight: bold;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: capitalExpenditure_slideIn__63\\+TM 0.3s ease-out;
}

.capitalExpenditure_success__Z4Ssi {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border: 2px solid #28a745;
}

.capitalExpenditure_error__hJFf\\+ {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border: 2px solid #dc3545;
}

.capitalExpenditure_info__HTu4G {
  background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%);
  color: #0c5460;
  border: 2px solid #17a2b8;
}

@keyframes capitalExpenditure_slideIn__63\\+TM {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.capitalExpenditure_clearPrompt__Jm3-g {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: capitalExpenditure_fadeIn__pqSNr 0.3s ease-out;
}

.capitalExpenditure_clearPromptContent__60TwZ {
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 400px;
  width: 90%;
  animation: capitalExpenditure_scaleIn__TxtWp 0.3s ease-out;
}

.capitalExpenditure_clearPromptContent__60TwZ h3 {
  color: #1e3c72;
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: bold;
}

.capitalExpenditure_clearPromptContent__60TwZ p {
  color: #6c757d;
  margin-bottom: 25px;
  font-size: 16px;
  line-height: 1.5;
}

.capitalExpenditure_clearPromptButtons__PNbmF {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.capitalExpenditure_clearButton__vQ\\+AP {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_clearButton__vQ\\+AP:hover:not(:disabled) {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_clearButton__vQ\\+AP:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_keepButton__Y55VI {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_keepButton__Y55VI:hover:not(:disabled) {
  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_keepButton__Y55VI:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

@keyframes capitalExpenditure_fadeIn__pqSNr {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes capitalExpenditure_scaleIn__TxtWp {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.capitalExpenditure_expenditureForm__\\+1tXb {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.capitalExpenditure_formHeader__\\+qwZG {
  margin-bottom: 25px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}
.capitalExpenditure_formHeader__\\+qwZG .capitalExpenditure_formInfo__QTJSS {
  display: flex;
  gap: 30px;
  align-items: center;
  flex-wrap: wrap;
}
.capitalExpenditure_formHeader__\\+qwZG .capitalExpenditure_formInfo__QTJSS .capitalExpenditure_infoGroup__Z7TDy {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.capitalExpenditure_formHeader__\\+qwZG .capitalExpenditure_formInfo__QTJSS .capitalExpenditure_infoGroup__Z7TDy label {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}
.capitalExpenditure_formHeader__\\+qwZG .capitalExpenditure_formInfo__QTJSS .capitalExpenditure_infoGroup__Z7TDy .capitalExpenditure_fiscalYearSelect__rJNCC {
  padding: 10px 15px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  min-width: 200px;
  background: white;
}
.capitalExpenditure_formHeader__\\+qwZG .capitalExpenditure_formInfo__QTJSS .capitalExpenditure_infoGroup__Z7TDy .capitalExpenditure_fiscalYearSelect__rJNCC:focus {
  outline: none;
  border-color: #1e3c72;
  box-shadow: 0 0 0 2px rgba(30, 60, 114, 0.2);
}
.capitalExpenditure_formHeader__\\+qwZG .capitalExpenditure_formInfo__QTJSS .capitalExpenditure_infoGroup__Z7TDy .capitalExpenditure_fiscalYearSelect__rJNCC:disabled {
  background: #e9ecef;
  cursor: not-allowed;
}

.capitalExpenditure_tableContainer__esNEd {
  overflow-x: auto;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 100%;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

@media (max-width: 1200px) {
  .capitalExpenditure_expenditureTable__l2sPf {
    min-width: 1000px;
  }
  .capitalExpenditure_titleCell__J04\\+V .capitalExpenditure_inputField__PHrs1 {
    max-width: 300px;
  }
}
@media (max-width: 768px) {
  .capitalExpenditure_expenditureTable__l2sPf {
    min-width: 1200px;
  }
  .capitalExpenditure_titleCell__J04\\+V .capitalExpenditure_inputField__PHrs1 {
    max-width: 250px;
  }
}
.capitalExpenditure_dataViewYearBar__YGYXb {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 14px;
  padding: 10px 14px;
  background: #e8f0fb;
  border: 1px solid #c5d4eb;
  border-radius: 6px;
  color: #1e3c72;
  font-size: 15px;
}
.capitalExpenditure_dataViewYearBar__YGYXb strong {
  font-size: 18px;
}
.capitalExpenditure_dataViewYearBar__YGYXb em {
  font-style: normal;
  color: #4a678a;
  font-size: 13px;
}

.capitalExpenditure_dataViewContainer__QQhqR {
  max-width: 100%;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  width: 100%;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_tabButton__XOWV4 {
  min-width: 0;
  margin-right: 0;
  padding: 10px 14px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_filterToggleButton__qA9TK,
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_refreshButton__5DgQo,
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_excelButton__n202q,
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_bulkDeleteButton__RIjk2 {
  max-width: 100%;
  padding: 10px 14px;
  font-size: 13px;
  letter-spacing: 0;
  text-transform: none;
}

.capitalExpenditure_detailedReportTabs__HM6h4 {
  flex-wrap: wrap;
  row-gap: 10px;
}

@media (max-width: 1200px) {
  .capitalExpenditure_dataViewContainer__QQhqR {
    padding: 20px;
  }
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_tabButton__XOWV4 {
    font-size: 13px;
    padding: 9px 12px;
  }
}
@media (max-width: 768px) {
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_tabButton__XOWV4,
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_filterToggleButton__qA9TK,
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_refreshButton__5DgQo,
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_excelButton__n202q,
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p > .capitalExpenditure_filterActions__5v2Wq .capitalExpenditure_bulkDeleteButton__RIjk2 {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
  .capitalExpenditure_detailedReportTabs__HM6h4 {
    padding: 0;
  }
}
.capitalExpenditure_stickyCol1__7\\+EKr {
  position: sticky !important;
  left: 0 !important;
  z-index: 4;
  width: 90px;
  min-width: 90px;
  max-width: 90px;
}

.capitalExpenditure_stickyCol2__g5K\\+u {
  position: sticky !important;
  left: 90px !important;
  z-index: 4;
  width: 220px;
  min-width: 220px;
  max-width: 220px;
}

.capitalExpenditure_stickyCol3__j-q5k {
  position: sticky !important;
  left: 310px !important;
  z-index: 4;
  width: 110px;
  min-width: 110px;
  max-width: 110px;
}

.capitalExpenditure_stickyCol4__1Oa8l {
  position: sticky !important;
  left: 420px !important;
  z-index: 4;
  width: 110px;
  min-width: 110px;
  max-width: 110px;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_stickyColGroup2__tYUc\\+ {
  position: sticky !important;
  left: 0 !important;
  z-index: 4;
  width: 310px !important;
  min-width: 310px !important;
  max-width: 310px !important;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_stickyColGroup4__kKzgv {
  position: sticky !important;
  left: 0 !important;
  z-index: 4;
  min-width: 530px;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_categoryCellSticky__9nadE {
  position: sticky !important;
  left: 0 !important;
  z-index: 4;
  background: #f4d03f !important;
  color: #000;
  font-weight: bold;
  text-align: left;
  padding: 12px 8px;
  border: 1px solid #000;
  font-size: 16px;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_totalLabel__9A-h8 {
  font-weight: bold;
  text-align: center;
  white-space: normal;
  line-height: 1.25;
  font-size: 13px;
  word-break: break-word;
}

.capitalExpenditure_expenditureTable__l2sPf {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 2px solid #000;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 800px;
  table-layout: auto;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_mainHeader__6k\\+NI {
  background: linear-gradient(135deg, #f39c12, #e67e22);
  color: white;
  font-weight: bold;
  text-align: center;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_mainHeader__6k\\+NI th {
  padding: 12px 8px;
  border: 1px solid #d68910;
  vertical-align: middle;
  font-size: 15px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
  min-width: 80px;
  position: relative;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_mainHeader__6k\\+NI th:hover {
  background: linear-gradient(135deg, #e67e22, #d68910);
  transform: scale(1.02);
  transition: all 0.2s ease;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_subHeader__-3MiM {
  background: linear-gradient(135deg, #e67e22, #d68910);
  color: white;
  font-weight: 600;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_subHeader__-3MiM th {
  padding: 10px 6px;
  border: 1px solid #d68910;
  text-align: center;
  font-size: 13px;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_codeHeader__okuMw {
  min-width: 90px;
  width: 90px;
  background: linear-gradient(135deg, #3498db, #2980b9) !important;
  border: 2px solid #2980b9 !important;
  position: sticky !important;
  left: 0 !important;
  z-index: 6;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_codeHeader__okuMw:hover {
  transform: none;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_titleHeader__0mlEY {
  min-width: 220px;
  width: 220px;
  background: linear-gradient(135deg, #9b59b6, #8e44ad) !important;
  border: 2px solid #8e44ad !important;
  position: sticky !important;
  left: 90px !important;
  z-index: 6;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_titleHeader__0mlEY:hover {
  transform: none;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_budgetHeader__JljXv {
  min-width: 110px;
  width: 110px;
  background: linear-gradient(135deg, #e67e22, #d68910) !important;
  border: 2px solid #d68910 !important;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_budgetHeaderSticky3__izyco {
  position: sticky !important;
  left: 310px !important;
  z-index: 6;
  min-width: 110px !important;
  width: 110px !important;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_budgetHeaderSticky3__izyco:hover {
  transform: none;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_budgetHeaderSticky4__KBZVe {
  position: sticky !important;
  left: 420px !important;
  z-index: 6;
  min-width: 110px !important;
  width: 110px !important;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_budgetHeaderSticky4__KBZVe:hover {
  transform: none;
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_quarterHeader__AdZ01 {
  min-width: 250px;
  background: linear-gradient(135deg, #f39c12, #e67e22) !important;
  border: 2px solid #d68910 !important;
  color: white !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_summaryHeader__flOVC {
  min-width: 250px;
  background: linear-gradient(135deg, #27ae60, #2ecc71) !important;
  border: 2px solid #27ae60 !important;
  color: white !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_differenceHeader__\\+Cvdz {
  min-width: 120px;
  background: linear-gradient(135deg, #e74c3c, #c0392b) !important;
  border: 2px solid #e74c3c !important;
  color: white !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
.capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_subHeaderCell__yQ4mv {
  min-width: 80px;
  font-size: 12px;
  padding: 8px 4px;
}
.capitalExpenditure_expenditureTable__l2sPf th, .capitalExpenditure_expenditureTable__l2sPf td {
  box-sizing: border-box;
  vertical-align: middle;
}
.capitalExpenditure_expenditureTable__l2sPf th {
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.capitalExpenditure_expenditureTable__l2sPf th:last-child {
  border-right: none;
}

.capitalExpenditure_addRowButtons__K3WuB {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.capitalExpenditure_addRowButtons__K3WuB .capitalExpenditure_addRowButton__sr6OW {
  flex: 1 1;
  min-width: 200px;
  padding: 10px 15px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_addRowButtons__K3WuB .capitalExpenditure_addRowButton__sr6OW:hover {
  background: linear-gradient(135deg, #218838 0%, #1aa179 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.capitalExpenditure_addRowButtons__K3WuB .capitalExpenditure_addRowButton__sr6OW:active {
  transform: translateY(0);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_addRowButtons__K3WuB .capitalExpenditure_addRowButton__sr6OW:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.capitalExpenditure_mainHeader__6k\\+NI {
  background: linear-gradient(135deg, #f39c12, #e67e22);
  color: white;
  font-weight: bold;
  text-align: center;
  border: 1px solid #d68910;
}
.capitalExpenditure_mainHeader__6k\\+NI th {
  padding: 12px 8px;
  border: 1px solid #d68910;
  font-size: 15px;
  white-space: nowrap;
  vertical-align: middle;
  min-width: 80px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  position: relative;
}
.capitalExpenditure_mainHeader__6k\\+NI th:hover {
  background: linear-gradient(135deg, #e67e22, #d68910);
  transform: scale(1.02);
  transition: all 0.2s ease;
}

.capitalExpenditure_quarterHeader__AdZ01 {
  background: linear-gradient(135deg, #f39c12, #e67e22) !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
  border: 2px solid #d68910 !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.capitalExpenditure_subHeader__-3MiM {
  background: linear-gradient(135deg, #e67e22, #d68910);
  color: white;
  font-weight: 600;
  text-align: center;
  border: 1px solid #d68910;
}
.capitalExpenditure_subHeader__-3MiM th {
  padding: 10px 6px;
  border: 1px solid #d68910;
  font-size: 13px;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
}

.capitalExpenditure_codeColumn__PTlVn {
  width: 100px;
  background: #f4d03f;
}

.capitalExpenditure_titleColumn__2PMXm {
  width: 200px;
  background: #f4d03f;
}

.capitalExpenditure_budgetColumn__hpw9z {
  width: 120px;
  background: #f4d03f;
}

.capitalExpenditure_actionColumn__5RhQC {
  width: 100px;
  background: #f4d03f;
}

.capitalExpenditure_categoryRow__2Iz\\+l {
  background: #f4d03f;
  border: 1px solid #000;
}

.capitalExpenditure_categoryCell__mDEXf {
  background: #f4d03f !important;
  color: #000;
  font-weight: bold;
  text-align: left;
  padding: 12px 8px;
  border: 1px solid #000;
  font-size: 16px;
}
.capitalExpenditure_categoryCell__mDEXf.capitalExpenditure_stickyColGroup4__kKzgv {
  background: #f4d03f !important;
}

.capitalExpenditure_dataRow__mbHll {
  background: #f8f9fa;
  transition: background-color 0.2s ease;
  border: 1px solid #000;
}

.capitalExpenditure_dataRow__mbHll:hover {
  background: #e9ecef;
}

.capitalExpenditure_dataRow__mbHll td {
  padding: 8px;
  border: 1px solid #000;
  vertical-align: middle;
}

.capitalExpenditure_codeCell__yTp\\+Z {
  background: #e7f3ff;
  text-align: center;
  min-width: 90px;
  width: 90px;
  white-space: nowrap;
}

.capitalExpenditure_titleCell__J04\\+V {
  background: #f0f8ff;
  min-width: 220px;
  width: 220px;
  word-wrap: break-word;
  white-space: normal;
}

.capitalExpenditure_budgetCell__gzrPV {
  background: #f8f9fa;
  text-align: center;
  min-width: 80px;
  width: auto;
}

.capitalExpenditure_stickyCol1__7\\+EKr.capitalExpenditure_codeCell__yTp\\+Z,
.capitalExpenditure_codeCell__yTp\\+Z.capitalExpenditure_stickyCol1__7\\+EKr {
  background: #e7f3ff !important;
}

.capitalExpenditure_stickyCol2__g5K\\+u.capitalExpenditure_titleCell__J04\\+V,
.capitalExpenditure_titleCell__J04\\+V.capitalExpenditure_stickyCol2__g5K\\+u {
  background: #f0f8ff !important;
}

.capitalExpenditure_stickyCol3__j-q5k.capitalExpenditure_budgetCell__gzrPV,
.capitalExpenditure_budgetCell__gzrPV.capitalExpenditure_stickyCol3__j-q5k,
.capitalExpenditure_stickyCol4__1Oa8l.capitalExpenditure_budgetCell__gzrPV,
.capitalExpenditure_budgetCell__gzrPV.capitalExpenditure_stickyCol4__1Oa8l {
  background: #f8f9fa !important;
}

.capitalExpenditure_actionCell__O56UO {
  background: #fff5f5;
  text-align: center;
}

.capitalExpenditure_inputField__PHrs1 {
  width: 100%;
  padding: 8px 6px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
  min-width: 0;
  resize: horizontal;
}

.capitalExpenditure_inputField__PHrs1:focus {
  outline: none;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 3px rgba(44, 90, 160, 0.1);
}

.capitalExpenditure_inputField__PHrs1::placeholder {
  color: #6c757d;
  font-style: italic;
}

.capitalExpenditure_removeButton__ccmQJ {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.capitalExpenditure_removeButton__ccmQJ:hover:not(:disabled) {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_removeButton__ccmQJ:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_codeCell__yTp\\+Z .capitalExpenditure_inputField__PHrs1 {
  min-width: 80px;
  max-width: 150px;
  text-align: center;
}

.capitalExpenditure_titleCell__J04\\+V .capitalExpenditure_inputField__PHrs1 {
  min-width: 160px;
  max-width: 220px;
  text-align: left;
  resize: none;
}

.capitalExpenditure_budgetCell__gzrPV .capitalExpenditure_inputField__PHrs1 {
  min-width: 60px;
  max-width: 200px;
  text-align: center;
}

.capitalExpenditure_addRowContainer__aX7rA {
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #f8f9fa;
  border-top: 1px solid #dee2e6;
}

.capitalExpenditure_addRowButton__sr6OW {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_addRowButton__sr6OW:hover {
  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_totalRow__FpLdY {
  background: #d4edda;
  font-weight: bold;
  color: #155724;
  position: relative;
  overflow: visible;
}
.capitalExpenditure_totalRow__FpLdY input {
  border: none !important;
  background: transparent !important;
  font-weight: bold;
  text-align: center;
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
}
.capitalExpenditure_totalRow__FpLdY .capitalExpenditure_stickyColGroup2__tYUc\\+,
.capitalExpenditure_totalRow__FpLdY .capitalExpenditure_stickyCol3__j-q5k,
.capitalExpenditure_totalRow__FpLdY .capitalExpenditure_stickyCol4__1Oa8l {
  background: #e8f5e9 !important;
}

.capitalExpenditure_incomeRow__qm0va {
  background: #d6eaf8 !important;
  color: #1a5276 !important;
}
.capitalExpenditure_incomeRow__qm0va .capitalExpenditure_incomeLabel__PDokr {
  background: #2980b9 !important;
  color: #fff !important;
  font-size: 13px;
  letter-spacing: 0.2px;
  width: 310px !important;
  min-width: 310px !important;
  max-width: 310px !important;
  white-space: normal;
}
.capitalExpenditure_incomeRow__qm0va .capitalExpenditure_incomeCell__uy5qy {
  background: #ebf5fb !important;
}
.capitalExpenditure_incomeRow__qm0va .capitalExpenditure_incomeSpacer__T47Xj {
  background: #eaf2f8 !important;
}
.capitalExpenditure_incomeRow__qm0va .capitalExpenditure_stickyColGroup2__tYUc\\+,
.capitalExpenditure_incomeRow__qm0va .capitalExpenditure_stickyCol3__j-q5k,
.capitalExpenditure_incomeRow__qm0va .capitalExpenditure_stickyCol4__1Oa8l {
  background: #d4e6f1 !important;
}
.capitalExpenditure_incomeRow__qm0va input {
  background: #fff !important;
  border: 1px solid #85c1e9 !important;
  border-radius: 2px !important;
  color: #1a5276 !important;
  padding: 4px !important;
}
.capitalExpenditure_incomeRow__qm0va td:hover {
  transform: none !important;
}

.capitalExpenditure_totalRow__FpLdY td {
  padding: 8px;
  border: 1px solid #000;
  background: #e8f5e9;
  text-align: center;
  font-weight: bold;
  color: #155724;
  font-size: 14px;
  vertical-align: middle;
  min-width: 80px;
}

.capitalExpenditure_totalRow__FpLdY td.capitalExpenditure_stickyColGroup2__tYUc\\+,
.capitalExpenditure_totalRow__FpLdY td:first-child {
  background: #c3e6cb;
  color: #155724;
  font-weight: bold;
  text-align: center;
  width: 310px !important;
  min-width: 310px !important;
  max-width: 310px !important;
}

.capitalExpenditure_totalRow__FpLdY td.capitalExpenditure_stickyCol3__j-q5k {
  min-width: 110px !important;
  width: 110px !important;
  max-width: 110px !important;
}

.capitalExpenditure_totalRow__FpLdY td.capitalExpenditure_stickyCol4__1Oa8l {
  min-width: 110px !important;
  width: 110px !important;
  max-width: 110px !important;
}

.capitalExpenditure_totalRow__FpLdY:hover td {
  transform: none;
}

.capitalExpenditure_incomeRow__qm0va td {
  background: #eaf2f8;
  border: 1px solid #000;
}

.capitalExpenditure_incomeRow__qm0va td.capitalExpenditure_incomeCell__uy5qy {
  background: #ebf5fb;
}

.capitalExpenditure_incomeRow__qm0va td.capitalExpenditure_incomeLabel__PDokr {
  background: #2980b9 !important;
  color: #fff !important;
}

.capitalExpenditure_totalInputField__yafB7 {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #34495e;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  background: #ffffff;
  font-weight: 600;
  color: #2c3e50;
  min-height: 36px;
  box-sizing: border-box;
}
.capitalExpenditure_totalInputField__yafB7:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.25);
}
.capitalExpenditure_totalInputField__yafB7:hover {
  border-color: #2980b9;
}
.capitalExpenditure_totalInputField__yafB7::placeholder {
  color: #6c757d;
}

.capitalExpenditure_totalRow__FpLdY:not(:first-of-type) .capitalExpenditure_totalInputField__yafB7 {
  border: none;
  background: transparent;
}
.capitalExpenditure_totalRow__FpLdY:not(:first-of-type) .capitalExpenditure_totalInputField__yafB7:focus {
  border: 1px solid #3498db;
  background: #ffffff;
}
.capitalExpenditure_totalRow__FpLdY:not(:first-of-type) .capitalExpenditure_totalInputField__yafB7:hover {
  background: #f8f9fa;
}

.capitalExpenditure_buttonContainer__Hj6ec {
  display: flex;
  justify-content: center;
  gap: 1rem;
  justify-content: center;
  margin: 2rem 0;
  flex-wrap: wrap;
}

.capitalExpenditure_loadDataButton__mW4Jw {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.capitalExpenditure_loadDataButton__mW4Jw:hover:not(:disabled) {
  background-color: #138496;
}
.capitalExpenditure_loadDataButton__mW4Jw:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.capitalExpenditure_submitButton__9zYjC {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_submitButton__9zYjC:hover:not(:disabled) {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_submitButton__9zYjC:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_resetButton__dvWiu {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_resetButton__dvWiu:hover:not(:disabled) {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_resetButton__dvWiu:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_updateButton__bj4gQ {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_updateButton__bj4gQ:hover:not(:disabled) {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_updateButton__bj4gQ:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_cancelButton__eUZxV {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_cancelButton__eUZxV:hover:not(:disabled) {
  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_cancelButton__eUZxV:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_readOnly__W73Cr {
  background-color: #f8f9fa !important;
  color: #495057 !important;
  cursor: not-allowed !important;
  border: 1px solid #ced4da !important;
}

.capitalExpenditure_readOnly__W73Cr:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ced4da !important;
}

.capitalExpenditure_disabled__x00GS {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
  border: 1px solid #ced4da !important;
  opacity: 0.7;
}

.capitalExpenditure_disabled__x00GS:hover {
  background-color: #f8f9fa !important;
  border-color: #ced4da !important;
  transform: none !important;
}

.capitalExpenditure_viewButton__yWxzg, .capitalExpenditure_editButton__wNa1b, .capitalExpenditure_deleteButton__vqJ8Y {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 2px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.capitalExpenditure_actionButtons__1ELyy {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid #dee2e6;
}

.capitalExpenditure_viewButton__yWxzg {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  font-size: 16px;
  padding: 10px 12px;
}

.capitalExpenditure_viewButton__yWxzg:hover {
  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(23, 162, 184, 0.3);
}

.capitalExpenditure_editButton__wNa1b {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
  color: #212529;
  font-size: 16px;
  padding: 10px 12px;
}

.capitalExpenditure_editButton__wNa1b:hover {
  background: linear-gradient(135deg, #e0a800 0%, #d39e00 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(255, 193, 7, 0.3);
}

.capitalExpenditure_deleteButton__vqJ8Y {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  font-size: 16px;
  padding: 10px 12px;
}

.capitalExpenditure_deleteButton__vqJ8Y:hover {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

.capitalExpenditure_quarterSection__6bUAz {
  margin-bottom: 30px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_quarterSection__6bUAz:not(:last-child) {
  margin-bottom: 40px;
}

.capitalExpenditure_quarterHeader__AdZ01 {
  color: #2c3e50;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}

.capitalExpenditure_financialSummaryCell__VptoP {
  padding: 0 !important;
  border: none !important;
  background: #f8f9fa;
}

.capitalExpenditure_financialSummary__XUHM5 {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}
.capitalExpenditure_financialSummary__XUHM5 th, .capitalExpenditure_financialSummary__XUHM5 td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_summaryHeader__flOVC {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 15px;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_summaryRow__KBajU {
  transition: background-color 0.2s ease;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_summaryRow__KBajU:hover {
  background-color: #f8f9fa;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_summaryRow__KBajU .capitalExpenditure_summaryLabel__Ak8Vb {
  font-weight: 500;
  color: #343a40;
  width: 70%;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_summaryRow__KBajU .capitalExpenditure_summaryValue__9MquJ {
  font-family: "Courier New", monospace;
  font-weight: 600;
  color: #1e3c72;
  text-align: right;
  width: 30%;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_summaryTotalRow__TH3AD {
  background-color: #f1f8ff;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_summaryTotalRow__TH3AD .capitalExpenditure_summaryLabel__Ak8Vb {
  font-weight: 600;
  color: #1e3c72;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_summaryTotalRow__TH3AD .capitalExpenditure_summaryValue__9MquJ {
  font-weight: 700;
  color: #1e3c72;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_highlightRow__Y8iu4 {
  background-color: #e6f7ff;
  border-top: 2px solid #b3e0ff;
  border-bottom: 2px solid #b3e0ff;
}
.capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_highlightRow__Y8iu4 .capitalExpenditure_summaryLabel__Ak8Vb, .capitalExpenditure_financialSummary__XUHM5 .capitalExpenditure_highlightRow__Y8iu4 .capitalExpenditure_summaryValue__9MquJ {
  font-weight: 700;
  color: #0056b3;
}

@media (max-width: 1400px) {
  .capitalExpenditure_capitalExpenditureContainer__QFLet {
    max-width: 100%;
  }
}
@media (max-width: 1200px) {
  .capitalExpenditure_capitalExpenditureContainer__QFLet {
    padding: 15px;
  }
  .capitalExpenditure_header__01PDc {
    padding: 15px;
  }
  .capitalExpenditure_universityTitle__UMlaw {
    font-size: 24px;
  }
  .capitalExpenditure_navButton__ssAwr {
    width: 200px !important;
    min-width: 200px !important;
    max-width: 200px !important;
    flex: 0 0 200px !important;
    font-size: 13px;
    padding: 10px 15px;
  }
  .capitalExpenditure_tableContainer__esNEd {
    padding: 15px;
  }
  .capitalExpenditure_mainHeader__6k\\+NI th,
  .capitalExpenditure_subHeader__-3MiM th {
    font-size: 12px;
    padding: 8px 4px;
  }
  .capitalExpenditure_inputField__PHrs1 {
    font-size: 12px;
    padding: 6px 4px;
  }
  .capitalExpenditure_removeButton__ccmQJ {
    font-size: 10px;
    padding: 4px 8px;
  }
}
@media (max-width: 768px) {
  .capitalExpenditure_capitalExpenditureContainer__QFLet {
    padding: 10px;
    margin: 0 auto;
  }
  .capitalExpenditure_header__01PDc {
    padding: 10px 5px;
    margin-bottom: 20px;
  }
  .capitalExpenditure_universityTitle__UMlaw {
    font-size: 20px;
    margin-bottom: 15px;
  }
  .capitalExpenditure_navButtons__zEVZ8 {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
  .capitalExpenditure_navButton__ssAwr {
    width: 100% !important;
    max-width: 300px !important;
    min-width: unset !important;
    flex: 0 0 auto !important;
    font-size: 12px;
    padding: 10px 15px;
  }
  .capitalExpenditure_officeDropdown__3vzAz {
    font-size: 16px;
    padding: 10px 15px;
  }
  .capitalExpenditure_selectedOffice__Qahw4 {
    font-size: 14px;
  }
  .capitalExpenditure_officeDropdownMenu__6yp0r {
    max-height: 300px;
  }
  .capitalExpenditure_officeOption__SMLoi {
    padding: 10px 15px;
    font-size: 13px;
  }
  .capitalExpenditure_fiscalYear__uykQQ {
    font-size: 14px;
  }
  .capitalExpenditure_categoryCell__mDEXf {
    font-size: 14px;
  }
  .capitalExpenditure_tableContainer__esNEd {
    padding: 10px;
    overflow-x: auto;
  }
  .capitalExpenditure_expenditureTable__l2sPf {
    min-width: 800px;
  }
  .capitalExpenditure_buttonContainer__Hj6ec {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  .capitalExpenditure_submitButton__9zYjC,
  .capitalExpenditure_resetButton__dvWiu,
  .capitalExpenditure_backButton__HkkB5,
  .capitalExpenditure_updateButton__bj4gQ,
  .capitalExpenditure_cancelButton__eUZxV,
  .capitalExpenditure_excelButton__n202q,
  .capitalExpenditure_printButton__8Rlxw,
  .capitalExpenditure_applyFilterButton__b6Awq,
  .capitalExpenditure_clearFilterButton__Mnlxg {
    width: 100%;
    max-width: 300px;
  }
  .capitalExpenditure_addRowButton__sr6OW {
    font-size: 14px;
    padding: 10px 20px;
  }
  .capitalExpenditure_clearPromptContent__60TwZ {
    padding: 20px;
    margin: 20px;
  }
  .capitalExpenditure_clearPromptButtons__PNbmF {
    flex-direction: column;
    gap: 10px;
  }
  .capitalExpenditure_clearButton__vQ\\+AP,
  .capitalExpenditure_keepButton__Y55VI {
    width: 100%;
  }
  .capitalExpenditure_dataViewContainer__QQhqR {
    padding: 15px;
  }
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK {
    min-width: 600px;
  }
  .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th {
    min-width: 100px;
  }
  .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(1) {
    min-width: 120px;
  }
  .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(2) {
    min-width: 110px;
  }
  .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(3) {
    min-width: 100px;
  }
  .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(4) {
    min-width: 100px;
  }
  .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(5) {
    min-width: 90px;
  }
  .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(6) {
    min-width: 150px;
  }
}
@media (max-width: 480px) {
  .capitalExpenditure_capitalExpenditureContainer__QFLet {
    padding: 5px;
  }
  .capitalExpenditure_header__01PDc {
    padding: 10px 5px;
  }
  .capitalExpenditure_universityTitle__UMlaw {
    font-size: 18px;
  }
  .capitalExpenditure_navButton__ssAwr {
    font-size: 11px;
    padding: 8px 12px;
  }
  .capitalExpenditure_officeDropdown__3vzAz {
    font-size: 14px;
    padding: 8px 12px;
  }
  .capitalExpenditure_fiscalYear__uykQQ {
    font-size: 12px;
  }
  .capitalExpenditure_tableContainer__esNEd {
    padding: 5px;
  }
  .capitalExpenditure_mainHeader__6k\\+NI th,
  .capitalExpenditure_subHeader__-3MiM th {
    font-size: 10px;
    padding: 6px 2px;
  }
  .capitalExpenditure_inputField__PHrs1 {
    font-size: 10px;
    padding: 4px 2px;
  }
  .capitalExpenditure_categoryCell__mDEXf {
    font-size: 12px;
  }
}
@media print {
  .capitalExpenditure_capitalExpenditureContainer__QFLet {
    background: white;
    box-shadow: none;
  }
  .capitalExpenditure_buttonContainer__Hj6ec,
  .capitalExpenditure_addRowContainer__aX7rA {
    display: none;
  }
  .capitalExpenditure_expenditureTable__l2sPf {
    box-shadow: none;
    border: 2px solid #000;
  }
  .capitalExpenditure_mainHeader__6k\\+NI,
  .capitalExpenditure_subHeader__-3MiM,
  .capitalExpenditure_categoryRow__2Iz\\+l {
    background: #f4d03f !important;
    color: #000 !important;
  }
  .capitalExpenditure_actionCell__O56UO {
    display: none;
  }
  .capitalExpenditure_clearPrompt__Jm3-g {
    display: none;
  }
  .capitalExpenditure_tokenDisplay__TjKzL {
    display: none;
  }
}
.capitalExpenditure_tokenDisplay__TjKzL {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: capitalExpenditure_fadeIn__pqSNr 0.5s ease-in-out;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc {
  color: white;
  text-align: center;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc h4 {
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenDetails__U4olv {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenDetails__U4olv span {
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 14px;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenDetails__U4olv span strong {
  color: #ffd700;
  margin-right: 5px;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenNote__pBNS6 {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
  font-style: italic;
}

@media (max-width: 768px) {
  .capitalExpenditure_tokenDisplay__TjKzL {
    margin: 15px 0;
    padding: 15px;
  }
  .capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc h4 {
    font-size: 16px;
  }
  .capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenDetails__U4olv {
    flex-direction: column;
    gap: 10px;
  }
  .capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenDetails__U4olv span {
    font-size: 13px;
    padding: 6px 12px;
  }
  .capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenNote__pBNS6 {
    font-size: 13px;
  }
}
.capitalExpenditure_dataViewContainer__QQhqR {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}
.capitalExpenditure_dataViewContainer__QQhqR h3 {
  color: #1e3c72;
  font-size: 24px;
  margin-bottom: 25px;
  text-align: center;
  border-bottom: 3px solid #1e3c72;
  padding-bottom: 10px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p {
  margin-bottom: 30px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filterToggleButton__qA9TK {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filterToggleButton__qA9TK:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(30, 60, 114, 0.3);
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterRow__VMr9G {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterRow__VMr9G .capitalExpenditure_filterGroup__EGvAK {
  flex: 1 1;
  min-width: 200px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterRow__VMr9G .capitalExpenditure_filterGroup__EGvAK label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #495057;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterRow__VMr9G .capitalExpenditure_filterGroup__EGvAK input, .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterRow__VMr9G .capitalExpenditure_filterGroup__EGvAK select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterRow__VMr9G .capitalExpenditure_filterGroup__EGvAK input:focus, .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterRow__VMr9G .capitalExpenditure_filterGroup__EGvAK select:focus {
  outline: none;
  border-color: #1e3c72;
  box-shadow: 0 0 0 2px rgba(30, 60, 114, 0.2);
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterActions__5v2Wq {
  display: flex;
  gap: 15px;
  justify-content: center;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterActions__5v2Wq button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterActions__5v2Wq button.capitalExpenditure_applyFiltersButton__-0\\+43 {
  background: #28a745;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterActions__5v2Wq button.capitalExpenditure_applyFiltersButton__-0\\+43:hover {
  background: #218838;
  transform: translateY(-1px);
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterActions__5v2Wq button.capitalExpenditure_clearFiltersButton__wwT6p {
  background: #6c757d;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_filtersSection__0pO7p .capitalExpenditure_filtersContainer__qZypt .capitalExpenditure_filterActions__5v2Wq button.capitalExpenditure_clearFiltersButton__wwT6p:hover {
  background: #5a6268;
  transform: translateY(-1px);
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb {
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb::after {
  content: "← → स्क्रोल गर्नुहोस्";
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
  z-index: 5;
  pointer-events: none;
  opacity: 0.8;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb::-webkit-scrollbar {
  height: 8px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_loading__\\+AuQJ {
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #6c757d;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 800px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  min-width: 120px;
  position: relative;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(1) {
  min-width: 150px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(2) {
  min-width: 140px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(3) {
  min-width: 130px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(4) {
  min-width: 130px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(5) {
  min-width: 120px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:nth-child(6) {
  min-width: 200px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK th:hover {
  background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);
  transform: scale(1.02);
  transition: all 0.2s ease;
  z-index: 10;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK td {
  padding: 12px;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
  color: #495057;
  white-space: nowrap;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll {
  transition: background-color 0.2s ease;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll:hover {
  background-color: #f8f9fa;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_statusBadge__2QpRH {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_statusBadge__2QpRH.capitalExpenditure_draft__mCoKY {
  background: #ffc107;
  color: #212529;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_statusBadge__2QpRH.capitalExpenditure_submitted__C6bXG {
  background: #17a2b8;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_statusBadge__2QpRH.capitalExpenditure_approved__9A176 {
  background: #28a745;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_statusBadge__2QpRH.capitalExpenditure_rejected__QYLZ4 {
  background: #dc3545;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_statusBadge__2QpRH.capitalExpenditure_completed__xtdo3 {
  background: #6f42c1;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_viewButton__yWxzg {
  background: #17a2b8;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_viewButton__yWxzg:hover {
  background: #138496;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_editButton__wNa1b {
  background: #ffc107;
  color: #212529;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_editButton__wNa1b:hover {
  background: #e0a800;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_exportButton__hMg65 {
  background: #28a745;
  color: white;
  font-size: 16px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_exportButton__hMg65:hover {
  background: #218838;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_printButton__8Rlxw {
  background: #6c757d;
  color: white;
  font-size: 16px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_printButton__8Rlxw:hover {
  background: #5a6268;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_deleteButton__vqJ8Y {
  background: #dc3545;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataTableContainer__9Rybb .capitalExpenditure_dataTable__gzdMK .capitalExpenditure_dataRow__mbHll .capitalExpenditure_actionButtons__1ELyy button.capitalExpenditure_deleteButton__vqJ8Y:hover {
  background: #c82333;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_noDataMessage__v2TFg {
  text-align: center;
  padding: 40px;
  color: #6c757d;
  font-size: 16px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_noDataMessage__v2TFg p {
  margin: 0;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_editModal__pTj\\+C {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_editModalContent__GVsso {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_editModalContent__GVsso h3 {
  margin: 0 0 20px 0;
  color: #333;
  text-align: center;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_editForm__RozmY {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_formGroup__bdAAB {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_formGroup__bdAAB label {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_formGroup__bdAAB input, .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_formGroup__bdAAB select {
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_formGroup__bdAAB input:focus, .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_formGroup__bdAAB select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_editActions__1Kn6Z {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 10px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_saveButton__4ekdK, .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_cancelButton__eUZxV {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_saveButton__4ekdK {
  background: #28a745;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_saveButton__4ekdK:hover {
  background: #218838;
  transform: translateY(-1px);
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_cancelButton__eUZxV {
  background: #6c757d;
  color: white;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_cancelButton__eUZxV:hover {
  background: #5a6268;
  transform: translateY(-1px);
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataViewActions__kqN2U {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 .capitalExpenditure_dataItem__eXR\\+m {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid #dee2e6;
  border-radius: 10px;
  padding: 20px;
  transition: all 0.3s ease;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 .capitalExpenditure_dataItem__eXR\\+m:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #1e3c72;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 .capitalExpenditure_dataItem__eXR\\+m h4 {
  color: #1e3c72;
  font-size: 18px;
  margin: 0 0 15px 0;
  font-weight: 600;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 .capitalExpenditure_dataItem__eXR\\+m p {
  margin: 8px 0;
  color: #495057;
  font-size: 14px;
}
.capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 .capitalExpenditure_dataItem__eXR\\+m p:first-of-type {
  font-weight: 600;
  color: #28a745;
}
.capitalExpenditure_dataViewContainer__QQhqR p {
  text-align: center;
  color: #6c757d;
  font-size: 16px;
  font-style: italic;
}

@media (max-width: 768px) {
  .capitalExpenditure_dataViewContainer__QQhqR {
    padding: 20px;
    margin: 15px 0;
  }
  .capitalExpenditure_dataViewContainer__QQhqR h3 {
    font-size: 20px;
  }
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 .capitalExpenditure_dataItem__eXR\\+m {
    padding: 15px;
  }
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 .capitalExpenditure_dataItem__eXR\\+m h4 {
    font-size: 16px;
  }
  .capitalExpenditure_dataViewContainer__QQhqR .capitalExpenditure_dataList__9j3y0 .capitalExpenditure_dataItem__eXR\\+m p {
    font-size: 13px;
  }
}
.capitalExpenditure_excelButton__n202q {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_excelButton__n202q:hover:not(:disabled) {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_excelButton__n202q:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_summaryButton__dLMfW {
  background: linear-gradient(135deg, #6f42c1 0%, #8e44ad 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_summaryButton__dLMfW:hover:not(:disabled) {
  background: linear-gradient(135deg, #5a32a3 0%, #7d3c98 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_summaryButton__dLMfW:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_detailedReportButton__uyKq1 {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_detailedReportButton__uyKq1:hover:not(:disabled) {
  background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_detailedReportButton__uyKq1:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_bulkDeleteButton__RIjk2 {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  margin-left: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.capitalExpenditure_bulkDeleteButton__RIjk2:hover:not(:disabled) {
  background: linear-gradient(135deg, #ff5252 0%, #d63031 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
}
.capitalExpenditure_bulkDeleteButton__RIjk2:active {
  transform: translateY(0);
}
.capitalExpenditure_bulkDeleteButton__RIjk2:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.6;
}

.capitalExpenditure_infoButton__Ta6-x {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_infoButton__Ta6-x:hover:not(:disabled) {
  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_infoButton__Ta6-x:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_printButton__8Rlxw {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.capitalExpenditure_printButton__8Rlxw:hover:not(:disabled) {
  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_printButton__8Rlxw:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.capitalExpenditure_dataTable__gzdMK th:first-child,
.capitalExpenditure_dataTable__gzdMK td:first-child {
  text-align: center;
  width: 50px;
}
.capitalExpenditure_dataTable__gzdMK th:first-child input[type=checkbox],
.capitalExpenditure_dataTable__gzdMK td:first-child input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #007bff;
}
.capitalExpenditure_dataTable__gzdMK th:first-child input[type=checkbox]:hover,
.capitalExpenditure_dataTable__gzdMK td:first-child input[type=checkbox]:hover {
  transform: scale(1.1);
}

.capitalExpenditure_masterItemsHeader__xseE1 .capitalExpenditure_headerCheckbox__VqEbV,
.capitalExpenditure_masterItem__DGs9h .capitalExpenditure_itemCheckbox__kaQ6D {
  text-align: center;
  width: 50px;
  flex-shrink: 0;
}
.capitalExpenditure_masterItemsHeader__xseE1 .capitalExpenditure_headerCheckbox__VqEbV input[type=checkbox],
.capitalExpenditure_masterItem__DGs9h .capitalExpenditure_itemCheckbox__kaQ6D input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #007bff;
}
.capitalExpenditure_masterItemsHeader__xseE1 .capitalExpenditure_headerCheckbox__VqEbV input[type=checkbox]:hover,
.capitalExpenditure_masterItem__DGs9h .capitalExpenditure_itemCheckbox__kaQ6D input[type=checkbox]:hover {
  transform: scale(1.1);
}

.capitalExpenditure_filterContainer__2BmI3 {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #dee2e6;
}

.capitalExpenditure_filterHeader__P3GKC {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.capitalExpenditure_filterHeader__P3GKC h4 {
  color: #1e3c72;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.capitalExpenditure_filterToggle__SFJkF {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.capitalExpenditure_filterToggle__SFJkF:hover {
  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_filterForm__gkm5y {
  border-top: 1px solid #dee2e6;
  padding-top: 15px;
}

.capitalExpenditure_filterRow__VMr9G {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.capitalExpenditure_filterGroup__EGvAK {
  flex: 1 1;
  min-width: 200px;
}
.capitalExpenditure_filterGroup__EGvAK label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #495057;
  font-size: 14px;
}

.capitalExpenditure_filterInput__crZqj,
.capitalExpenditure_filterSelect__TBPQZ {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.capitalExpenditure_filterInput__crZqj:focus,
.capitalExpenditure_filterSelect__TBPQZ:focus {
  outline: none;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 3px rgba(44, 90, 160, 0.1);
}

.capitalExpenditure_filterInput__crZqj::placeholder {
  color: #6c757d;
  font-style: italic;
}

.capitalExpenditure_filterActions__5v2Wq {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-start;
}

.capitalExpenditure_filterToggleButton__qA9TK {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.capitalExpenditure_filterToggleButton__qA9TK:hover:not(:disabled) {
  background-color: #5a6268;
}
.capitalExpenditure_filterToggleButton__qA9TK:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.capitalExpenditure_refreshButton__5DgQo {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.capitalExpenditure_refreshButton__5DgQo:hover:not(:disabled) {
  background-color: #138496;
}
.capitalExpenditure_refreshButton__5DgQo:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.capitalExpenditure_applyFilterButton__b6Awq {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.capitalExpenditure_applyFilterButton__b6Awq:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_clearFilterButton__Mnlxg {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.capitalExpenditure_clearFilterButton__Mnlxg:hover {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.capitalExpenditure_filterInfo__VcNEK {
  background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%);
  border: 1px solid #17a2b8;
  border-radius: 6px;
  padding: 15px;
  margin-top: 20px;
  text-align: center;
}
.capitalExpenditure_filterInfo__VcNEK p {
  color: #0c5460;
  font-weight: bold;
  margin: 0;
  font-size: 16px;
}

@media (max-width: 768px) {
  .capitalExpenditure_filterContainer__2BmI3 {
    padding: 15px;
  }
  .capitalExpenditure_filterRow__VMr9G {
    flex-direction: column;
    gap: 15px;
  }
  .capitalExpenditure_filterGroup__EGvAK {
    min-width: unset;
  }
  .capitalExpenditure_filterActions__5v2Wq {
    flex-direction: column;
    gap: 10px;
  }
  .capitalExpenditure_filterToggle__SFJkF {
    font-size: 12px;
    padding: 6px 12px;
  }
}
.capitalExpenditure_quarterSelector__zBZhQ {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.capitalExpenditure_quarterButton__TktiH {
  padding: 0.75rem 1.5rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  color: #495057;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_quarterButton__TktiH:hover {
  border-color: #667eea;
  color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.2);
}
.capitalExpenditure_quarterButton__TktiH.capitalExpenditure_active__o\\+vnK {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.capitalExpenditure_actionButtons__1ELyy {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  flex-wrap: wrap;
}

.capitalExpenditure_addRowButton__sr6OW {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_addRowButton__sr6OW:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.capitalExpenditure_submitButton__9zYjC {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_submitButton__9zYjC:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}
.capitalExpenditure_submitButton__9zYjC:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.capitalExpenditure_resetButton__dvWiu {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_resetButton__dvWiu:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}
.capitalExpenditure_resetButton__dvWiu:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.capitalExpenditure_noData__gcRDg {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataContent__ND5yB {
  max-width: 600px;
  margin: 0 auto;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataContent__ND5yB h3 {
  color: #495057;
  margin-bottom: 20px;
  font-size: 24px;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataContent__ND5yB p {
  margin: 15px 0;
  font-size: 16px;
  line-height: 1.6;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataActions__idzss {
  margin-top: 30px;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataActions__idzss .capitalExpenditure_primaryButton__oF\\+wW {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
  margin-bottom: 25px;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataActions__idzss .capitalExpenditure_primaryButton__oF\\+wW:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataActions__idzss .capitalExpenditure_primaryButton__oF\\+wW:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataActions__idzss .capitalExpenditure_noDataInstructions__MfKZ9 {
  text-align: left;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataActions__idzss .capitalExpenditure_noDataInstructions__MfKZ9 h4 {
  color: #495057;
  margin-bottom: 15px;
  font-size: 18px;
  text-align: center;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataActions__idzss .capitalExpenditure_noDataInstructions__MfKZ9 ol {
  margin: 0;
  padding-left: 20px;
}
.capitalExpenditure_noData__gcRDg .capitalExpenditure_noDataActions__idzss .capitalExpenditure_noDataInstructions__MfKZ9 ol li {
  margin: 8px 0;
  line-height: 1.5;
  color: #6c757d;
}

.capitalExpenditure_editForm__RozmY {
  margin-bottom: 1.5rem;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_formRow__QCC9C {
  display: flex;
  margin-bottom: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e9ecef;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_formRow__QCC9C label {
  flex: 0 0 150px;
  font-weight: 600;
  color: #495057;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_formRow__QCC9C span {
  flex: 1 1;
  color: #212529;
  padding-left: 1rem;
}

.capitalExpenditure_fiscalYearContainer__kmp\\+V {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
}
.capitalExpenditure_fiscalYearContainer__kmp\\+V .capitalExpenditure_fiscalYearLabel__JCLOi {
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}
.capitalExpenditure_fiscalYearContainer__kmp\\+V .capitalExpenditure_fiscalYearSelect__rJNCC {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  background-color: white;
  min-width: 200px;
}
.capitalExpenditure_fiscalYearContainer__kmp\\+V .capitalExpenditure_fiscalYearSelect__rJNCC:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.capitalExpenditure_fiscalYearContainer__kmp\\+V .capitalExpenditure_fiscalYearSelect__rJNCC.capitalExpenditure_disabled__x00GS {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
  border-color: #dee2e6;
}
.capitalExpenditure_fiscalYearContainer__kmp\\+V .capitalExpenditure_fiscalYearLocked__4KDA8 {
  min-width: 200px;
  padding: 0.55rem 0.9rem;
  border: 1px solid #c5d4eb;
  border-radius: 4px;
  background: #eef4fb;
  color: #1e3c72;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
}

.capitalExpenditure_toggleViewButton__8yyu6 {
  padding: 0.75rem 1.5rem;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 1rem;
}
.capitalExpenditure_toggleViewButton__8yyu6:hover {
  background-color: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}
.capitalExpenditure_toggleViewButton__8yyu6:active {
  transform: translateY(0);
}

.capitalExpenditure_viewModeInfo__gD6S2 {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 6px;
}
.capitalExpenditure_viewModeInfo__gD6S2 .capitalExpenditure_viewModeText__1gqfy {
  font-weight: 600;
  color: #1976d2;
  font-size: 1rem;
}

/* Popup Message Styles */
.capitalExpenditure_popupMessage__5f4NT {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  animation: capitalExpenditure_slideInRight__Cu4Ap 0.3s ease-out;
}

.capitalExpenditure_popupContent__Lwvjf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 400px;
  position: relative;
}

.capitalExpenditure_popupContent__Lwvjf.capitalExpenditure_success__Z4Ssi {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.capitalExpenditure_popupContent__Lwvjf.capitalExpenditure_error__hJFf\\+ {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.capitalExpenditure_popupContent__Lwvjf.capitalExpenditure_warning__6rr3K {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  color: #856404;
}

.capitalExpenditure_popupContent__Lwvjf.capitalExpenditure_info__HTu4G {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  color: #0c5460;
}

.capitalExpenditure_popupText__HGqtn {
  font-size: 14px;
  font-weight: 500;
  flex: 1 1;
  margin-right: 12px;
}

.capitalExpenditure_popupClose__LHhoy {
  background: none;
  border: none;
  font-size: 20px;
  font-weight: bold;
  color: inherit;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.capitalExpenditure_popupClose__LHhoy:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

@keyframes capitalExpenditure_slideInRight__Cu4Ap {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes capitalExpenditure_slideOutRight__m9zmb {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}
.capitalExpenditure_popupMessage__5f4NT.capitalExpenditure_hiding__PBbi7 {
  animation: capitalExpenditure_slideOutRight__m9zmb 0.3s ease-in;
}

.capitalExpenditure_newDataButton__z0rMQ {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-right: 12px;
}
.capitalExpenditure_newDataButton__z0rMQ:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_newDataButton__z0rMQ:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}
.capitalExpenditure_newDataButton__z0rMQ:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.capitalExpenditure_editFormContainer__Iw4Mf {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  overflow-y: auto;
  animation: capitalExpenditure_fadeIn__pqSNr 0.3s ease-out;
}

@keyframes capitalExpenditure_fadeIn__pqSNr {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.capitalExpenditure_editFormContent__27jWB {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 100%;
  max-height: 95vh;
  overflow-y: auto;
  position: relative;
  animation: capitalExpenditure_slideIn__63\\+TM 0.3s ease-out;
}

@keyframes capitalExpenditure_slideIn__63\\+TM {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.capitalExpenditure_editFormHeader__yl4B\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  position: relative;
}
.capitalExpenditure_editFormHeader__yl4B\\+ h2 {
  margin: 0;
  color: white;
  font-size: 28px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.capitalExpenditure_editFormActions__tVqTn {
  display: flex;
  gap: 15px;
  margin-right: 60px; /* Add space for the close button */
}

.capitalExpenditure_headerContent__FxBbx {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 10px;
}

.capitalExpenditure_currentYearFormNote__iUCeK {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #d6eaf8;
}

.capitalExpenditure_editFormYearSwitch__TeSOt {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
}
.capitalExpenditure_editFormYearSwitch__TeSOt label {
  font-size: 13px;
  font-weight: 600;
  color: #e8f1fb;
  white-space: nowrap;
}
.capitalExpenditure_editFormYearSwitch__TeSOt select {
  min-width: 180px;
  padding: 6px 10px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  color: #1e3c72;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.capitalExpenditure_editFormYearSwitch__TeSOt select:disabled {
  opacity: 0.7;
  cursor: wait;
}

.capitalExpenditure_yearSwitchLoading__HtN\\+y {
  font-size: 12px;
  color: #f8e9a1;
}

.capitalExpenditure_successMessage__FGVbD {
  background: rgba(40, 167, 69, 0.9);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  animation: capitalExpenditure_slideDown__b2SfC 0.3s ease-out;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

@keyframes capitalExpenditure_slideDown__b2SfC {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.capitalExpenditure_closeButton__iTG3W {
  position: absolute;
  top: 15px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.capitalExpenditure_closeButton__iTG3W:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.capitalExpenditure_cancelButton__eUZxV {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.capitalExpenditure_cancelButton__eUZxV:hover:not(:disabled) {
  background-color: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_cancelButton__eUZxV:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.capitalExpenditure_saveButton__4ekdK {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.capitalExpenditure_saveButton__4ekdK:hover:not(:disabled) {
  background-color: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_saveButton__4ekdK:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.capitalExpenditure_downloadExcelButton__m3YdO {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}
.capitalExpenditure_downloadExcelButton__m3YdO:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_downloadExcelButton__m3YdO:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.capitalExpenditure_editForm__RozmY .capitalExpenditure_section__gi5Ix {
  margin-bottom: 40px;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_section__gi5Ix h3 {
  color: #2c3e50;
  font-size: 20px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_tableContainer__esNEd {
  overflow-x: auto;
  margin-bottom: 20px;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf th, .capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf td {
  padding: 12px 8px;
  text-align: left;
  border: 1px solid #dee2e6;
  font-size: 14px;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf td {
  vertical-align: middle;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_inputField__PHrs1 {
  width: 100%;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_inputField__PHrs1:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_remainingBalance__tWQCl {
  background-color: #f8f9fa;
  font-weight: 500;
  color: #495057;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_removeButton__ccmQJ {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_expenditureTable__l2sPf .capitalExpenditure_removeButton__ccmQJ:hover {
  background-color: #c82333;
  transform: translateY(-1px);
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_addRowButton__sr6OW {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}
.capitalExpenditure_editForm__RozmY .capitalExpenditure_addRowButton__sr6OW:hover {
  background-color: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.capitalExpenditure_itemActions__33Pw1 {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.capitalExpenditure_editButton__wNa1b, .capitalExpenditure_deleteButton__vqJ8Y {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
}
.capitalExpenditure_editButton__wNa1b:hover, .capitalExpenditure_deleteButton__vqJ8Y:hover {
  transform: scale(1.1);
}

.capitalExpenditure_editButton__wNa1b {
  color: #007bff;
}
.capitalExpenditure_editButton__wNa1b:hover {
  background: #e3f2fd;
}

.capitalExpenditure_deleteButton__vqJ8Y {
  color: #dc3545;
}
.capitalExpenditure_deleteButton__vqJ8Y:hover {
  background: #ffebee;
}

.capitalExpenditure_searchSection__Z7SiD {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
}

.capitalExpenditure_searchInputContainer__CJgWx {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 10px;
}

.capitalExpenditure_searchInput__DzXz9 {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.capitalExpenditure_searchInput__DzXz9:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}
.capitalExpenditure_searchInput__DzXz9::placeholder {
  color: #6c757d;
}

.capitalExpenditure_searchButton__WoCr8 {
  padding: 12px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_searchButton__WoCr8:hover {
  background: #0056b3;
  transform: translateY(-1px);
}
.capitalExpenditure_searchButton__WoCr8:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
}

.capitalExpenditure_clearSearchButton__VncP0 {
  padding: 12px 20px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_clearSearchButton__VncP0:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.capitalExpenditure_searchHint__jlh49 {
  color: #6c757d;
  font-size: 12px;
  text-align: center;
}

.capitalExpenditure_searchResults__fNl\\+S {
  margin-top: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_searchResults__fNl\\+S h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  text-align: center;
}

.capitalExpenditure_resultsList__3WlGO {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.capitalExpenditure_resultItem__yaxC7 {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}
.capitalExpenditure_resultItem__yaxC7:hover {
  background: #e9ecef;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.capitalExpenditure_resultCode__NlC9D {
  background: #007bff;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  min-width: 80px;
  text-align: center;
}

.capitalExpenditure_resultTitle__dG0H3 {
  flex: 1 1;
  font-weight: 500;
  color: #333;
}

.capitalExpenditure_resultType__BEOFw {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.capitalExpenditure_resultType__BEOFw.capitalExpenditure_capital__LJS4p {
  background: #28a745;
  color: white;
}
.capitalExpenditure_resultType__BEOFw.capitalExpenditure_operational__d\\+FP4 {
  background: #ffc107;
  color: #212529;
}

.capitalExpenditure_populateButton__FCJiT {
  padding: 8px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_populateButton__FCJiT:hover {
  background: #218838;
  transform: translateY(-1px);
}

.capitalExpenditure_summaryReportSection__7Lkhw {
  background: white;
  border-radius: 12px;
  padding: 25px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_summaryHeader__flOVC {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f8f9fa;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_summaryHeader__flOVC h3 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 24px;
  font-weight: bold;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_summaryHeader__flOVC p {
  margin: 0;
  color: #6c757d;
  font-size: 16px;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_summaryStats__M61k0 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_summaryStats__M61k0 .capitalExpenditure_statCard__lxp19 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 25px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_summaryStats__M61k0 .capitalExpenditure_statCard__lxp19:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_summaryStats__M61k0 .capitalExpenditure_statCard__lxp19 .capitalExpenditure_statTitle__ls5SV {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_summaryStats__M61k0 .capitalExpenditure_statCard__lxp19 .capitalExpenditure_statValue__9tV-F {
  font-size: 28px;
  font-weight: bold;
  margin: 0;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 {
  margin-bottom: 30px;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 h4 {
  color: #2c3e50;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_statusBreakdown__H-Qcc {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_statusBreakdown__H-Qcc .capitalExpenditure_statusItem__AImrh {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_statusBreakdown__H-Qcc .capitalExpenditure_statusItem__AImrh:hover {
  background: #e9ecef;
  transform: translateY(-2px);
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_statusBreakdown__H-Qcc .capitalExpenditure_statusItem__AImrh .capitalExpenditure_statusName__UOqQO {
  font-weight: 600;
  color: #495057;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_statusBreakdown__H-Qcc .capitalExpenditure_statusItem__AImrh .capitalExpenditure_statusCount__JPDWv {
  background: #007bff;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 14px;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_statusBreakdown__H-Qcc .capitalExpenditure_statusItem__AImrh .capitalExpenditure_statusPercentage__KgxdC {
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.2s ease;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP .capitalExpenditure_institutionHeader__uxHGq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP .capitalExpenditure_institutionHeader__uxHGq .capitalExpenditure_institutionName__VvFNC {
  font-weight: bold;
  color: #2c3e50;
  font-size: 16px;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP .capitalExpenditure_institutionHeader__uxHGq .capitalExpenditure_institutionCount__jYheF {
  background: #28a745;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP .capitalExpenditure_institutionDetails__5sW2J .capitalExpenditure_detailRow__Di7wB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 0;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP .capitalExpenditure_institutionDetails__5sW2J .capitalExpenditure_detailRow__Di7wB:last-child {
  margin-bottom: 0;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP .capitalExpenditure_institutionDetails__5sW2J .capitalExpenditure_detailRow__Di7wB span:first-child {
  color: #6c757d;
  font-weight: 500;
}
.capitalExpenditure_summaryReportSection__7Lkhw .capitalExpenditure_breakdownSection__nDAu0 .capitalExpenditure_institutionBreakdown__3F0FM .capitalExpenditure_institutionItem__8FDZP .capitalExpenditure_institutionDetails__5sW2J .capitalExpenditure_detailRow__Di7wB span:last-child {
  color: #2c3e50;
  font-weight: 600;
}

.capitalExpenditure_detailedReportSection__JC3qt {
  background: white;
  border-radius: 12px;
  padding: 25px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedHeader__0IoSx {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f8f9fa;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedHeader__0IoSx h3 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 24px;
  font-weight: bold;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedHeader__0IoSx p {
  margin: 0;
  color: #6c757d;
  font-size: 16px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedStats__L0hWY {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedStats__L0hWY .capitalExpenditure_statCard__lxp19 {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  padding: 25px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedStats__L0hWY .capitalExpenditure_statCard__lxp19:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedStats__L0hWY .capitalExpenditure_statCard__lxp19 .capitalExpenditure_statTitle__ls5SV {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedStats__L0hWY .capitalExpenditure_statCard__lxp19 .capitalExpenditure_statValue__9tV-F {
  font-size: 28px;
  font-weight: bold;
  margin: 0;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z {
  margin-bottom: 30px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z h4 {
  color: #2c3e50;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_tableWrapper__bU\\+bA {
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_tableWrapper__bU\\+bA::-webkit-scrollbar {
  height: 8px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_tableWrapper__bU\\+bA::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_tableWrapper__bU\\+bA::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_tableWrapper__bU\\+bA::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  min-width: 1200px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  min-width: 120px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(1) {
  min-width: 150px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(2) {
  min-width: 140px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(3) {
  min-width: 120px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(4) {
  min-width: 120px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(5) {
  min-width: 130px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(6) {
  min-width: 130px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(7) {
  min-width: 130px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(8) {
  min-width: 130px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(9) {
  min-width: 130px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:nth-child(10) {
  min-width: 200px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 th:hover {
  background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);
  transform: scale(1.02);
  transition: all 0.2s ease;
  z-index: 10;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 td {
  padding: 12px;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
  color: #495057;
  white-space: nowrap;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem {
  transition: background-color 0.2s ease;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem:hover {
  background-color: #f8f9fa;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem .capitalExpenditure_detailedActions__lMz5C {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem .capitalExpenditure_detailedActions__lMz5C button {
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem .capitalExpenditure_detailedActions__lMz5C button:hover {
  transform: translateY(-1px);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem .capitalExpenditure_detailedActions__lMz5C button.capitalExpenditure_viewButton__yWxzg {
  background: #17a2b8;
  color: white;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem .capitalExpenditure_detailedActions__lMz5C button.capitalExpenditure_editButton__wNa1b {
  background: #ffc107;
  color: #212529;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem .capitalExpenditure_detailedActions__lMz5C button.capitalExpenditure_exportButton__hMg65 {
  background: #28a745;
  color: white;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem .capitalExpenditure_detailedActions__lMz5C button.capitalExpenditure_printButton__8Rlxw {
  background: #6c757d;
  color: white;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_detailedTableContainer__0vl4z .capitalExpenditure_detailedTable__HZuj5 .capitalExpenditure_detailedRow__OSXem .capitalExpenditure_detailedActions__lMz5C button.capitalExpenditure_deleteButton__vqJ8Y {
  background: #dc3545;
  color: white;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd {
  margin-bottom: 30px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd h4 {
  color: #2c3e50;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_tableWrapper__bU\\+bA {
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_tableWrapper__bU\\+bA::-webkit-scrollbar {
  height: 8px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_tableWrapper__bU\\+bA::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_tableWrapper__bU\\+bA::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_tableWrapper__bU\\+bA::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
  border-radius: 8px;
  overflow: visible;
  min-width: 2000px;
  border: 2px solid #dee2e6;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN th {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 12px 8px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;
  border: 1px solid #dee2e6;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN th.capitalExpenditure_budgetCodeHeader__h5-Fg {
  min-width: 100px;
  width: 100px;
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  position: sticky;
  left: 0;
  z-index: 5;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN th.capitalExpenditure_budgetTitleHeader__ObctZ {
  min-width: 300px;
  width: 300px;
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  position: sticky;
  left: 100px;
  z-index: 5;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN th.capitalExpenditure_codeNumberHeader__KeDHL {
  min-width: 120px;
  background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN th.capitalExpenditure_institutionHeader__uxHGq {
  min-width: 80px;
  font-size: 11px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN th.capitalExpenditure_totalHeader__g208\\+ {
  min-width: 100px;
  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN td {
  padding: 8px 6px;
  border: 1px solid #dee2e6;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN td.capitalExpenditure_budgetCode__JAxXu {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
  position: sticky;
  left: 0;
  z-index: 3;
  min-width: 100px;
  width: 100px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN td.capitalExpenditure_budgetTitle__hPEHk {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  text-align: left;
  padding-left: 12px;
  position: sticky;
  left: 100px;
  z-index: 3;
  min-width: 300px;
  width: 300px;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.12);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN td.capitalExpenditure_budgetCodeCell__33UhY {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
  position: sticky;
  left: 0;
  z-index: 3;
  min-width: 100px;
  width: 100px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN td.capitalExpenditure_budgetTitleCell__MfOqE {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  text-align: left;
  padding-left: 12px;
  position: sticky;
  left: 100px;
  z-index: 3;
  min-width: 300px;
  width: 300px;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.12);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN td.capitalExpenditure_codeNumber__Yd-1c {
  background: #f0f8ff;
  font-weight: 600;
  color: #8e44ad;
  text-align: center;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN td.capitalExpenditure_institutionValue__LmtAm {
  background: white;
  color: #495057;
  font-weight: 500;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN td.capitalExpenditure_totalValue__Nmhpl {
  background: #e8f5e8;
  font-weight: 600;
  color: #27ae60;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_sectionHeaderRow__cZdrR .capitalExpenditure_sectionHeader__dNSfb {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  color: white;
  font-size: 14px;
  text-align: left;
  padding: 15px 8px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_subtotalRow__\\+YVNr {
  background: #fff3cd;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_subtotalRow__\\+YVNr .capitalExpenditure_budgetCode__JAxXu {
  background: #fff3cd;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_subtotalRow__\\+YVNr .capitalExpenditure_budgetTitle__hPEHk {
  background: #fff3cd;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_subtotalRow__\\+YVNr .capitalExpenditure_codeNumber__Yd-1c {
  background: #fff3cd;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_subtotalRow__\\+YVNr .capitalExpenditure_institutionValue__LmtAm {
  background: #fff3cd;
  font-weight: 600;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_subtotalRow__\\+YVNr .capitalExpenditure_totalValue__Nmhpl {
  background: #d4edda;
  color: #155724;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_dataRow__mbHll:hover {
  background-color: #f8f9fa;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_grandTotalRow__8cFqn {
  background: #d1ecf1;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_grandTotalRow__8cFqn .capitalExpenditure_budgetTitle__hPEHk {
  background: #d1ecf1;
  font-size: 14px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_grandTotalRow__8cFqn .capitalExpenditure_codeNumber__Yd-1c {
  background: #d1ecf1;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_grandTotalRow__8cFqn .capitalExpenditure_institutionValue__LmtAm {
  background: #d1ecf1;
  font-weight: 600;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_summaryExcelTableContainer__ftEfd .capitalExpenditure_summaryExcelTable__BGTxN .capitalExpenditure_grandTotalRow__8cFqn .capitalExpenditure_totalValue__Nmhpl {
  background: #cce5ff;
  color: #004085;
  font-size: 14px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 {
  width: 100%;
  overflow-x: auto;
  margin: 20px 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-collapse: separate;
  border-spacing: 0;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 > thead > tr:first-child > th:nth-child(1),
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 > tbody > tr > td:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 4;
  background: #f5f7fa;
  min-width: 70px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 > thead > tr:first-child > th:nth-child(2),
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 > tbody > tr > td:nth-child(2) {
  position: sticky;
  left: 70px;
  z-index: 4;
  background: #f5f7fa;
  min-width: 250px;
  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.12);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table th, .capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table td {
  padding: 12px 8px;
  text-align: center;
  border: 1px solid #e0e0e0;
  vertical-align: middle;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table th {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #2c3e50;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 10;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table tbody tr {
  transition: background-color 0.2s ease;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table tbody tr:hover {
  background-color: #f0f7ff;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_expenseTitle__hWSc8 {
  text-align: left;
  min-width: 250px;
  max-width: 300px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_expenseTitle__hWSc8 .capitalExpenditure_code__\\+f1U7 {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 4px;
  font-size: 13px;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_expenseTitle__hWSc8 .capitalExpenditure_title__MJLdo {
  font-size: 12px;
  color: #555;
  line-height: 1.4;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_budgetInput__DwZeO {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-align: right;
  font-family: monospace;
  font-size: 13px;
  transition: all 0.2s ease;
  background-color: white;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_budgetInput__DwZeO:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_budgetInput__DwZeO:hover:not(:focus) {
  border-color: #bbb;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_budgetInput__DwZeO:read-only {
  background-color: #f8f9fa;
  cursor: default;
}
@media (max-width: 768px) {
  .capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table th, .capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table td {
    padding: 8px 6px;
    font-size: 13px;
  }
  .capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_expenseTitle__hWSc8 {
    min-width: 200px;
    max-width: 250px;
  }
  .capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_budgetDemandTable__jniZ0 table .capitalExpenditure_budgetInput__DwZeO {
    width: 70px;
    padding: 4px 6px;
  }
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_exportSection__vOA7K {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_exportSection__vOA7K h4 {
  color: #2c3e50;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px 0;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_exportSection__vOA7K .capitalExpenditure_exportButtons__fAQ2M {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_exportSection__vOA7K .capitalExpenditure_exportButtons__fAQ2M button {
  padding: 12px 25px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_exportSection__vOA7K .capitalExpenditure_exportButtons__fAQ2M button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_exportSection__vOA7K .capitalExpenditure_exportButtons__fAQ2M button.capitalExpenditure_excelButton__n202q {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_exportSection__vOA7K .capitalExpenditure_exportButtons__fAQ2M button.capitalExpenditure_pdfButton__hf-X\\+ {
  background: #dc3545;
  color: white;
}
.capitalExpenditure_detailedReportSection__JC3qt .capitalExpenditure_exportSection__vOA7K .capitalExpenditure_exportButtons__fAQ2M button.capitalExpenditure_printButton__8Rlxw {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
}

@media (max-width: 768px) {
  .capitalExpenditure_editFormContainer__Iw4Mf {
    padding: 10px;
  }
  .capitalExpenditure_editFormContent__27jWB {
    max-height: 98vh;
  }
  .capitalExpenditure_editFormHeader__yl4B\\+ {
    padding: 15px 20px;
  }
  .capitalExpenditure_editFormHeader__yl4B\\+ h2 {
    font-size: 20px;
  }
  .capitalExpenditure_editForm__RozmY {
    padding: 0 20px 20px 20px;
  }
  .capitalExpenditure_editFormActions__tVqTn {
    flex-direction: column;
    gap: 10px;
  }
  .capitalExpenditure_successMessage__FGVbD {
    font-size: 12px;
    padding: 6px 12px;
  }
}
.capitalExpenditure_detailedReportTabs__HM6h4 {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  padding: 0 20px;
}
.capitalExpenditure_detailedReportTabs__HM6h4 .capitalExpenditure_detailedTabButton__oN50C {
  padding: 10px 20px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: white;
  color: #6c757d;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
}
.capitalExpenditure_detailedReportTabs__HM6h4 .capitalExpenditure_detailedTabButton__oN50C:hover {
  border-color: #4a90e2;
  color: #4a90e2;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.2);
}
.capitalExpenditure_detailedReportTabs__HM6h4 .capitalExpenditure_detailedTabButton__oN50C.capitalExpenditure_activeDetailedTab__cQbQY {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: white;
  border-color: #4a90e2;
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);
}

.capitalExpenditure_tokenPopupOverlay__xX2RQ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: capitalExpenditure_fadeIn__pqSNr 0.3s ease-out;
}

.capitalExpenditure_tokenPopup__xPGqp {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
  overflow: hidden;
  animation: capitalExpenditure_slideInUp__CxLSA 0.4s ease-out;
  border: 2px solid #e9ecef;
}

.capitalExpenditure_tokenPopupHeader__F7u0t {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 30px 30px 20px 30px;
  text-align: center;
  position: relative;
}
.capitalExpenditure_tokenPopupHeader__F7u0t .capitalExpenditure_tokenSuccessIcon__5r\\+id {
  font-size: 3rem;
  margin-bottom: 15px;
  animation: capitalExpenditure_bounceIn__zLpY6 0.6s ease-out;
}
.capitalExpenditure_tokenPopupHeader__F7u0t h2 {
  margin: 0 0 10px 0;
  font-size: 1.8rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.capitalExpenditure_tokenPopupHeader__F7u0t p {
  margin: 0;
  font-size: 1rem;
  opacity: 0.95;
  line-height: 1.4;
}

.capitalExpenditure_tokenDisplay__TjKzL {
  padding: 30px;
  background: white;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenLabel__GBH-U {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 15px;
  text-align: center;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenValue__Q28fO {
  background: linear-gradient(135deg, #6f42c1 0%, #e83e8c 100%);
  color: white;
  font-family: "Courier New", monospace;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  margin-bottom: 25px;
  box-shadow: 0 8px 25px rgba(111, 66, 193, 0.3);
  letter-spacing: 2px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  animation: capitalExpenditure_pulse__Lll\\+m 2s infinite;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenInfoItem__fZGZZ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenInfoItem__fZGZZ .capitalExpenditure_tokenInfoLabel__ygDfi {
  font-weight: 600;
  color: #495057;
  font-size: 0.95rem;
}
.capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenInfo__Fmmyc .capitalExpenditure_tokenInfoItem__fZGZZ .capitalExpenditure_tokenInfoValue__h7Hp8 {
  color: #6c757d;
  font-weight: 500;
  font-size: 0.95rem;
}

.capitalExpenditure_tokenPopupActions__SbHjP {
  padding: 0 30px 20px 30px;
  display: flex;
  gap: 15px;
  justify-content: center;
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCopyButton__COtIX, .capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCloseButton__hDbMw {
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  min-width: 140px;
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCopyButton__COtIX {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCopyButton__COtIX:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCopyButton__COtIX:active {
  transform: translateY(0);
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCopyButton__COtIX.capitalExpenditure_copySuccess__E4Eik {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCopyButton__COtIX.capitalExpenditure_copySuccess__E4Eik:hover {
  background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCloseButton__hDbMw {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCloseButton__hDbMw:hover {
  background: linear-gradient(135deg, #495057 0%, #343a40 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
}
.capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCloseButton__hDbMw:active {
  transform: translateY(0);
}

.capitalExpenditure_tokenPopupFooter__zpyRL {
  background: #fff3cd;
  border-top: 1px solid #ffeaa7;
  padding: 15px 30px;
  text-align: center;
}
.capitalExpenditure_tokenPopupFooter__zpyRL p {
  margin: 0;
  color: #856404;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.4;
}

.capitalExpenditure_budgetActionOverlay__90cP1 {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.capitalExpenditure_budgetActionModal__0K9ud {
  width: min(1180px, 100%);
  max-height: calc(100vh - 32px);
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.capitalExpenditure_budgetActionHeader__ftmcX {
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: #ffffff;
}
.capitalExpenditure_budgetActionHeader__ftmcX h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.capitalExpenditure_budgetActionClose__y2j8i {
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
}
.capitalExpenditure_budgetActionClose__y2j8i:hover {
  background: rgba(255, 255, 255, 0.35);
}

.capitalExpenditure_budgetActionMeta__nRjqx {
  padding: 10px 18px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fb;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 0.9rem;
  color: #334155;
}

.capitalExpenditure_budgetActionBody__lPuHO {
  padding: 10px 16px 0;
  overflow: auto;
}

.capitalExpenditure_budgetPopupInput__spUaq {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 0.85rem;
  background: #ffffff;
}
.capitalExpenditure_budgetPopupInput__spUaq:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.12);
}

.capitalExpenditure_budgetActionInfo__SbZGf {
  margin: 10px 16px 0;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 600;
}
.capitalExpenditure_budgetActionInfo__SbZGf.capitalExpenditure_success__Z4Ssi {
  background: #eafaf1;
  border: 1px solid #ccefdc;
  color: #166534;
}
.capitalExpenditure_budgetActionInfo__SbZGf.capitalExpenditure_error__hJFf\\+ {
  background: #fff1f2;
  border: 1px solid #ffd6de;
  color: #9f1239;
}
.capitalExpenditure_budgetActionInfo__SbZGf.capitalExpenditure_info__HTu4G {
  background: #eef2ff;
  border: 1px solid #dbe4ff;
  color: #1e3a8a;
}

.capitalExpenditure_budgetActionActions__Xcb7r {
  padding: 12px 16px 16px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #ffffff;
}

.capitalExpenditure_budgetActionButton__-gauP {
  border: none;
  border-radius: 8px;
  padding: 9px 14px;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  background: #e9ecef;
  color: #334155;
}
.capitalExpenditure_budgetActionButton__-gauP:hover {
  background: #dfe3e8;
}

.capitalExpenditure_budgetActionSave__5q4l- {
  background: #e67e22;
  color: #ffffff;
}
.capitalExpenditure_budgetActionSave__5q4l-:hover:not(:disabled) {
  background: #d96f0f;
}
.capitalExpenditure_budgetActionSave__5q4l-:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@keyframes capitalExpenditure_fadeIn__pqSNr {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes capitalExpenditure_slideInUp__CxLSA {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes capitalExpenditure_bounceIn__zLpY6 {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes capitalExpenditure_pulse__Lll\\+m {
  0% {
    box-shadow: 0 8px 25px rgba(111, 66, 193, 0.3);
  }
  50% {
    box-shadow: 0 8px 25px rgba(111, 66, 193, 0.6);
  }
  100% {
    box-shadow: 0 8px 25px rgba(111, 66, 193, 0.3);
  }
}
@media (max-width: 768px) {
  .capitalExpenditure_budgetActionOverlay__90cP1 {
    padding: 8px;
  }
  .capitalExpenditure_budgetActionModal__0K9ud {
    max-height: calc(100vh - 16px);
  }
  .capitalExpenditure_budgetActionHeader__ftmcX {
    padding: 12px 14px;
  }
  .capitalExpenditure_budgetActionHeader__ftmcX h3 {
    font-size: 0.95rem;
  }
  .capitalExpenditure_budgetActionMeta__nRjqx {
    padding: 10px 14px;
    font-size: 0.85rem;
    gap: 8px;
  }
  .capitalExpenditure_budgetActionBody__lPuHO {
    padding: 8px 10px 0;
  }
  .capitalExpenditure_budgetActionActions__Xcb7r {
    padding: 10px 12px 12px;
    flex-direction: column-reverse;
  }
  .capitalExpenditure_budgetActionButton__-gauP {
    width: 100%;
  }
  .capitalExpenditure_tokenPopup__xPGqp {
    max-width: 95vw;
    margin: 10px;
  }
  .capitalExpenditure_tokenPopupHeader__F7u0t {
    padding: 25px 20px 15px 20px;
  }
  .capitalExpenditure_tokenPopupHeader__F7u0t h2 {
    font-size: 1.5rem;
  }
  .capitalExpenditure_tokenPopupHeader__F7u0t p {
    font-size: 0.9rem;
  }
  .capitalExpenditure_tokenDisplay__TjKzL {
    padding: 20px;
  }
  .capitalExpenditure_tokenDisplay__TjKzL .capitalExpenditure_tokenValue__Q28fO {
    font-size: 1.2rem;
    padding: 15px;
    letter-spacing: 1px;
  }
  .capitalExpenditure_tokenPopupActions__SbHjP {
    padding: 0 20px 15px 20px;
    flex-direction: column;
  }
  .capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCopyButton__COtIX, .capitalExpenditure_tokenPopupActions__SbHjP .capitalExpenditure_tokenCloseButton__hDbMw {
    min-width: auto;
    width: 100%;
  }
  .capitalExpenditure_tokenPopupFooter__zpyRL {
    padding: 12px 20px;
  }
  .capitalExpenditure_tokenPopupFooter__zpyRL p {
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/capitalExpenditure/capitalExpenditure.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAGE,aAAA;EACA,gCAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;AAAF;;AAGA;EACE,oBAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,2CAAA;EACA,oBAAA;EACA,WAAA;AAAF;;AAGA;EACE,eAAA;EACA,qBAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,oCAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,sBAAA;AAAF;;AAGA;EACE,oCAAA;EACA,sCAAA;EACA,2BAAA;AAAF;;AAGA;EACE,oCAAA;EACA,mBAAA;EACA,wCAAA;AAAF;;AAGA;EACE,6DAAA;EACA,qBAAA;EACA,2BAAA;EACA,4CAAA;EACA,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oDAAA;EACA,0BAAA;AAAF;;AAGA;EACE,6DAAA;EACA,YAAA;EACA,iBAAA;AAAF;AAEE;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AAAJ;;AAKA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yCAAA;AAFF;;AAKA;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oDAAA;EACA,0BAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAFF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,yBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AAHF;;AAMA;EACE,cAAA;EACA,kBAAA;AAHF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;AAHF;;AAMA;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AAHF;;AAMA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAHF;;AAMA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;EACE,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;AAKE;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,wCAAA;AAHJ;AAME;EACE,6DAAA;EACA,YAAA;AAJJ;AAOE;EACE,6DAAA;EACA,cAAA;AALJ;;AASA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AANF;;AASA;EACE,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,wCAAA;AANF;;AASA;EACE,6DAAA;EACA,2BAAA;EACA,wCAAA;AANF;;AASA;EACE,wBAAA;AANF;;AASA;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AANF;;AAUA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AAPF;AASE;EACE,kBAAA;EACA,cAAA;EACA,+DAAA;EACA,YAAA;EACA,eAAA;AAPJ;;AAWA;EACE;IACE,UAAA;IACA,uCAAA;EARF;EAUA;IACE,UAAA;IACA,iCAAA;EARF;AACF;AAYA;EACE,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;AAVF;AAYE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AAVJ;AAYI;EACE,SAAA;EACA,eAAA;EACA,iBAAA;AAVN;AAeI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAbN;AAiBE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAfN;AAkBI;EACE,6DAAA;EACA,YAAA;AAhBN;AAkBM;EACE,6DAAA;EACA,2BAAA;AAhBR;AAoBI;EACE,6DAAA;EACA,YAAA;AAlBN;AAoBM;EACE,6DAAA;EACA,2BAAA;AAlBR;;AAwBA;EACE,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;AArBF;;AAwBA;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AArBF;;AAwBA;EACE,6DAAA;EACA,2BAAA;EACA,wCAAA;AArBF;;AAwBA;EACE,wBAAA;AArBF;;AAwBA;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AArBF;;AAwBA;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,6DAAA;EACA,2BAAA;EACA,wCAAA;AArBF;;AAwBA;EACE,wBAAA;AArBF;;AAwBA;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;AArBF;;AAwBA;EACE,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AArBF;;AAwBA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;AArBF;;AAwBA;EACE,mBAAA;AArBF;;AAwBA;EACE,cAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AArBF;;AAwBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AArBF;AAuBE;EACE,cAAA;AArBJ;AAwBE;EACE,qBAAA;EACA,UAAA;AAtBJ;AAwBI;EACE,aAAA;EACA,gBAAA;AAtBN;;AA2BA;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAxBF;;AA4BA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;AAzBF;;AA4BA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;AAzBF;AA2BE;EACE,cAAA;AAzBJ;AA4BE;EACE,cAAA;EACA,4BAAA;AA1BJ;;AA8BA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;AA3BF;AA6BE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA3BJ;AA6BI;EACE,cAAA;AA3BN;AA8BI;EACE,qBAAA;EACA,UAAA;AA5BN;AA8BM;EACE,aAAA;EACA,gBAAA;AA5BR;AAiCE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA/BJ;;AAmCA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,iBAAA;AAhCF;;AAyCA;EACE,mBAAA;AAtCF;;AAyCA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAtCF;AAwCE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAtCJ;AAyCE;EACE,aAAA;EACA,gBAAA;AAvCJ;AA0CE;EACE,cAAA;EACA,kBAAA;AAxCJ;AA0CI;EACE,aAAA;EACA,gBAAA;AAxCN;AA4CE;EACE,gBAAA;AA1CJ;;AA8CA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA3CF;AA6CE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AA3CJ;;AA+CA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,iDAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;AA5CF;;AA+CA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AA5CF;AA8CE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AA5CJ;AA8CI;EACE,qBAAA;AA5CN;;AAiDA;EACE,iBAAA;EACA,cAAA;AA9CF;;AAiDA;EACE,iBAAA;EACA,cAAA;AA9CF;;AAiDA;EACE,iBAAA;EACA,cAAA;AA9CF;;AAiDA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AA9CF;;AAiDA;EACE,iBAAA;EACA,gBAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,iDAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,gCAAA;EACA,yBAAA;AA9CF;AAgDE;EACE,mBAAA;AA9CJ;AAiDE;EACE,mBAAA;AA/CJ;;AAmDA;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAhDF;;AAmDA;EACE,SAAA;EACA,gBAAA;EACA,WAAA;AAhDF;;AAmDA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AAhDF;AAkDE;EACE,mBAAA;EACA,YAAA;AAhDJ;AAmDE;EACE,mBAAA;EACA,cAAA;AAjDJ;;AAqDA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AAlDF;AAoDE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AAlDJ;AAoDI;EACE,qBAAA;AAlDN;;AAuDA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AApDF;;AAuDA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AApDF;AAsDE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AApDJ;AAuDE;EACE,aAAA;EACA,gBAAA;AArDJ;;AAyDA;EACE,qCAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,wCAAA;AAtDF;;AAyDA;EACE,8BAAA;EACA,qBAAA;EACA,0CAAA;AAtDF;;AAyDA;EACE,qBAAA;EACA,4CAAA;AAtDF;;AAyDA;EACE,qBAAA;EACA,4CAAA;AAtDF;;AAyDA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtDF;;AAyDA;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;AAtDF;;AAyDA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4DAAA;AAtDF;;AAyDA;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;AAtDF;;AAyDA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kCAAA;AAtDF;;AAyDA;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AAtDF;;AAyDA;EACE,iBAAA;EACA,gBAAA;AAtDF;;AAyDA;EACE,kBAAA;EACA,eAAA;EACA,sCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtDF;;AAyDA;EACE,yBAAA;AAtDF;;AAyDA;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAtDF;;AAyDA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAtDF;;AA0DA;EACE,kBAAA;EACA,WAAA;AAvDF;;AA0DA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAvDF;AAyDE;EACE,qBAAA;AAvDJ;;AA2DA;EACE,WAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAxDF;;AA2DA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,qCAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,4DAAA;AAxDF;;AA2DA;EACE,iBAAA;EACA,gBAAA;AAxDF;;AA2DA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;AAxDF;AA0DE;EACE,yBAAA;AAxDJ;AA2DE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAzDJ;;AA6DA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AA1DF;AA4DE;EACE,WAAA;AA1DJ;;AA8DA;EACE;IACE,UAAA;IACA,4BAAA;EA3DF;EA6DA;IACE,UAAA;IACA,wBAAA;EA3DF;AACF;AA8DA;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AA5DF;;AAkEA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,2DAAA;AA/DF;;AAkEA;EACE,6DAAA;EACA,cAAA;EACA,yBAAA;AA/DF;;AAkEA;EACE,6DAAA;EACA,cAAA;EACA,yBAAA;AA/DF;;AAkEA;EACE,6DAAA;EACA,cAAA;EACA,yBAAA;AA/DF;;AAkEA;EACE;IACE,UAAA;IACA,4BAAA;EA/DF;EAiEA;IACE,UAAA;IACA,wBAAA;EA/DF;AACF;AAmEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,yDAAA;AAjEF;;AAoEA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,0DAAA;AAjEF;;AAoEA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAjEF;;AAoEA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAjEF;;AAoEA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAjEF;;AAoEA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAjEF;;AAoEA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAjEF;;AAoEA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAjEF;;AAoEA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAjEF;;AAoEA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAjEF;;AAoEA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAjEF;;AAoEA;EACE;IACE,UAAA;EAjEF;EAmEA;IACE,UAAA;EAjEF;AACF;AAoEA;EACE;IACE,UAAA;IACA,qBAAA;EAlEF;EAoEA;IACE,UAAA;IACA,mBAAA;EAlEF;AACF;AAqEA;EACE,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AAnEF;;AAuEA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AApEF;AAsEE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AApEJ;AAsEI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AApEN;AAsEM;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AApER;AAuEM;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArER;AAuEQ;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AArEV;AAwEQ;EACE,mBAAA;EACA,mBAAA;AAtEV;;AA6EA;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;AA1EF;;AA8EA;EACE;IACE,iBAAA;EA3EF;EA8EA;IACE,gBAAA;EA5EF;AACF;AA+EA;EACE;IACE,iBAAA;EA7EF;EAgFA;IACE,gBAAA;EA9EF;AACF;AAiFA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA/EF;AAiFE;EACE,eAAA;AA/EJ;AAkFE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAhFJ;;AAqFA;EACE,eAAA;AAlFF;AAqFI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAnFN;AAsFI;EACE,YAAA;EACA,eAAA;EACA,kBAAA;AApFN;AAuFI;;;;EAIE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AArFN;;AA0FA;EACE,eAAA;EACA,aAAA;AAvFF;;AA0FA;EACE;IACE,aAAA;EAvFF;EAyFE;IACE,eAAA;IACA,iBAAA;EAvFJ;AACF;AA2FA;EAEI;IACE,sBAAA;IACA,oBAAA;IACA,QAAA;EA1FJ;EA6FE;;;;;IAKE,WAAA;IACA,uBAAA;IACA,kBAAA;EA3FJ;EA+FA;IACE,UAAA;EA7FF;AACF;AA2GA;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,WAdc;EAed,eAfc;EAgBd,eAhBc;AAzFhB;;AA4GA;EACE,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,YAtBc;EAuBd,gBAvBc;EAwBd,gBAxBc;AAjFhB;;AA4GA;EACE,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,YA9Bc;EA+Bd,gBA/Bc;EAgCd,gBAhCc;AAzEhB;;AA4GA;EACE,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,YAtCc;EAuCd,gBAvCc;EAwCd,gBAxCc;EAyCd,8CAAA;AAzGF;;AA4GA;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,8CAAA;AAzGF;;AA4GA;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAtDgB;EAuDhB,8CAAA;AAzGF;;AA4GA;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,8CAAA;AAzGF;;AA4GA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AAzGF;;AA4GA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,wCAAA;EACA,gBAAA;EACA,kBAAA;AAzGF;AA4GE;EACE,qDAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA1GJ;AA4GI;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AA1GN;AA4GM;EACE,qDAAA;EACA,sBAAA;EACA,yBAAA;AA1GR;AA+GE;EACE,qDAAA;EACA,YAAA;EACA,gBAAA;AA7GJ;AA+GI;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;AA7GN;AAkHE;EACE,eA5IY;EA6IZ,WA7IY;EA8IZ,gEAAA;EACA,oCAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;AAhHJ;AAkHI;EACE,eAAA;AAhHN;AAoHE;EACE,gBAzJY;EA0JZ,YA1JY;EA2JZ,gEAAA;EACA,oCAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;AAlHJ;AAoHI;EACE,eAAA;AAlHN;AAsHE;EACE,gBAtKY;EAuKZ,YAvKY;EAwKZ,gEAAA;EACA,oCAAA;AApHJ;AAuHE;EACE,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,2BAAA;EACA,uBAAA;AArHJ;AAuHI;EACE,eAAA;AArHN;AAyHE;EACE,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,2BAAA;EACA,uBAAA;EACA,6CAAA;AAvHJ;AAyHI;EACE,eAAA;AAvHN;AA2HE;EACE,gBAAA;EACA,gEAAA;EACA,oCAAA;EACA,uBAAA;EACA,2CAAA;AAzHJ;AA4HE;EACE,gBAAA;EACA,gEAAA;EACA,oCAAA;EACA,uBAAA;EACA,2CAAA;AA1HJ;AA6HE;EACE,gBAAA;EACA,gEAAA;EACA,oCAAA;EACA,uBAAA;EACA,2CAAA;AA3HJ;AA8HE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AA5HJ;AAgIE;EACE,sBAAA;EACA,sBAAA;AA9HJ;AAkIE;EACE,gDAAA;EACA,iDAAA;AAhIJ;AAkII;EACE,kBAAA;AAhIN;;AAqIA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAlIF;AAoIE;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,wCAAA;AAlIJ;AAoII;EACE,6DAAA;EACA,2BAAA;EACA,yCAAA;AAlIN;AAqII;EACE,wBAAA;EACA,wCAAA;AAnIN;AAsII;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AApIN;;AA0IA;EACE,qDAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAvIF;AAyIE;EACE,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,2CAAA;EACA,kBAAA;AAvIJ;AAyII;EACE,qDAAA;EACA,sBAAA;EACA,yBAAA;AAvIN;;AA4IA;EACE,gEAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,2CAAA;AAzIF;;AA6IA;EACE,qDAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AA1IF;AA4IE;EACE,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;AA1IJ;;AA8IA;EACE,YAAA;EACA,mBAAA;AA3IF;;AA8IA;EACE,YAAA;EACA,mBAAA;AA3IF;;AA8IA;EACE,YAAA;EACA,mBAAA;AA3IF;;AA8IA;EACE,YAAA;EACA,mBAAA;AA3IF;;AA+IA;EACE,mBAAA;EACA,sBAAA;AA5IF;;AA+IA;EACE,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AA5IF;AA8IE;EACE,8BAAA;AA5IJ;;AAgJA;EACE,mBAAA;EACA,sCAAA;EACA,sBAAA;AA7IF;;AAgJA;EACE,mBAAA;AA7IF;;AAgJA;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;AA7IF;;AAgJA;EACE,mBAAA;EACA,kBAAA;EACA,eAlZc;EAmZd,WAnZc;EAoZd,mBAAA;AA7IF;;AAgJA;EACE,mBAAA;EACA,gBAxZc;EAyZd,YAzZc;EA0Zd,qBAAA;EACA,mBAAA;AA7IF;;AAgJA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AA7IF;;AAiJA;;EAEE,8BAAA;AA9IF;;AAiJA;;EAEE,8BAAA;AA9IF;;AAiJA;;;;EAIE,8BAAA;AA9IF;;AAiJA;EACE,mBAAA;EACA,kBAAA;AA9IF;;AAiJA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,wDAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AA9IF;;AAiJA;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AA9IF;;AAiJA;EACE,cAAA;EACA,kBAAA;AA9IF;;AAiJA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,qBAAA;AA9IF;;AAiJA;EACE,6DAAA;EACA,2BAAA;EACA,yCAAA;AA9IF;;AAiJA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AA9IF;;AAkJA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA/IF;;AAkJA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AA/IF;;AAkJA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA/IF;;AAkJA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AA/IF;;AAkJA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AA/IF;;AAkJA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AA/IF;;AAkJA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AA/IF;AAiJE;EACE,uBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AA/IJ;AAkJE;;;EAGE,8BAAA;AAhJJ;;AAoJA;EACE,8BAAA;EACA,yBAAA;AAjJF;AAmJE;EACE,8BAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,mBAAA;AAjJJ;AAoJE;EACE,8BAAA;AAlJJ;AAqJE;EACE,8BAAA;AAnJJ;AAsJE;;;EAGE,8BAAA;AApJJ;AAuJE;EACE,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;AArJJ;AAwJE;EACE,0BAAA;AAtJJ;;AA0JA;EACE,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EAEA,eAAA;AAxJF;;AA2JA;;EAEE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AAxJF;;AA2JA;EACE,2BAAA;EACA,uBAAA;EACA,2BAAA;AAxJF;;AA2JA;EACE,2BAAA;EACA,uBAAA;EACA,2BAAA;AAxJF;;AA2JA;EACE,eAAA;AAxJF;;AA2JA;EACE,mBAAA;EACA,sBAAA;AAxJF;;AA2JA;EACE,mBAAA;AAxJF;;AA2JA;EACE,8BAAA;EACA,sBAAA;AAxJF;;AA2JA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAxJF;AA0JE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAxJJ;AA2JE;EACE,qBAAA;AAzJJ;AA4JE;EACE,cAAA;AA1JJ;;AA+JA;EACE,YAAA;EACA,uBAAA;AA5JF;AA8JE;EACE,yBAAA;EACA,mBAAA;AA5JJ;AA+JE;EACE,mBAAA;AA7JJ;;AAmKA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAhKF;;AAmKA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAhKF;AAkKE;EACE,yBAAA;AAhKJ;AAmKE;EACE,yBAAA;EACA,mBAAA;AAjKJ;;AAqKA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAlKF;;AAqKA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAlKF;;AAqKA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAlKF;;AAqKA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAlKF;;AAqKA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAlKF;;AAqKA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAlKF;;AAqKA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAlKF;;AAqKA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAlKF;;AAqKA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAlKF;;AAqKA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAlKF;;AAqKA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAlKF;;AAqKA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAlKF;;AAsKA;EACE,oCAAA;EACA,yBAAA;EACA,8BAAA;EACA,oCAAA;AAnKF;;AAsKA;EACE,wBAAA;EACA,2BAAA;EACA,gCAAA;AAnKF;;AAuKA;EACE,oCAAA;EACA,yBAAA;EACA,8BAAA;EACA,oCAAA;EACA,YAAA;AApKF;;AAuKA;EACE,oCAAA;EACA,gCAAA;EACA,0BAAA;AApKF;;AAwKA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AArKF;;AAwKA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AArKF;;AAwKA;EACE,6DAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AArKF;;AAwKA;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AArKF;;AAwKA;EACE,6DAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AArKF;;AAwKA;EACE,6DAAA;EACA,2BAAA;EACA,4CAAA;AArKF;;AAwKA;EACE,6DAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AArKF;;AAwKA;EACE,6DAAA;EACA,2BAAA;EACA,4CAAA;AArKF;;AAyKA;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AAtKF;AAwKE;EACE,mBAAA;AAtKJ;;AA0KA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAvKF;;AA2KA;EACE,qBAAA;EACA,uBAAA;EACA,mBAAA;AAxKF;;AA2KA;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAxKF;AA0KE;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;AAxKJ;AA2KE;EACE,6DAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAzKJ;AA4KE;EACE,sCAAA;AA1KJ;AA4KI;EACE,yBAAA;AA1KN;AA6KI;EACE,gBAAA;EACA,cAAA;EACA,UAAA;AA3KN;AA8KI;EACE,qCAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AA5KN;AAwLE;EACE,yBAAA;AAtLJ;AAwLI;EACE,gBAAA;EACA,cAAA;AAtLN;AAyLI;EACE,gBAAA;EACA,cAAA;AAvLN;AA2LE;EACE,yBAAA;EACA,6BAAA;EACA,gCAAA;AAzLJ;AA2LI;EACE,gBAAA;EACA,cAAA;AAzLN;;AA+LA;EACE;IACE,eAAA;EA5LF;AACF;AAgMA;EACE;IACE,aAAA;EA9LF;EAiMA;IACE,aAAA;EA/LF;EAkMA;IACE,eAAA;EAhMF;EAmMA;IACE,uBAAA;IACA,2BAAA;IACA,2BAAA;IACA,0BAAA;IACA,eAAA;IACA,kBAAA;EAjMF;EAoMA;IACE,aAAA;EAlMF;EAqMA;;IAEE,eAAA;IACA,gBAAA;EAnMF;EAsMA;IACE,eAAA;IACA,gBAAA;EApMF;EAuMA;IACE,eAAA;IACA,gBAAA;EArMF;AACF;AAwMA;EACE;IACE,aAAA;IACA,cAAA;EAtMF;EAyMA;IACE,iBAAA;IACA,mBAAA;EAvMF;EA0MA;IACE,eAAA;IACA,mBAAA;EAxMF;EA2MA;IACE,sBAAA;IACA,SAAA;IACA,mBAAA;EAzMF;EA4MA;IACE,sBAAA;IACA,2BAAA;IACA,2BAAA;IACA,yBAAA;IACA,eAAA;IACA,kBAAA;EA1MF;EA6MA;IACE,eAAA;IACA,kBAAA;EA3MF;EA8MA;IACE,eAAA;EA5MF;EA+MA;IACE,iBAAA;EA7MF;EAgNA;IACE,kBAAA;IACA,eAAA;EA9MF;EAiNA;IACE,eAAA;EA/MF;EAkNA;IACE,eAAA;EAhNF;EAmNA;IACE,aAAA;IACA,gBAAA;EAjNF;EAoNA;IACE,gBAAA;EAlNF;EAqNA;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EAnNF;EAsNA;;;;;;;;;IASE,WAAA;IACA,gBAAA;EApNF;EAuNA;IACE,eAAA;IACA,kBAAA;EArNF;EAwNA;IACE,aAAA;IACA,YAAA;EAtNF;EAyNA;IACE,sBAAA;IACA,SAAA;EAvNF;EA0NA;;IAEE,WAAA;EAxNF;EA2NA;IACE,aAAA;EAzNF;EA2NE;IACE,0BAAA;IACA,SAAA;EAzNJ;EA+NE;IACE,gBAAA;EA7NJ;EA+NI;IACE,gBAAA;EA7NN;EA+NM;IAAiB,gBAAA;EA5NvB;EA6NM;IAAiB,gBAAA;EA1NvB;EA2NM;IAAiB,gBAAA;EAxNvB;EAyNM;IAAiB,gBAAA;EAtNvB;EAuNM;IAAiB,eAAA;EApNvB;EAqNM;IAAiB,gBAAA;EAlNvB;AACF;AAuNA;EACE;IACE,YAAA;EArNF;EAwNA;IACE,iBAAA;EAtNF;EAyNA;IACE,eAAA;EAvNF;EA0NA;IACE,eAAA;IACA,iBAAA;EAxNF;EA2NA;IACE,eAAA;IACA,iBAAA;EAzNF;EA4NA;IACE,eAAA;EA1NF;EA6NA;IACE,YAAA;EA3NF;EA8NA;;IAEE,eAAA;IACA,gBAAA;EA5NF;EA+NA;IACE,eAAA;IACA,gBAAA;EA7NF;EAgOA;IACE,eAAA;EA9NF;AACF;AAkOA;EACE;IACE,iBAAA;IACA,gBAAA;EAhOF;EAmOA;;IAEE,aAAA;EAjOF;EAoOA;IACE,gBAAA;IACA,sBAAA;EAlOF;EAqOA;;;IAGE,8BAAA;IACA,sBAAA;EAnOF;EAsOA;IACE,aAAA;EApOF;EAuOA;IACE,aAAA;EArOF;EAwOA;IACE,aAAA;EAtOF;AACF;AA0OA;EACE,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,4DAAA;AAxOF;AA0OE;EACE,YAAA;EACA,kBAAA;AAxOJ;AA0OI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AAxON;AA2OI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAzON;AA2OM;EACE,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;AAzOR;AA2OQ;EACE,cAAA;EACA,iBAAA;AAzOV;AA8OI;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AA5ON;;AAiPA;EACE;IACE,cAAA;IACA,aAAA;EA9OF;EAiPI;IACE,eAAA;EA/ON;EAkPI;IACE,sBAAA;IACA,SAAA;EAhPN;EAkPM;IACE,eAAA;IACA,iBAAA;EAhPR;EAoPI;IACE,eAAA;EAlPN;AACF;AAwPA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,cAAA;AAtPF;AAwPE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,oBAAA;AAtPJ;AA0PE;EACE,mBAAA;AAxPJ;AA0PI;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAxPN;AA0PM;EACE,2BAAA;EACA,4CAAA;AAxPR;AA4PI;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AA1PN;AA4PM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA1PR;AA4PQ;EACE,SAAA;EACA,gBAAA;AA1PV;AA4PU;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA1PZ;AA6PU;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AA3PZ;AA6PY;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AA3Pd;AAiQM;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AA/PR;AAiQQ;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA/PV;AAiQU;EACE,mBAAA;EACA,YAAA;AA/PZ;AAiQY;EACE,mBAAA;EACA,2BAAA;AA/Pd;AAmQU;EACE,mBAAA;EACA,YAAA;AAjQZ;AAmQY;EACE,mBAAA;EACA,2BAAA;AAjQd;AA0QE;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;AAxQJ;AA2QI;EACE,gCAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;AAzQN;AA6QI;EACE,WAAA;AA3QN;AA8QI;EACE,mBAAA;EACA,kBAAA;AA5QN;AA+QI;EACE,gBAAA;EACA,kBAAA;AA7QN;AA+QM;EACE,gBAAA;AA7QR;AAiRI;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AA/QN;AAkRM;EACF,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,gBAAA;AAhRJ;AAkRI;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAhRN;AAmRM;EAAiB,gBAAA;AAhRvB;AAiRM;EAAiB,gBAAA;AA9QvB;AA+QM;EAAiB,gBAAA;AA5QvB;AA6QM;EAAiB,gBAAA;AA1QvB;AA2QM;EAAiB,gBAAA;AAxQvB;AAyQM;EAAiB,gBAAA;AAtQvB;AAyQM;EACE,6DAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;AAvQR;AA2QI;EACE,aAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAzQN;AA4QM;EACE,sCAAA;AA1QR;AA4QQ;EACE,yBAAA;AA1QV;AA6QQ;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA3QV;AA6QU;EACE,mBAAA;EACA,cAAA;AA3QZ;AA8QU;EACE,mBAAA;EACA,YAAA;AA5QZ;AA+QU;EACE,mBAAA;EACA,YAAA;AA7QZ;AAgRU;EACE,mBAAA;EACA,YAAA;AA9QZ;AAiRU;EACE,mBAAA;EACA,YAAA;AA/QZ;AAmRQ;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAjRV;AAmRU;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAjRZ;AAmRY;EACE,mBAAA;EACA,YAAA;AAjRd;AAmRc;EACE,mBAAA;AAjRhB;AAqRY;EACE,mBAAA;EACA,cAAA;AAnRd;AAqRc;EACE,mBAAA;AAnRhB;AAuRY;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AArRd;AAuRc;EACE,mBAAA;AArRhB;AAyRY;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAvRd;AAyRc;EACE,mBAAA;AAvRhB;AA2RY;EACE,mBAAA;EACA,YAAA;AAzRd;AA2Rc;EACE,mBAAA;AAzRhB;AAmSE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AAjSJ;AAmSI;EACE,SAAA;AAjSN;AAsSE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AApSJ;AAuSE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AArSJ;AAuSI;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AArSN;AAySE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvSJ;AA0SE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxSJ;AA0SI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAxSN;AA2SI;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AAzSN;AA2SM;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AAzSR;AA8SE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AA5SJ;AA+SE;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA7SJ;AAgTE;EACE,mBAAA;EACA,YAAA;AA9SJ;AAgTI;EACE,mBAAA;EACA,2BAAA;AA9SN;AAkTE;EACE,mBAAA;EACA,YAAA;AAhTJ;AAkTI;EACE,mBAAA;EACA,2BAAA;AAhTN;AAoTE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAlTJ;AAqTE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAnTJ;AAqTI;EACE,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAnTN;AAqTM;EACE,2BAAA;EACA,0CAAA;EACA,qBAAA;AAnTR;AAsTM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AApTR;AAuTM;EACE,aAAA;EACA,cAAA;EACA,eAAA;AArTR;AAuTQ;EACE,gBAAA;EACA,cAAA;AArTV;AA2TE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAzTJ;;AA6TA;EACE;IACE,aAAA;IACA,cAAA;EA1TF;EA4TE;IACE,eAAA;EA1TJ;EA6TE;IACE,0BAAA;IACA,SAAA;EA3TJ;EA6TI;IACE,aAAA;EA3TN;EA6TM;IACE,eAAA;EA3TR;EA8TM;IACE,eAAA;EA5TR;AACF;AAkUA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAhUF;;AAmUA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAhUF;;AAmUA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAhUF;;AAmUA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAhUF;;AAmUA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAhUF;;AAmUA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAhUF;;AAmUA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAhUF;;AAmUA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAhUF;;AAmUA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAhUF;;AAmUA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,+CAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAhUF;AAkUE;EACE,6DAAA;EACA,2BAAA;EACA,+CAAA;AAhUJ;AAmUE;EACE,wBAAA;AAjUJ;AAoUE;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAlUJ;;AAsUA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAnUF;;AAsUA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAnUF;;AAsUA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAnUF;;AAsUA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;AAnUF;;AAsUA;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAnUF;;AAsUA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAnUF;;AAuUA;;EAEE,kBAAA;EACA,WAAA;AApUF;AAsUE;;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AAnUJ;AAqUI;;EACE,qBAAA;AAlUN;;AAwUA;;EAEE,kBAAA;EACA,WAAA;EACA,cAAA;AArUF;AAuUE;;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AApUJ;AAsUI;;EACE,qBAAA;AAnUN;;AAyUA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,yBAAA;AAtUF;;AAyUA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAtUF;AAwUE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AAtUJ;;AA0UA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAvUF;;AA0UA;EACE,6DAAA;EACA,2BAAA;EACA,yCAAA;AAvUF;;AA0UA;EACE,6BAAA;EACA,iBAAA;AAvUF;;AA0UA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAvUF;;AA0UA;EACE,SAAA;EACA,gBAAA;AAvUF;AAyUE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAvUJ;;AA2UA;;EAEE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,wDAAA;EACA,sBAAA;AAxUF;;AA2UA;;EAEE,aAAA;EACA,qBAAA;EACA,4CAAA;AAxUF;;AA2UA;EACE,cAAA;EACA,kBAAA;AAxUF;;AA2UA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;AAxUF;;AA2UA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAxUF;AA0UE;EACE,yBAAA;AAxUJ;AA2UE;EACE,yBAAA;EACA,mBAAA;AAzUJ;;AA6UA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AA1UF;AA4UE;EACE,yBAAA;AA1UJ;AA6UE;EACE,yBAAA;EACA,mBAAA;AA3UJ;;AA+UA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,qBAAA;AA5UF;;AA+UA;EACE,6DAAA;EACA,2BAAA;EACA,yCAAA;AA5UF;;AA+UA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;EACA,qBAAA;AA5UF;;AA+UA;EACE,6DAAA;EACA,2BAAA;EACA,yCAAA;AA5UF;;AA+UA;EACE,6DAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AA5UF;AA8UE;EACE,cAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;AA5UJ;;AAgVA;EACE;IACE,aAAA;EA7UF;EAgVA;IACE,sBAAA;IACA,SAAA;EA9UF;EAiVA;IACE,gBAAA;EA/UF;EAkVA;IACE,sBAAA;IACA,SAAA;EAhVF;EAmVA;IACE,eAAA;IACA,iBAAA;EAjVF;AACF;AAwVA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAtVF;;AAyVA;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAtVF;AAwVE;EACE,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,8CAAA;AAtVJ;AAyVE;EACE,6DAAA;EACA,YAAA;EACA,yBAAA;EACA,+CAAA;AAvVJ;;AA2VA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAxVF;;AA2VA;EACE,uBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAxVF;AA0VE;EACE,2BAAA;EACA,6CAAA;AAxVJ;;AA4VA;EACE,uBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAzVF;AA2VE;EACE,2BAAA;EACA,6CAAA;AAzVJ;AA4VE;EACE,YAAA;EACA,mBAAA;AA1VJ;;AA8VA;EACE,uBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA3VF;AA6VE;EACE,2BAAA;EACA,+CAAA;AA3VJ;AA8VE;EACE,YAAA;EACA,mBAAA;AA5VJ;;AAgWA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AA7VF;AA+VE;EACE,gBAAA;EACA,cAAA;AA7VJ;AA+VI;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AA7VN;AAgWI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA9VN;AAkWE;EACE,gBAAA;AAhWJ;AAkWI;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,6CAAA;EACA,mBAAA;AAhWN;AAkWM;EACE,2BAAA;EACA,6CAAA;AAhWR;AAmWM;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAjWR;AAqWI;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAnWN;AAqWM;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAnWR;AAsWM;EACE,SAAA;EACA,kBAAA;AApWR;AAsWQ;EACE,aAAA;EACA,gBAAA;EACA,cAAA;AApWV;;AA2WA;EACE,qBAAA;AAxWF;AA0WE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gCAAA;AAxWJ;AA0WI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAxWN;AA2WI;EACE,SAAA;EACA,cAAA;EACA,kBAAA;AAzWN;;AA8WA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AA3WF;AA6WE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;AA3WJ;AA8WE;EACE,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AA5WJ;AA8WI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA5WN;AA+WI;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AA7WN;AAiXE;EACE,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA/WJ;;AAmXA;EACE,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAhXF;AAkXE;EACE,yBAAA;EACA,2BAAA;EACA,4CAAA;AAhXJ;AAmXE;EACE,wBAAA;AAjXJ;;AAqXA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAlXF;AAoXE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAlXJ;;AAsXA,yBAAA;AACA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,+DAAA;AAnXF;;AAsXA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAnXF;;AAsXA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAnXF;;AAsXA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAnXF;;AAsXA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAnXF;;AAsXA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAnXF;;AAsXA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;AAnXF;;AAsXA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AAnXF;AAqXE;EACE,oCAAA;AAnXJ;;AAuXA;EACE;IACE,2BAAA;IACA,UAAA;EApXF;EAsXA;IACE,wBAAA;IACA,UAAA;EApXF;AACF;AAuXA;EACE;IACE,wBAAA;IACA,UAAA;EArXF;EAuXA;IACE,2BAAA;IACA,UAAA;EArXF;AACF;AAwXA;EACE,+DAAA;AAtXF;;AAyXA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAtXF;AAwXE;EACE,yBAAA;EACA,2BAAA;EACA,wCAAA;AAtXJ;AAyXE;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAvXJ;AA0XE;EACE,wBAAA;EACA,wCAAA;AAxXJ;;AA6XA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,yDAAA;AA1XF;;AA6XA;EACE;IACE,UAAA;EA1XF;EA4XA;IACE,UAAA;EA1XF;AACF;AA6XA;EACE,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2DAAA;AA3XF;;AA8XA;EACE;IACE,UAAA;EA3XF;EA6XA;IACE,UAAA;EA3XF;AACF;AA8XA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gCAAA;EACA,6DAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;AA5XF;AA8XE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,2CAAA;AA5XJ;;AAgYA;EACE,aAAA;EACA,SAAA;EACA,kBAAA,EAAA,mCAAA;AA7XF;;AAgYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;AA7XF;;AAgYA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA7XF;;AAgYA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;AA7XF;AA+XE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA7XJ;AAgYE;EACE,gBAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA9XJ;AAgYI;EACE,YAAA;EACA,YAAA;AA9XN;;AAmYA;EACE,eAAA;EACA,cAAA;AAhYF;;AAmYA;EACE,kCAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;EACA,4CAAA;AAhYF;;AAmYA;EACE;IACE,UAAA;IACA,4BAAA;EAhYF;EAkYA;IACE,UAAA;IACA,wBAAA;EAhYF;AACF;AAmYA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAjYF;AAmYE;EACE,oCAAA;EACA,qBAAA;AAjYJ;;AAqYA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAlYF;AAoYE;EACE,yBAAA;EACA,2BAAA;EACA,wCAAA;AAlYJ;AAqYE;EACE,YAAA;EACA,mBAAA;AAnYJ;;AAuYA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AApYF;AAsYE;EACE,yBAAA;EACA,2BAAA;EACA,wCAAA;AApYJ;AAuYE;EACE,YAAA;EACA,mBAAA;AArYJ;;AAyYA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAtYF;AAwYE;EACE,yBAAA;EACA,2BAAA;EACA,wCAAA;AAtYJ;AAyYE;EACE,YAAA;EACA,mBAAA;AAvYJ;;AA4YE;EACE,mBAAA;AAzYJ;AA2YI;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAzYN;AA6YE;EACE,gBAAA;EACA,mBAAA;AA3YJ;AA8YE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AA5YJ;AA8YI;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AA5YN;AA+YI;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AA7YN;AAgZI;EACE,sBAAA;AA9YN;AAiZI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AA/YN;AAiZM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA/YR;AAmZI;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AAjZN;AAoZI;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAlZN;AAoZM;EACE,yBAAA;EACA,2BAAA;AAlZR;AAuZE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AArZJ;AAuZI;EACE,yBAAA;EACA,2BAAA;EACA,wCAAA;AArZN;;AA0ZA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;AAvZF;;AA0ZA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAvZF;AAyZE;EACE,qBAAA;AAvZJ;;AA2ZA;EACE,cAAA;AAxZF;AA0ZE;EACE,mBAAA;AAxZJ;;AA4ZA;EACE,cAAA;AAzZF;AA2ZE;EACE,mBAAA;AAzZJ;;AA6ZA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AA1ZF;;AA6ZA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AA1ZF;;AA6ZA;EACE,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AA1ZF;AA4ZE;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AA1ZJ;AA6ZE;EACE,cAAA;AA3ZJ;;AA+ZA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA5ZF;AA8ZE;EACE,mBAAA;EACA,2BAAA;AA5ZJ;AA+ZE;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;AA7ZJ;;AAiaA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA9ZF;AAgaE;EACE,mBAAA;EACA,2BAAA;AA9ZJ;;AAkaA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AA/ZF;;AAkaA;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AA/ZF;AAiaE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA/ZJ;;AAmaA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AAhaF;;AAmaA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAhaF;AAkaE;EACE,mBAAA;EACA,2BAAA;EACA,wCAAA;AAhaJ;;AAoaA;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAjaF;;AAoaA;EACE,SAAA;EACA,gBAAA;EACA,WAAA;AAjaF;;AAoaA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AAjaF;AAmaE;EACE,mBAAA;EACA,YAAA;AAjaJ;AAoaE;EACE,mBAAA;EACA,cAAA;AAlaJ;;AAsaA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAnaF;AAqaE;EACE,mBAAA;EACA,2BAAA;AAnaJ;;AAwaA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,yCAAA;EACA,yBAAA;AAraF;AAuaE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAraJ;AAuaI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAraN;AAwaI;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAtaN;AA0aE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AAxaJ;AA0aI;EACE,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;AAxaN;AA0aM;EACE,2BAAA;EACA,yCAAA;AAxaR;AA2aM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAzaR;AA4aM;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AA1aR;AA+aE;EACE,mBAAA;AA7aJ;AA+aI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gCAAA;AA7aN;AAgbI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AA9aN;AAgbM;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;AA9aR;AAgbQ;EACE,mBAAA;EACA,2BAAA;AA9aV;AAibQ;EACE,gBAAA;EACA,cAAA;AA/aV;AAkbQ;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAhbV;AAmbQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAjbV;AAsbI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AApbN;AAsbM;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AApbR;AAsbQ;EACE,mBAAA;EACA,2BAAA;EACA,wCAAA;AApbV;AAubQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AArbV;AAubU;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AArbZ;AAwbU;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAtbZ;AA2bU;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAzbZ;AA2bY;EACE,gBAAA;AAzbd;AA4bY;EACE,cAAA;EACA,gBAAA;AA1bd;AA6bY;EACE,cAAA;EACA,gBAAA;AA3bd;;AAqcA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,yCAAA;EACA,yBAAA;AAlcF;AAocE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAlcJ;AAocI;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAlcN;AAqcI;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAncN;AAucE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AArcJ;AAucI;EACE,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;AArcN;AAucM;EACE,2BAAA;EACA,yCAAA;AArcR;AAwcM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAtcR;AAycM;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AAvcR;AA4cE;EACE,mBAAA;AA1cJ;AA4cI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gCAAA;AA1cN;AA6cI;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;AA3cN;AA8cM;EACE,WAAA;AA5cR;AA+cM;EACE,mBAAA;EACA,kBAAA;AA7cR;AAgdM;EACE,gBAAA;EACA,kBAAA;AA9cR;AAgdQ;EACE,gBAAA;AA9cV;AAmdI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAjdN;AAmdM;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAjdR;AAodQ;EAAiB,gBAAA;AAjdzB;AAkdQ;EAAiB,gBAAA;AA/czB;AAgdQ;EAAiB,gBAAA;AA7czB;AA8cQ;EAAiB,gBAAA;AA3czB;AA4cQ;EAAiB,gBAAA;AAzczB;AA0cQ;EAAiB,gBAAA;AAvczB;AAwcQ;EAAiB,gBAAA;AArczB;AAscQ;EAAiB,gBAAA;AAnczB;AAocQ;EAAiB,gBAAA;AAjczB;AAkcQ;EAAkB,gBAAA;AA/b1B;AAicQ;EACE,6DAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;AA/bV;AAmcM;EACE,aAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAjcR;AAocM;EACE,sCAAA;AAlcR;AAocQ;EACE,yBAAA;AAlcV;AAqcQ;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAncV;AAqcU;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAncZ;AAqcY;EACE,2BAAA;AAncd;AAscY;EACE,mBAAA;EACA,YAAA;AApcd;AAucY;EACE,mBAAA;EACA,cAAA;AArcd;AAwcY;EACE,mBAAA;EACA,YAAA;AAtcd;AAycY;EACE,mBAAA;EACA,YAAA;AAvcd;AA0cY;EACE,mBAAA;EACA,YAAA;AAxcd;AAidE;EACE,mBAAA;AA/cJ;AAidI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gCAAA;AA/cN;AAkdI;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;AAhdN;AAmdM;EACE,WAAA;AAjdR;AAodM;EACE,mBAAA;EACA,kBAAA;AAldR;AAqdM;EACE,gBAAA;EACA,kBAAA;AAndR;AAqdQ;EACE,gBAAA;AAndV;AAwdI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAtdN;AAwdM;EACE,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AAtdR;AAwdQ;EACE,gBAAA;EACA,YAAA;EACA,6DAAA;EACA,gBAAA;EACA,OAAA;EACA,UAAA;AAtdV;AAydQ;EACE,gBAAA;EACA,YAAA;EACA,6DAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,6CAAA;AAvdV;AA0dQ;EACE,gBAAA;EACA,6DAAA;AAxdV;AA2dQ;EACE,eAAA;EACA,eAAA;AAzdV;AA4dQ;EACE,gBAAA;EACA,6DAAA;AA1dV;AA8dM;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AA5dR;AA8dQ;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AA5dV;AA+dQ;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,8CAAA;AA7dV;AAgeQ;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AA9dV;AAieQ;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,8CAAA;AA/dV;AAkeQ;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAheV;AAmeQ;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AAjeV;AAoeQ;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAleV;AAueQ;EACE,6DAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAreV;AAyeM;EACE,mBAAA;AAveR;AAyeQ;EACE,mBAAA;AAveV;AA0eQ;EACE,mBAAA;AAxeV;AA2eQ;EACE,mBAAA;AAzeV;AA4eQ;EACE,mBAAA;EACA,gBAAA;AA1eV;AA6eQ;EACE,mBAAA;EACA,cAAA;AA3eV;AAgfQ;EACE,yBAAA;AA9eV;AAkfM;EACE,mBAAA;AAhfR;AAkfQ;EACE,mBAAA;EACA,eAAA;AAhfV;AAmfQ;EACE,mBAAA;AAjfV;AAofQ;EACE,mBAAA;EACA,gBAAA;AAlfV;AAqfQ;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AAnfV;AA0fA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,yBAAA;EACA,iBAAA;AAxfF;AA2fE;;EAEE,gBAAA;EACA,OAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;AAzfJ;AA4fE;;EAEE,gBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CAAA;AA1fJ;AA6fE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AA3fJ;AA6fI;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AA3fN;AA8fI;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AA5fN;AA+fI;EACE,sCAAA;AA7fN;AA+fM;EACE,yBAAA;AA7fR;AAggBM;EACE,yBAAA;AA9fR;AAkgBI;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AAhgBN;AAkgBM;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAhgBR;AAmgBM;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAjgBR;AAqgBI;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;AAngBN;AAqgBM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAngBR;AAsgBM;EACE,kBAAA;AApgBR;AAugBM;EACE,yBAAA;EACA,eAAA;AArgBR;AA0gBE;EAEI;IACE,gBAAA;IACA,eAAA;EAzgBN;EA4gBI;IACE,gBAAA;IACA,gBAAA;EA1gBN;EA6gBI;IACE,WAAA;IACA,gBAAA;EA3gBN;AACF;AAghBA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AA9gBJ;AAghBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA9gBN;AAihBI;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AA/gBN;AAihBM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;AA/gBR;AAihBQ;EACE,2BAAA;EACA,yCAAA;AA/gBV;AAkhBQ;EACE,6DAAA;EACA,YAAA;AAhhBV;AAmhBQ;EACE,mBAAA;EACA,YAAA;AAjhBV;AAohBQ;EACE,6DAAA;EACA,YAAA;AAlhBV;;AA0hBA;EACE;IACE,aAAA;EAvhBF;EA0hBA;IACE,gBAAA;EAxhBF;EA2hBA;IACE,kBAAA;EAzhBF;EA2hBE;IACE,eAAA;EAzhBJ;EA6hBA;IACE,yBAAA;EA3hBF;EA8hBA;IACE,sBAAA;IACA,SAAA;EA5hBF;EA+hBA;IACE,eAAA;IACA,iBAAA;EA7hBF;AACF;AAgiBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA9hBF;AAgiBE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA9hBJ;AAgiBI;EACE,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,6CAAA;AA9hBN;AAiiBI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;EACA,6CAAA;AA/hBN;;AAqiBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,0BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yDAAA;AAliBF;;AAqiBA;EACE,6DAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,4DAAA;EACA,yBAAA;AAliBF;;AAqiBA;EACE,6DAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;AAliBF;AAoiBE;EACE,eAAA;EACA,mBAAA;EACA,2DAAA;AAliBJ;AAqiBE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;AAniBJ;AAsiBE;EACE,SAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AApiBJ;;AAwiBA;EACE,aAAA;EACA,iBAAA;AAriBF;AAuiBE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAriBJ;AAwiBE;EACE,6DAAA;EACA,YAAA;EACA,qCAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,0CAAA;EACA,uDAAA;AAtiBJ;AAyiBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAviBJ;AAyiBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAviBN;AAyiBM;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AAviBR;AA0iBM;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAxiBR;;AAgjBA;EACE,yBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AA7iBF;AA+iBE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA7iBJ;AAgjBE;EACE,6DAAA;EACA,YAAA;EACA,6CAAA;AA9iBJ;AAgjBI;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AA9iBN;AAijBI;EACE,wBAAA;AA/iBN;AAmjBI;EACE,6DAAA;EACA,6CAAA;AAjjBN;AAmjBM;EACE,6DAAA;EACA,6CAAA;AAjjBR;AAsjBE;EACE,6DAAA;EACA,YAAA;EACA,+CAAA;AApjBJ;AAsjBI;EACE,6DAAA;EACA,2BAAA;EACA,+CAAA;AApjBN;AAujBI;EACE,wBAAA;AArjBN;;AA0jBA;EACE,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;AAvjBF;AAyjBE;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAvjBJ;;AA2jBA;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAxjBF;;AA2jBA;EACE,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAxjBF;;AA2jBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gCAAA;EACA,6DAAA;EACA,cAAA;AAxjBF;AA0jBE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AAxjBJ;;AA4jBA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAzjBF;AA2jBE;EACE,qCAAA;AAzjBJ;;AA6jBA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1jBF;;AA6jBA;EACE,oBAAA;EACA,cAAA;AA1jBF;;AA6jBA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA1jBF;AA4jBE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA1jBJ;;AA8jBA;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA3jBF;AA6jBE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AA3jBJ;AA8jBE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AA5jBJ;AA+jBE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AA7jBJ;;AAikBA;EACE,uBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AA9jBF;;AAikBA;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AA9jBF;AAgkBE;EACE,mBAAA;AA9jBJ;;AAkkBA;EACE,mBAAA;EACA,cAAA;AA/jBF;AAikBE;EACE,mBAAA;AA/jBJ;AAkkBE;EACE,YAAA;EACA,mBAAA;AAhkBJ;;AAqkBA;EACE;IACE,UAAA;EAlkBF;EAokBA;IACE,UAAA;EAlkBF;AACF;AAqkBA;EACE;IACE,UAAA;IACA,sCAAA;EAnkBF;EAqkBA;IACE,UAAA;IACA,iCAAA;EAnkBF;AACF;AAskBA;EACE;IACE,UAAA;IACA,qBAAA;EApkBF;EAskBA;IACE,UAAA;IACA,sBAAA;EApkBF;EAskBA;IACE,qBAAA;EApkBF;EAskBA;IACE,UAAA;IACA,mBAAA;EApkBF;AACF;AAukBA;EACE;IACE,8CAAA;EArkBF;EAukBA;IACE,8CAAA;EArkBF;EAukBA;IACE,8CAAA;EArkBF;AACF;AAykBA;EACE;IACE,YAAA;EAvkBF;EA0kBA;IACE,8BAAA;EAxkBF;EA2kBA;IACE,kBAAA;EAzkBF;EA2kBE;IACE,kBAAA;EAzkBJ;EA6kBA;IACE,kBAAA;IACA,kBAAA;IACA,QAAA;EA3kBF;EA8kBA;IACE,mBAAA;EA5kBF;EA+kBA;IACE,uBAAA;IACA,8BAAA;EA7kBF;EAglBA;IACE,WAAA;EA9kBF;EAilBA;IACE,eAAA;IACA,YAAA;EA/kBF;EAklBA;IACE,4BAAA;EAhlBF;EAklBE;IACE,iBAAA;EAhlBJ;EAmlBE;IACE,iBAAA;EAjlBJ;EAqlBA;IACE,aAAA;EAnlBF;EAqlBE;IACE,iBAAA;IACA,aAAA;IACA,mBAAA;EAnlBJ;EAylBA;IACE,yBAAA;IACA,sBAAA;EAvlBF;EAylBE;IACE,eAAA;IACA,WAAA;EAvlBJ;EA2lBA;IACE,kBAAA;EAzlBF;EA2lBE;IACE,kBAAA;EAzlBJ;AACF","sourcesContent":[".capitalExpenditureContainer {\n  // max-width: 1400px;\n  // margin: 0 auto;\n  padding: 20px;\n  font-family: 'Arial', sans-serif;\n  background-color: #f8f9fa;\n  min-height: 100vh;\n  box-sizing: border-box;\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 30px;\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n  color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.universityTitle {\n  font-size: 28px;\n  font-weight: bold;\n  margin: 0 0 12px 0;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.currentYearBanner {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 10px;\n  margin: 0 auto 18px;\n  padding: 8px 18px;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  border-radius: 999px;\n  color: #fff;\n}\n\n.currentYearLabel {\n  font-size: 13px;\n  letter-spacing: 0.4px;\n  opacity: 0.9;\n}\n\n.currentYearValue {\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.navButtons {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  width: 100%;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.navButton {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  width: 220px !important;\n  min-width: 220px !important;\n  max-width: 220px !important;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 0 0 220px !important;\n  box-sizing: border-box;\n}\n\n.navButton:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n.navButton.active {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.navButton.activeTab {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  border-color: #28a745;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);\n  position: relative;\n}\n\n.navButton.activeTab::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #28a745, #20c997);\n  border-radius: 0 0 6px 6px;\n}\n\n.navButton.logoutButton {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n  color: white;\n  margin-left: auto;\n  \n  &:hover {\n    background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);\n  }\n}\n\n// Tab Button Styles for Report Tabs\n.tabButton {\n  background: #ffffff;\n  color: #495057;\n  border: 2px solid #dee2e6;\n  padding: 12px 20px;\n  border-radius: 8px 8px 0 0;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-right: 5px;\n  position: relative;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-bottom: none;\n  min-width: 160px;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tabButton:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.tabButton.activeTab {\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  color: white;\n  border-color: #007bff;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n  position: relative;\n  z-index: 10;\n}\n\n.tabButton.activeTab::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #007bff, #0056b3);\n  border-radius: 0 0 8px 8px;\n}\n\n.tabButton:not(.activeTab) {\n  background: #f8f9fa;\n  color: #6c757d;\n  border-color: #dee2e6;\n}\n\n.tabButton:not(.activeTab):hover {\n  background: #e9ecef;\n  color: #495057;\n  border-color: #adb5bd;\n}\n\n// Edit Form Styles\n.formInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n  background-color: #ffffff;\n  box-sizing: border-box;\n}\n\n.formInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.formInput::placeholder {\n  color: #adb5bd;\n  font-style: italic;\n}\n\n.formSelect {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n  background-color: #ffffff;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.formSelect:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.formRow {\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.formRow label {\n  min-width: 120px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.formRow span {\n  flex: 1;\n  padding: 10px 12px;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  color: #495057;\n  font-size: 14px;\n}\n\n.modeIndicator {\n  margin-bottom: 15px;\n  \n  .viewMode, .editMode {\n    display: inline-block;\n    padding: 8px 16px;\n    border-radius: 20px;\n    font-size: 14px;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n  \n  .viewMode {\n    background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);\n    color: white;\n  }\n  \n  .editMode {\n    background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);\n    color: #212529;\n  }\n}\n\n.officeDropdownContainer {\n  position: relative;\n  margin: 0 0 8px 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  justify-content: center;\n}\n\n.refreshButton {\n  background: linear-gradient(135deg, #ffc107 0%, #ff8c00 100%);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: bold;\n  text-align: center;\n  transition: all 0.3s ease;\n  border: none;\n  min-width: 140px;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.refreshButton:hover {\n  background: linear-gradient(135deg, #e0a800 0%, #e67e00 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.refreshButton:active {\n  transform: translateY(0);\n}\n\n.refreshButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  opacity: 0.6;\n}\n\n// Modal Overlay Styles\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backdrop-filter: blur(3px);\n  \n  .popupMessage {\n    position: relative;\n    z-index: 10000;\n    animation: modalSlideIn 0.3s ease-out;\n    margin: 20px;\n    max-width: 90vw;\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n// Refresh Popup Styles\n.refresh {\n  background: linear-gradient(135deg, #ffc107 0%, #ff8c00 100%);\n  color: white;\n  max-width: 500px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n  border-radius: 12px;\n  \n  .refreshPopupHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n    \n    h3 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: bold;\n    }\n  }\n  \n  .refreshPopupBody {\n    p {\n      margin: 0 0 20px 0;\n      font-size: 14px;\n      line-height: 1.5;\n    }\n  }\n  \n  .refreshPopupActions {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n    \n    .confirmButton, .cancelButton {\n      padding: 10px 20px;\n      border: none;\n      border-radius: 6px;\n      font-weight: bold;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      min-width: 120px;\n    }\n    \n    .confirmButton {\n      background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n      color: white;\n      \n      &:hover {\n        background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n        transform: translateY(-1px);\n      }\n    }\n    \n    .cancelButton {\n      background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n      color: white;\n      \n      &:hover {\n        background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);\n        transform: translateY(-1px);\n      }\n    }\n  }\n}\n\n.uploadSection {\n  margin-top: 15px;\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  width: 100%;\n  max-width: 400px;\n}\n\n.uploadLabel {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: bold;\n  color: white;\n  text-align: center;\n}\n\n.uploadInputContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.uploadInput {\n  position: absolute;\n  left: -9999px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.uploadButton {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: bold;\n  text-align: center;\n  transition: all 0.3s ease;\n  border: none;\n  min-width: 120px;\n  display: inline-block;\n}\n\n.uploadButton:hover {\n  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.uploadButton:active {\n  transform: translateY(0);\n}\n\n.uploadButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  opacity: 0.6;\n}\n\n.downloadTemplateButton {\n  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: bold;\n  text-align: center;\n  transition: all 0.3s ease;\n  border: none;\n  min-width: 120px;\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.downloadTemplateButton:hover {\n  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.downloadTemplateButton:active {\n  transform: translateY(0);\n}\n\n.downloadTemplateButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.selectedFileInfo {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin: 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: white;\n  font-size: 14px;\n}\n\n.clearFileButton {\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s ease;\n}\n\n.clearFileButton:hover {\n  background: #c82333;\n}\n\n.uploadingNote {\n  display: block;\n  color: #ffc107;\n  font-weight: bold;\n  text-align: center;\n  margin: 10px 0;\n  font-size: 14px;\n}\n\n.uploadWarning {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #856404;\n  \n  strong {\n    color: #856404;\n  }\n  \n  ul {\n    margin: 10px 0 0 20px;\n    padding: 0;\n    \n    li {\n      margin: 5px 0;\n      line-height: 1.4;\n    }\n  }\n}\n\n.uploadHint {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 12px;\n  text-align: center;\n  line-height: 1.4;\n  margin-top: 10px;\n}\n\n// Settings Component Styles\n.settingsContainer {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.settingsTitle {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.subTabNavigation {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.subTabButton {\n  background: none;\n  border: none;\n  padding: 15px 30px;\n  margin: 0 10px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #666;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s ease;\n\n  &:hover {\n    color: #007bff;\n  }\n\n  &.activeSubTab {\n    color: #007bff;\n    border-bottom-color: #007bff;\n  }\n}\n\n.listSettingsContent {\n  background: white;\n  border-radius: 10px;\n  padding: 30px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n\n  .uploadWarning {\n    margin-bottom: 20px;\n    padding: 15px;\n    background: #fff3cd;\n    border: 1px solid #ffeaa7;\n    border-radius: 6px;\n    font-size: 14px;\n    color: #856404;\n    \n    strong {\n      color: #856404;\n    }\n    \n    ul {\n      margin: 10px 0 0 20px;\n      padding: 0;\n      \n      li {\n        margin: 5px 0;\n        line-height: 1.4;\n      }\n    }\n  }\n  \n  .uploadHint {\n    color: #666;\n    font-size: 12px;\n    text-align: center;\n    line-height: 1.4;\n    margin-top: 10px;\n  }\n}\n\n.tokenSettingsContent {\n  background: white;\n  border-radius: 10px;\n  padding: 30px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  min-height: 500px;\n}\n\n\n\n\n\n\n\n.selectionInfo {\n  margin-bottom: 25px;\n}\n\n.infoBox {\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 8px;\n  padding: 20px;\n  color: #856404;\n\n  h4 {\n    margin: 0 0 15px 0;\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  p {\n    margin: 8px 0;\n    line-height: 1.5;\n  }\n\n  ul {\n    margin: 10px 0;\n    padding-left: 20px;\n\n    li {\n      margin: 5px 0;\n      line-height: 1.4;\n    }\n  }\n\n  strong {\n    font-weight: 600;\n  }\n}\n\n.masterItemsSection {\n  margin-top: 30px;\n  padding-top: 30px;\n  border-top: 2px solid #e0e0e0;\n\n  h3 {\n    color: #333;\n    font-size: 18px;\n    margin-bottom: 20px;\n    text-align: center;\n  }\n}\n\n.masterItemsTable {\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.masterItemsHeader {\n  display: grid;\n  grid-template-columns: 50px 120px 1fr 200px 120px;\n  gap: 15px;\n  background: #f8f9fa;\n  padding: 15px;\n  font-weight: bold;\n  color: #495057;\n  border-bottom: 2px solid #dee2e6;\n  font-size: 14px;\n}\n\n.headerCheckbox {\n  text-align: center;\n  width: 50px;\n  flex-shrink: 0;\n  \n  input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    accent-color: #007bff;\n    \n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n}\n\n.headerCode {\n  font-weight: bold;\n  color: #495057;\n}\n\n.headerTitle {\n  font-weight: bold;\n  color: #495057;\n}\n\n.headerType {\n  font-weight: bold;\n  color: #495057;\n}\n\n.headerActions {\n  font-weight: bold;\n  color: #495057;\n  text-align: center;\n}\n\n.masterItemsList {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.masterItem {\n  display: grid;\n  grid-template-columns: 50px 120px 1fr 200px 120px;\n  gap: 15px;\n  align-items: center;\n  padding: 15px;\n  background: white;\n  border-bottom: 1px solid #e9ecef;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f8f9fa;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.itemCode {\n  background: #007bff;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: bold;\n  min-width: 80px;\n  text-align: center;\n}\n\n.itemTitle {\n  flex: 1;\n  font-weight: 500;\n  color: #333;\n}\n\n.itemType {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n\n  &.capital {\n    background: #28a745;\n    color: white;\n  }\n\n  &.operational {\n    background: #ffc107;\n    color: #212529;\n  }\n}\n\n.itemCheckbox {\n  text-align: center;\n  width: 50px;\n  flex-shrink: 0;\n  \n  input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    accent-color: #007bff;\n    \n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n}\n\n.itemActions {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n}\n\n.successBox {\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  border-radius: 8px;\n  padding: 20px;\n  color: #155724;\n\n  h4 {\n    margin: 0 0 15px 0;\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  p {\n    margin: 8px 0;\n    line-height: 1.5;\n  }\n}\n\n.officeDropdown {\n  background: rgba(255, 255, 255, 0.95);\n  color: #000000;\n  padding: 12px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 18px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.officeDropdown:hover {\n  background: rgba(255, 255, 255, 1);\n  border-color: #2a5298;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.officeDropdown.required {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n}\n\n.officeDropdown.required:hover {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.2);\n}\n\n.selectedOffice {\n  flex: 1;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dropdownArrow {\n  margin-left: 10px;\n  font-size: 12px;\n  transition: transform 0.3s ease;\n}\n\n.officeDropdownMenu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  margin-top: 5px;\n  max-height: 400px;\n  overflow: hidden;\n  animation: slideDown 0.3s ease-out;\n}\n\n.searchContainer {\n  padding: 15px;\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.officeSearchInput {\n  width: 100%;\n  padding: 10px 15px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  color: #000000;\n  transition: border-color 0.2s ease;\n}\n\n.officeSearchInput:focus {\n  outline: none;\n  border-color: #2a5298;\n  box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1);\n}\n\n.officeOptionsList {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.officeOption {\n  padding: 12px 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  border-bottom: 1px solid #f1f3f4;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #000000;\n}\n\n.officeOption:hover {\n  background-color: #f8f9fa;\n}\n\n.officeOption.selected {\n  background-color: #e3f2fd;\n  color: #000000;\n  font-weight: 600;\n}\n\n.noResults {\n  padding: 20px;\n  text-align: center;\n  color: #000000;\n  font-style: italic;\n}\n\n// Category dropdown styles\n.categoryDropdownContainer {\n  position: relative;\n  width: 100%;\n}\n\n.categoryDropdown {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  min-height: 38px;\n  transition: border-color 0.2s;\n\n  &:hover {\n    border-color: #007bff;\n  }\n}\n\n.selectedCategory {\n  color: #333;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.categoryDropdownMenu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-height: 300px;\n  overflow: hidden;\n  animation: slideDown 0.2s ease-out;\n}\n\n.categoryOptionsList {\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.categoryOption {\n  padding: 8px 12px;\n  cursor: pointer;\n  color: #000000;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n\n  &:hover {\n    background-color: #f8f9fa;\n  }\n\n  &.selected {\n    background-color: #e3f2fd;\n    color: #000000;\n    font-weight: 600;\n  }\n}\n\n.categorySearchInput {\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  border-bottom: 1px solid #ddd;\n  outline: none;\n  font-size: 14px;\n  color: #000000;\n  background: transparent;\n\n  &::placeholder {\n    color: #999;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fiscalYear {\n  font-size: 18px;\n  margin: 0;\n  font-weight: 500;\n}\n\n\n\n// Message styles\n.message {\n  padding: 15px 20px;\n  margin: 20px 0;\n  border-radius: 6px;\n  font-weight: bold;\n  text-align: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  animation: slideIn 0.3s ease-out;\n}\n\n.success {\n  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n  color: #155724;\n  border: 2px solid #28a745;\n}\n\n.error {\n  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n  color: #721c24;\n  border: 2px solid #dc3545;\n}\n\n.info {\n  background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%);\n  color: #0c5460;\n  border: 2px solid #17a2b8;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Clear prompt modal styles\n.clearPrompt {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.clearPromptContent {\n  background: white;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  max-width: 400px;\n  width: 90%;\n  animation: scaleIn 0.3s ease-out;\n}\n\n.clearPromptContent h3 {\n  color: #1e3c72;\n  margin-bottom: 15px;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.clearPromptContent p {\n  color: #6c757d;\n  margin-bottom: 25px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.clearPromptButtons {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n.clearButton {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.clearButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.clearButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.keepButton {\n  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.keepButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.keepButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.expenditureForm {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n// Form Header\n.formHeader {\n  margin-bottom: 25px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n  \n  .formInfo {\n    display: flex;\n    gap: 30px;\n    align-items: center;\n    flex-wrap: wrap;\n    \n    .infoGroup {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      \n      label {\n        font-weight: 600;\n        color: #495057;\n        font-size: 14px;\n      }\n      \n      .fiscalYearSelect {\n        padding: 10px 15px;\n        border: 1px solid #ced4da;\n        border-radius: 6px;\n        font-size: 14px;\n        min-width: 200px;\n        background: white;\n        \n        &:focus {\n          outline: none;\n          border-color: #1e3c72;\n          box-shadow: 0 0 0 2px rgba(30, 60, 114, 0.2);\n        }\n        \n        &:disabled {\n          background: #e9ecef;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n}\n\n.tableContainer {\n  overflow-x: auto;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  min-width: 100%;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n}\n\n// Responsive table behavior\n@media (max-width: 1200px) {\n  .expenditureTable {\n    min-width: 1000px;\n  }\n  \n  .titleCell .inputField {\n    max-width: 300px;\n  }\n}\n\n@media (max-width: 768px) {\n  .expenditureTable {\n    min-width: 1200px;\n  }\n  \n  .titleCell .inputField {\n    max-width: 250px;\n  }\n}\n\n.dataViewYearBar {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 14px;\n  padding: 10px 14px;\n  background: #e8f0fb;\n  border: 1px solid #c5d4eb;\n  border-radius: 6px;\n  color: #1e3c72;\n  font-size: 15px;\n\n  strong {\n    font-size: 18px;\n  }\n\n  em {\n    font-style: normal;\n    color: #4a678a;\n    font-size: 13px;\n  }\n}\n\n// Data-view responsiveness overrides (keeps current colors/theme)\n.dataViewContainer {\n  max-width: 100%;\n\n  .filtersSection {\n    > .filterActions {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 10px;\n      width: 100%;\n    }\n\n    > .filterActions .tabButton {\n      min-width: 0;\n      margin-right: 0;\n      padding: 10px 14px;\n    }\n\n    > .filterActions .filterToggleButton,\n    > .filterActions .refreshButton,\n    > .filterActions .excelButton,\n    > .filterActions .bulkDeleteButton {\n      max-width: 100%;\n      padding: 10px 14px;\n      font-size: 13px;\n      letter-spacing: 0;\n      text-transform: none;\n    }\n  }\n}\n\n.detailedReportTabs {\n  flex-wrap: wrap;\n  row-gap: 10px;\n}\n\n@media (max-width: 1200px) {\n  .dataViewContainer {\n    padding: 20px;\n\n    .filtersSection > .filterActions .tabButton {\n      font-size: 13px;\n      padding: 9px 12px;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .dataViewContainer {\n    .filtersSection > .filterActions {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 8px;\n    }\n\n    .filtersSection > .filterActions .tabButton,\n    .filtersSection > .filterActions .filterToggleButton,\n    .filtersSection > .filterActions .refreshButton,\n    .filtersSection > .filterActions .excelButton,\n    .filtersSection > .filterActions .bulkDeleteButton {\n      width: 100%;\n      justify-content: center;\n      text-align: center;\n    }\n  }\n\n  .detailedReportTabs {\n    padding: 0;\n  }\n}\n\n// Frozen left columns (कोड नं. | खर्च शिर्षक | बिनियोजित | परिमार्जीत)\n$sticky-col1-w: 90px;\n$sticky-col2-w: 220px;\n$sticky-col3-w: 110px;\n$sticky-col4-w: 110px;\n$sticky-left-2: $sticky-col1-w;\n$sticky-left-3: $sticky-col1-w + $sticky-col2-w;\n$sticky-left-4: $sticky-col1-w + $sticky-col2-w + $sticky-col3-w;\n$sticky-group4-w: $sticky-col1-w + $sticky-col2-w + $sticky-col3-w + $sticky-col4-w;\n$sticky-group2-w: $sticky-col1-w + $sticky-col2-w;\n\n.stickyCol1 {\n  position: sticky !important;\n  left: 0 !important;\n  z-index: 4;\n  width: $sticky-col1-w;\n  min-width: $sticky-col1-w;\n  max-width: $sticky-col1-w;\n}\n\n.stickyCol2 {\n  position: sticky !important;\n  left: $sticky-left-2 !important;\n  z-index: 4;\n  width: $sticky-col2-w;\n  min-width: $sticky-col2-w;\n  max-width: $sticky-col2-w;\n}\n\n.stickyCol3 {\n  position: sticky !important;\n  left: $sticky-left-3 !important;\n  z-index: 4;\n  width: $sticky-col3-w;\n  min-width: $sticky-col3-w;\n  max-width: $sticky-col3-w;\n}\n\n.stickyCol4 {\n  position: sticky !important;\n  left: $sticky-left-4 !important;\n  z-index: 4;\n  width: $sticky-col4-w;\n  min-width: $sticky-col4-w;\n  max-width: $sticky-col4-w;\n  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.15);\n}\n\n.stickyColGroup2 {\n  position: sticky !important;\n  left: 0 !important;\n  z-index: 4;\n  width: $sticky-group2-w !important;\n  min-width: $sticky-group2-w !important;\n  max-width: $sticky-group2-w !important;\n  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.15);\n}\n\n.stickyColGroup4 {\n  position: sticky !important;\n  left: 0 !important;\n  z-index: 4;\n  min-width: $sticky-group4-w;\n  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.15);\n}\n\n.categoryCellSticky {\n  position: sticky !important;\n  left: 0 !important;\n  z-index: 4;\n  background: #f4d03f !important;\n  color: #000;\n  font-weight: bold;\n  text-align: left;\n  padding: 12px 8px;\n  border: 1px solid #000;\n  font-size: 16px;\n  box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.15);\n}\n\n.totalLabel {\n  font-weight: bold;\n  text-align: center;\n  white-space: normal;\n  line-height: 1.25;\n  font-size: 13px;\n  word-break: break-word;\n}\n\n.expenditureTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 2px solid #000;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  min-width: 800px;\n  table-layout: auto;\n  \n  // Enhanced header styling\n  .mainHeader {\n    background: linear-gradient(135deg, #f39c12, #e67e22);\n    color: white;\n    font-weight: bold;\n    text-align: center;\n    \n    th {\n      padding: 12px 8px;\n      border: 1px solid #d68910;\n      vertical-align: middle;\n      font-size: 15px;\n      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n      white-space: nowrap;\n      min-width: 80px;\n      position: relative;\n      \n      &:hover {\n        background: linear-gradient(135deg, #e67e22, #d68910);\n        transform: scale(1.02);\n        transition: all 0.2s ease;\n      }\n    }\n  }\n  \n  .subHeader {\n    background: linear-gradient(135deg, #e67e22, #d68910);\n    color: white;\n    font-weight: 600;\n    \n    th {\n      padding: 10px 6px;\n      border: 1px solid #d68910;\n      text-align: center;\n      font-size: 13px;\n      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);\n      white-space: nowrap;\n    }\n  }\n  \n  // Specific header column styles (also frozen on horizontal scroll)\n  .codeHeader {\n    min-width: $sticky-col1-w;\n    width: $sticky-col1-w;\n    background: linear-gradient(135deg, #3498db, #2980b9) !important;\n    border: 2px solid #2980b9 !important;\n    position: sticky !important;\n    left: 0 !important;\n    z-index: 6;\n\n    &:hover {\n      transform: none;\n    }\n  }\n  \n  .titleHeader {\n    min-width: $sticky-col2-w;\n    width: $sticky-col2-w;\n    background: linear-gradient(135deg, #9b59b6, #8e44ad) !important;\n    border: 2px solid #8e44ad !important;\n    position: sticky !important;\n    left: $sticky-left-2 !important;\n    z-index: 6;\n\n    &:hover {\n      transform: none;\n    }\n  }\n  \n  .budgetHeader {\n    min-width: $sticky-col3-w;\n    width: $sticky-col3-w;\n    background: linear-gradient(135deg, #e67e22, #d68910) !important;\n    border: 2px solid #d68910 !important;\n  }\n\n  .budgetHeaderSticky3 {\n    position: sticky !important;\n    left: $sticky-left-3 !important;\n    z-index: 6;\n    min-width: $sticky-col3-w !important;\n    width: $sticky-col3-w !important;\n\n    &:hover {\n      transform: none;\n    }\n  }\n\n  .budgetHeaderSticky4 {\n    position: sticky !important;\n    left: $sticky-left-4 !important;\n    z-index: 6;\n    min-width: $sticky-col4-w !important;\n    width: $sticky-col4-w !important;\n    box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.2);\n\n    &:hover {\n      transform: none;\n    }\n  }\n  \n  .quarterHeader {\n    min-width: 250px;\n    background: linear-gradient(135deg, #f39c12, #e67e22) !important;\n    border: 2px solid #d68910 !important;\n    color: white !important;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  }\n  \n  .summaryHeader {\n    min-width: 250px;\n    background: linear-gradient(135deg, #27ae60, #2ecc71) !important;\n    border: 2px solid #27ae60 !important;\n    color: white !important;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  }\n  \n  .differenceHeader {\n    min-width: 120px;\n    background: linear-gradient(135deg, #e74c3c, #c0392b) !important;\n    border: 2px solid #e74c3c !important;\n    color: white !important;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n  }\n  \n  .subHeaderCell {\n    min-width: 80px;\n    font-size: 12px;\n    padding: 8px 4px;\n  }\n  \n  // Ensure proper column alignment\n  th, td {\n    box-sizing: border-box;\n    vertical-align: middle;\n  }\n  \n  // Add subtle borders for better visual separation\n  th {\n    border-right: 1px solid rgba(255, 255, 255, 0.3);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n    \n    &:last-child {\n      border-right: none;\n    }\n  }\n}\n\n.addRowButtons {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n  \n  .addRowButton {\n    flex: 1;\n    min-width: 200px;\n    padding: 10px 15px;\n    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    \n    &:hover {\n      background: linear-gradient(135deg, #218838 0%, #1aa179 100%);\n      transform: translateY(-2px);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    }\n    \n    &:active {\n      transform: translateY(0);\n      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);\n    }\n    \n    &:disabled {\n      background: #6c757d;\n      cursor: not-allowed;\n      opacity: 0.6;\n      transform: none;\n      box-shadow: none;\n    }\n  }\n}\n\n// Enhanced table header styling\n.mainHeader {\n  background: linear-gradient(135deg, #f39c12, #e67e22);\n  color: white;\n  font-weight: bold;\n  text-align: center;\n  border: 1px solid #d68910;\n  \n  th {\n    padding: 12px 8px;\n    border: 1px solid #d68910;\n    font-size: 15px;\n    white-space: nowrap;\n    vertical-align: middle;\n    min-width: 80px;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n    position: relative;\n    \n    &:hover {\n      background: linear-gradient(135deg, #e67e22, #d68910);\n      transform: scale(1.02);\n      transition: all 0.2s ease;\n    }\n  }\n}\n\n.quarterHeader {\n  background: linear-gradient(135deg, #f39c12, #e67e22) !important;\n  color: white !important;\n  font-weight: bold;\n  text-align: center;\n  border: 2px solid #d68910 !important;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n// Sub header row with individual column names\n.subHeader {\n  background: linear-gradient(135deg, #e67e22, #d68910);\n  color: white;\n  font-weight: 600;\n  text-align: center;\n  border: 1px solid #d68910;\n  \n  th {\n    padding: 10px 6px;\n    border: 1px solid #d68910;\n    font-size: 13px;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);\n    white-space: nowrap;\n  }\n}\n\n.codeColumn {\n  width: 100px;\n  background: #f4d03f;\n}\n\n.titleColumn {\n  width: 200px;\n  background: #f4d03f;\n}\n\n.budgetColumn {\n  width: 120px;\n  background: #f4d03f;\n}\n\n.actionColumn {\n  width: 100px;\n  background: #f4d03f;\n}\n\n// Category row for \"Capital Expenditure\"\n.categoryRow {\n  background: #f4d03f; // Light peach/orange color from image\n  border: 1px solid #000;\n}\n\n.categoryCell {\n  background: #f4d03f !important; // Light peach/orange color from image\n  color: #000;\n  font-weight: bold;\n  text-align: left;\n  padding: 12px 8px;\n  border: 1px solid #000;\n  font-size: 16px;\n\n  &.stickyColGroup4 {\n    background: #f4d03f !important;\n  }\n}\n\n.dataRow {\n  background: #f8f9fa;\n  transition: background-color 0.2s ease;\n  border: 1px solid #000;\n}\n\n.dataRow:hover {\n  background: #e9ecef;\n}\n\n.dataRow td {\n  padding: 8px;\n  border: 1px solid #000;\n  vertical-align: middle;\n}\n\n.codeCell {\n  background: #e7f3ff;\n  text-align: center;\n  min-width: $sticky-col1-w;\n  width: $sticky-col1-w;\n  white-space: nowrap;\n}\n\n.titleCell {\n  background: #f0f8ff;\n  min-width: $sticky-col2-w;\n  width: $sticky-col2-w;\n  word-wrap: break-word;\n  white-space: normal;\n}\n\n.budgetCell {\n  background: #f8f9fa;\n  text-align: center;\n  min-width: 80px;\n  width: auto;\n}\n\n// Sticky body cells keep opaque backgrounds while scrolling\n.stickyCol1.codeCell,\n.codeCell.stickyCol1 {\n  background: #e7f3ff !important;\n}\n\n.stickyCol2.titleCell,\n.titleCell.stickyCol2 {\n  background: #f0f8ff !important;\n}\n\n.stickyCol3.budgetCell,\n.budgetCell.stickyCol3,\n.stickyCol4.budgetCell,\n.budgetCell.stickyCol4 {\n  background: #f8f9fa !important;\n}\n\n.actionCell {\n  background: #fff5f5;\n  text-align: center;\n}\n\n.inputField {\n  width: 100%;\n  padding: 8px 6px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  background: white;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n  min-width: 0;\n  resize: horizontal;\n}\n\n.inputField:focus {\n  outline: none;\n  border-color: #2c5aa0;\n  box-shadow: 0 0 0 3px rgba(44, 90, 160, 0.1);\n}\n\n.inputField::placeholder {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.removeButton {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.removeButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.removeButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n// Flexible input field styles for content-based expansion\n.codeCell .inputField {\n  min-width: 80px;\n  max-width: 150px;\n  text-align: center;\n}\n\n.titleCell .inputField {\n  min-width: 160px;\n  max-width: 220px;\n  text-align: left;\n  resize: none;\n}\n\n.budgetCell .inputField {\n  min-width: 60px;\n  max-width: 200px;\n  text-align: center;\n}\n\n.addRowContainer {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n  background: #f8f9fa;\n  border-top: 1px solid #dee2e6;\n}\n\n.addRowButton {\n  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.addRowButton:hover {\n  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.totalRow {\n  background: #d4edda;\n  font-weight: bold;\n  color: #155724;\n  position: relative;\n  overflow: visible; // required for sticky left columns\n\n  input {\n    border: none !important;\n    background: transparent !important;\n    font-weight: bold;\n    text-align: center;\n    width: 100%;\n    padding: 4px;\n    box-sizing: border-box;\n  }\n\n  .stickyColGroup2,\n  .stickyCol3,\n  .stickyCol4 {\n    background: #e8f5e9 !important;\n  }\n}\n\n.incomeRow {\n  background: #d6eaf8 !important;\n  color: #1a5276 !important;\n\n  .incomeLabel {\n    background: #2980b9 !important;\n    color: #fff !important;\n    font-size: 13px;\n    letter-spacing: 0.2px;\n    width: $sticky-group2-w !important;\n    min-width: $sticky-group2-w !important;\n    max-width: $sticky-group2-w !important;\n    white-space: normal;\n  }\n\n  .incomeCell {\n    background: #ebf5fb !important;\n  }\n\n  .incomeSpacer {\n    background: #eaf2f8 !important;\n  }\n\n  .stickyColGroup2,\n  .stickyCol3,\n  .stickyCol4 {\n    background: #d4e6f1 !important;\n  }\n\n  input {\n    background: #fff !important;\n    border: 1px solid #85c1e9 !important;\n    border-radius: 2px !important;\n    color: #1a5276 !important;\n    padding: 4px !important;\n  }\n\n  td:hover {\n    transform: none !important;\n  }\n}\n\n.totalRow td {\n  padding: 8px;\n  border: 1px solid #000;\n  background: #e8f5e9;\n  text-align: center;\n  font-weight: bold;\n  color: #155724;\n  font-size: 14px;\n  vertical-align: middle;\n  // Match data-row budget cells so columns line up\n  min-width: 80px;\n}\n\n.totalRow td.stickyColGroup2,\n.totalRow td:first-child {\n  background: #c3e6cb;\n  color: #155724;\n  font-weight: bold;\n  text-align: center;\n  width: $sticky-group2-w !important;\n  min-width: $sticky-group2-w !important;\n  max-width: $sticky-group2-w !important;\n}\n\n.totalRow td.stickyCol3 {\n  min-width: $sticky-col3-w !important;\n  width: $sticky-col3-w !important;\n  max-width: $sticky-col3-w !important;\n}\n\n.totalRow td.stickyCol4 {\n  min-width: $sticky-col4-w !important;\n  width: $sticky-col4-w !important;\n  max-width: $sticky-col4-w !important;\n}\n\n.totalRow:hover td {\n  transform: none;\n}\n\n.incomeRow td {\n  background: #eaf2f8;\n  border: 1px solid #000;\n}\n\n.incomeRow td.incomeCell {\n  background: #ebf5fb;\n}\n\n.incomeRow td.incomeLabel {\n  background: #2980b9 !important;\n  color: #fff !important;\n}\n\n.totalInputField {\n  width: 100%;\n  padding: 8px 12px;\n  border: 2px solid #34495e;\n  border-radius: 4px;\n  font-size: 14px;\n  text-align: center;\n  background: #ffffff;\n  font-weight: 600;\n  color: #2c3e50;\n  min-height: 36px;\n  box-sizing: border-box;\n  \n  &:focus {\n    outline: none;\n    border-color: #3498db;\n    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.25);\n  }\n  \n  &:hover {\n    border-color: #2980b9;\n  }\n  \n  &::placeholder {\n    color: #6c757d;\n  }\n}\n\n// Hide borders for other financial summary rows\n.totalRow:not(:first-of-type) .totalInputField {\n  border: none;\n  background: transparent;\n  \n  &:focus {\n    border: 1px solid #3498db;\n    background: #ffffff;\n  }\n  \n  &:hover {\n    background: #f8f9fa;\n  }\n}\n\n\n\n.buttonContainer {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  justify-content: center;\n  margin: 2rem 0;\n  flex-wrap: wrap;\n}\n\n.loadDataButton {\n  background-color: #17a2b8;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n\n  &:hover:not(:disabled) {\n    background-color: #138496;\n  }\n\n  &:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n  }\n}\n\n.submitButton {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.submitButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.submitButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.resetButton {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.resetButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.resetButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.updateButton {\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.updateButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.updateButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.cancelButton {\n  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.cancelButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.cancelButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n// Read-only input styles\n.readOnly {\n  background-color: #f8f9fa !important;\n  color: #495057 !important;\n  cursor: not-allowed !important;\n  border: 1px solid #ced4da !important;\n}\n\n.readOnly:focus {\n  outline: none !important;\n  box-shadow: none !important;\n  border-color: #ced4da !important;\n}\n\n// Disabled dropdown styles\n.disabled {\n  background-color: #f8f9fa !important;\n  color: #6c757d !important;\n  cursor: not-allowed !important;\n  border: 1px solid #ced4da !important;\n  opacity: 0.7;\n}\n\n.disabled:hover {\n  background-color: #f8f9fa !important;\n  border-color: #ced4da !important;\n  transform: none !important;\n}\n\n// Data view action buttons\n.viewButton, .editButton, .deleteButton {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin: 2px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.actionButtons {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 15px;\n  padding-top: 10px;\n  border-top: 1px solid #dee2e6;\n}\n\n.viewButton {\n  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);\n  color: white;\n  font-size: 16px;\n  padding: 10px 12px;\n}\n\n.viewButton:hover {\n  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(23, 162, 184, 0.3);\n}\n\n.editButton {\n  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);\n  color: #212529;\n  font-size: 16px;\n  padding: 10px 12px;\n}\n\n.editButton:hover {\n  background: linear-gradient(135deg, #e0a800 0%, #d39e00 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(255, 193, 7, 0.3);\n}\n\n.deleteButton {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  font-size: 16px;\n  padding: 10px 12px;\n}\n\n.deleteButton:hover {\n  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);\n}\n\n// Quarterly Section Styles\n.quarterSection {\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  \n  &:not(:last-child) {\n    margin-bottom: 40px;\n  }\n}\n\n.quarterHeader {\n  color: #2c3e50;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n// Financial Summary Styles\n.financialSummaryCell {\n  padding: 0 !important;\n  border: none !important;\n  background: #f8f9fa;\n}\n\n.financialSummary {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 15px 0;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n  \n  th, td {\n    padding: 12px 15px;\n    text-align: left;\n    border-bottom: 1px solid #e9ecef;\n  }\n  \n  .summaryHeader {\n    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n    color: white;\n    font-size: 16px;\n    font-weight: 600;\n    text-align: left;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding: 12px 15px;\n  }\n  \n  .summaryRow {\n    transition: background-color 0.2s ease;\n    \n    &:hover {\n      background-color: #f8f9fa;\n    }\n    \n    .summaryLabel {\n      font-weight: 500;\n      color: #343a40;\n      width: 70%;\n    }\n    \n    .summaryValue {\n      font-family: 'Courier New', monospace;\n      font-weight: 600;\n      color: #1e3c72;\n      text-align: right;\n      width: 30%;\n    }\n  }\n  \n\n  \n\n  \n\n  \n  \n\n  .summaryTotalRow {\n    background-color: #f1f8ff;\n    \n    .summaryLabel {\n      font-weight: 600;\n      color: #1e3c72;\n    }\n    \n    .summaryValue {\n      font-weight: 700;\n      color: #1e3c72;\n    }\n  }\n  \n  .highlightRow {\n    background-color: #e6f7ff;\n    border-top: 2px solid #b3e0ff;\n    border-bottom: 2px solid #b3e0ff;\n    \n    .summaryLabel, .summaryValue {\n      font-weight: 700;\n      color: #0056b3;\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 1400px) {\n  .capitalExpenditureContainer {\n    max-width: 100%;\n    // margin: 0 auto;\n  }\n}\n\n@media (max-width: 1200px) {\n  .capitalExpenditureContainer {\n    padding: 15px;\n  }\n  \n  .header {\n    padding: 15px;\n  }\n  \n  .universityTitle {\n    font-size: 24px;\n  }\n  \n  .navButton {\n    width: 200px !important;\n    min-width: 200px !important;\n    max-width: 200px !important;\n    flex: 0 0 200px !important;\n    font-size: 13px;\n    padding: 10px 15px;\n  }\n  \n  .tableContainer {\n    padding: 15px;\n  }\n  \n  .mainHeader th,\n  .subHeader th {\n    font-size: 12px;\n    padding: 8px 4px;\n  }\n  \n  .inputField {\n    font-size: 12px;\n    padding: 6px 4px;\n  }\n  \n  .removeButton {\n    font-size: 10px;\n    padding: 4px 8px;\n  }\n}\n\n@media (max-width: 768px) {\n  .capitalExpenditureContainer {\n    padding: 10px;\n    margin: 0 auto;\n  }\n  \n  .header {\n    padding: 10px 5px;\n    margin-bottom: 20px;\n  }\n  \n  .universityTitle {\n    font-size: 20px;\n    margin-bottom: 15px;\n  }\n  \n  .navButtons {\n    flex-direction: column;\n    gap: 10px;\n    align-items: center;\n  }\n  \n  .navButton {\n    width: 100% !important;\n    max-width: 300px !important;\n    min-width: unset !important;\n    flex: 0 0 auto !important;\n    font-size: 12px;\n    padding: 10px 15px;\n  }\n  \n  .officeDropdown {\n    font-size: 16px;\n    padding: 10px 15px;\n  }\n  \n  .selectedOffice {\n    font-size: 14px;\n  }\n  \n  .officeDropdownMenu {\n    max-height: 300px;\n  }\n  \n  .officeOption {\n    padding: 10px 15px;\n    font-size: 13px;\n  }\n  \n  .fiscalYear {\n    font-size: 14px;\n  }\n  \n  .categoryCell {\n    font-size: 14px;\n  }\n  \n  .tableContainer {\n    padding: 10px;\n    overflow-x: auto;\n  }\n  \n  .expenditureTable {\n    min-width: 800px;\n  }\n  \n  .buttonContainer {\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n  }\n  \n  .submitButton,\n  .resetButton,\n  .backButton,\n  .updateButton,\n  .cancelButton,\n  .excelButton,\n  .printButton,\n  .applyFilterButton,\n  .clearFilterButton {\n    width: 100%;\n    max-width: 300px;\n  }\n  \n  .addRowButton {\n    font-size: 14px;\n    padding: 10px 20px;\n  }\n  \n  .clearPromptContent {\n    padding: 20px;\n    margin: 20px;\n  }\n  \n  .clearPromptButtons {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .clearButton,\n  .keepButton {\n    width: 100%;\n  }\n  \n  .dataViewContainer {\n    padding: 15px;\n    \n    .dataList {\n      grid-template-columns: 1fr;\n      gap: 15px;\n    }\n  }\n  \n  // Mobile table improvements\n  .dataTableContainer {\n    .dataTable {\n      min-width: 600px; // Smaller minimum width on mobile\n      \n      th {\n        min-width: 100px; // Smaller minimum width for headers on mobile\n        \n        &:nth-child(1) { min-width: 120px; } // संस्था\n        &:nth-child(2) { min-width: 110px; } // आर्थिक वर्ष\n        &:nth-child(3) { min-width: 100px; } // सिर्जना मिति\n        &:nth-child(4) { min-width: 100px; } // अन्तिम अपडेट\n        &:nth-child(5) { min-width: 90px; }  // स्थिति\n        &:nth-child(6) { min-width: 150px; } // कार्यहरू\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .capitalExpenditureContainer {\n    padding: 5px;\n  }\n  \n  .header {\n    padding: 10px 5px;\n  }\n  \n  .universityTitle {\n    font-size: 18px;\n  }\n  \n  .navButton {\n    font-size: 11px;\n    padding: 8px 12px;\n  }\n  \n  .officeDropdown {\n    font-size: 14px;\n    padding: 8px 12px;\n  }\n  \n  .fiscalYear {\n    font-size: 12px;\n  }\n  \n  .tableContainer {\n    padding: 5px;\n  }\n  \n  .mainHeader th,\n  .subHeader th {\n    font-size: 10px;\n    padding: 6px 2px;\n  }\n  \n  .inputField {\n    font-size: 10px;\n    padding: 4px 2px;\n  }\n  \n  .categoryCell {\n    font-size: 12px;\n  }\n}\n\n// Print styles\n@media print {\n  .capitalExpenditureContainer {\n    background: white;\n    box-shadow: none;\n  }\n  \n  .buttonContainer,\n  .addRowContainer {\n    display: none;\n  }\n  \n  .expenditureTable {\n    box-shadow: none;\n    border: 2px solid #000;\n  }\n  \n  .mainHeader,\n  .subHeader,\n  .categoryRow {\n    background: #f4d03f !important;\n    color: #000 !important;\n  }\n  \n  .actionCell {\n    display: none;\n  }\n  \n  .clearPrompt {\n    display: none;\n  }\n  \n  .tokenDisplay {\n    display: none;\n  }\n}\n\n// Token Display Styles\n.tokenDisplay {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n  padding: 20px;\n  margin: 20px 0;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  animation: fadeIn 0.5s ease-in-out;\n  \n  .tokenInfo {\n    color: white;\n    text-align: center;\n    \n    h4 {\n      margin: 0 0 15px 0;\n      font-size: 18px;\n      font-weight: 600;\n      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    }\n    \n    .tokenDetails {\n      display: flex;\n      justify-content: center;\n      gap: 30px;\n      margin-bottom: 15px;\n      flex-wrap: wrap;\n      \n      span {\n        background: rgba(255, 255, 255, 0.1);\n        padding: 8px 16px;\n        border-radius: 8px;\n        border: 1px solid rgba(255, 255, 255, 0.2);\n        font-size: 14px;\n        \n        strong {\n          color: #ffd700;\n          margin-right: 5px;\n        }\n      }\n    }\n    \n    .tokenNote {\n      margin: 0;\n      font-size: 14px;\n      opacity: 0.9;\n      font-style: italic;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .tokenDisplay {\n    margin: 15px 0;\n    padding: 15px;\n    \n    .tokenInfo {\n      h4 {\n        font-size: 16px;\n      }\n      \n      .tokenDetails {\n        flex-direction: column;\n        gap: 10px;\n        \n        span {\n          font-size: 13px;\n          padding: 6px 12px;\n        }\n      }\n      \n      .tokenNote {\n        font-size: 13px;\n      }\n    }\n  }\n}\n\n// Data View Styles\n.dataViewContainer {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin: 20px 0;\n  \n  h3 {\n    color: #1e3c72;\n    font-size: 24px;\n    margin-bottom: 25px;\n    text-align: center;\n    border-bottom: 3px solid #1e3c72;\n    padding-bottom: 10px;\n  }\n  \n  // Filters Section\n  .filtersSection {\n    margin-bottom: 30px;\n    \n    .filterToggleButton {\n      background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n      color: white;\n      border: none;\n      padding: 12px 24px;\n      border-radius: 6px;\n      font-size: 14px;\n      font-weight: bold;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      \n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 8px rgba(30, 60, 114, 0.3);\n      }\n    }\n    \n    .filtersContainer {\n      background: #f8f9fa;\n      border: 1px solid #dee2e6;\n      border-radius: 8px;\n      padding: 20px;\n      \n      .filterRow {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 15px;\n        flex-wrap: wrap;\n        \n        .filterGroup {\n          flex: 1;\n          min-width: 200px;\n          \n          label {\n            display: block;\n            margin-bottom: 5px;\n            font-weight: 600;\n            color: #495057;\n          }\n          \n          input, select {\n            width: 100%;\n            padding: 8px 12px;\n            border: 1px solid #ced4da;\n            border-radius: 4px;\n            font-size: 14px;\n            \n            &:focus {\n              outline: none;\n              border-color: #1e3c72;\n              box-shadow: 0 0 0 2px rgba(30, 60, 114, 0.2);\n            }\n          }\n        }\n      }\n      \n      .filterActions {\n        display: flex;\n        gap: 15px;\n        justify-content: center;\n        \n        button {\n          padding: 10px 20px;\n          border: none;\n          border-radius: 6px;\n          font-size: 14px;\n          font-weight: 600;\n          cursor: pointer;\n          transition: all 0.3s ease;\n          \n          &.applyFiltersButton {\n            background: #28a745;\n            color: white;\n            \n            &:hover {\n              background: #218838;\n              transform: translateY(-1px);\n            }\n          }\n          \n          &.clearFiltersButton {\n            background: #6c757d;\n            color: white;\n            \n            &:hover {\n              background: #5a6268;\n              transform: translateY(-1px);\n            }\n          }\n        }\n      }\n    }\n  }\n  \n  // Data Table\n  .dataTableContainer {\n    overflow-x: auto;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    position: relative;\n    \n    // Scroll indicator\n    &::after {\n      content: \"← → स्क्रोल गर्नुहोस्\";\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      background: rgba(0, 0, 0, 0.7);\n      color: white;\n      padding: 5px 10px;\n      border-radius: 15px;\n      font-size: 12px;\n      font-weight: 500;\n      z-index: 5;\n      pointer-events: none;\n      opacity: 0.8;\n    }\n    \n    // Custom scrollbar styling\n    &::-webkit-scrollbar {\n      height: 8px;\n    }\n    \n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 4px;\n    }\n    \n    &::-webkit-scrollbar-thumb {\n      background: #888;\n      border-radius: 4px;\n      \n      &:hover {\n        background: #555;\n      }\n    }\n    \n    .loading {\n      text-align: center;\n      padding: 40px;\n      font-size: 18px;\n      color: #6c757d;\n    }\n    \n      .dataTable {\n    width: 100%;\n    border-collapse: collapse;\n    background: white;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    min-width: 800px; // Ensure minimum width for all columns\n    \n    th {\n      background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n      color: white;\n      padding: 15px 12px;\n      text-align: left;\n      font-weight: 600;\n      font-size: 14px;\n      white-space: nowrap; // Prevent text wrapping\n      min-width: 120px; // Minimum width for each header\n      position: relative; // For tooltip positioning\n      \n      // Specific column widths for better readability\n      &:nth-child(1) { min-width: 150px; } // संस्था (Institution)\n      &:nth-child(2) { min-width: 140px; } // आर्थिक वर्ष (Fiscal Year)\n      &:nth-child(3) { min-width: 130px; } // सिर्जना मिति (Creation Date)\n      &:nth-child(4) { min-width: 130px; } // अन्तिम अपडेट (Last Update)\n      &:nth-child(5) { min-width: 120px; } // स्थिति (Status)\n      &:nth-child(6) { min-width: 200px; } // कार्यहरू (Actions)\n      \n      // Hover effect to show full text\n      &:hover {\n        background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);\n        transform: scale(1.02);\n        transition: all 0.2s ease;\n        z-index: 10;\n      }\n    }\n    \n    td {\n      padding: 12px;\n      border-bottom: 1px solid #dee2e6;\n      font-size: 14px;\n      color: #495057;\n      white-space: nowrap; // Prevent text wrapping in cells\n    }\n      \n      .dataRow {\n        transition: background-color 0.2s ease;\n        \n        &:hover {\n          background-color: #f8f9fa;\n        }\n        \n        .statusBadge {\n          padding: 4px 8px;\n          border-radius: 12px;\n          font-size: 12px;\n          font-weight: 600;\n          text-transform: uppercase;\n          \n          &.draft {\n            background: #ffc107;\n            color: #212529;\n          }\n          \n          &.submitted {\n            background: #17a2b8;\n            color: white;\n          }\n          \n          &.approved {\n            background: #28a745;\n            color: white;\n          }\n          \n          &.rejected {\n            background: #dc3545;\n            color: white;\n          }\n          \n          &.completed {\n            background: #6f42c1;\n            color: white;\n          }\n        }\n        \n        .actionButtons {\n          display: flex;\n          gap: 8px;\n          flex-wrap: wrap;\n          \n          button {\n            padding: 6px 12px;\n            border: none;\n            border-radius: 4px;\n            font-size: 12px;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            \n            &.viewButton {\n              background: #17a2b8;\n              color: white;\n              \n              &:hover {\n                background: #138496;\n              }\n            }\n            \n            &.editButton {\n              background: #ffc107;\n              color: #212529;\n              \n              &:hover {\n                background: #e0a800;\n              }\n            }\n            \n            &.exportButton {\n              background: #28a745;\n              color: white;\n              font-size: 16px;\n              \n              &:hover {\n                background: #218838;\n              }\n            }\n            \n            &.printButton {\n              background: #6c757d;\n              color: white;\n              font-size: 16px;\n              \n              &:hover {\n                background: #5a6268;\n              }\n            }\n            \n            &.deleteButton {\n              background: #dc3545;\n              color: white;\n              \n              &:hover {\n                background: #c82333;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  \n  // No Data Message\n  .noDataMessage {\n    text-align: center;\n    padding: 40px;\n    color: #6c757d;\n    font-size: 16px;\n    \n    p {\n      margin: 0;\n    }\n  }\n  \n  // Edit Modal\n  .editModal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n\n  .editModalContent {\n    background: white;\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n    max-width: 500px;\n    width: 90%;\n    max-height: 80vh;\n    overflow-y: auto;\n\n    h3 {\n      margin: 0 0 20px 0;\n      color: #333;\n      text-align: center;\n    }\n  }\n\n  .editForm {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .formGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    label {\n      font-weight: 600;\n      color: #495057;\n      font-size: 14px;\n    }\n\n    input, select {\n      padding: 12px;\n      border: 1px solid #ced4da;\n      border-radius: 6px;\n      font-size: 14px;\n      transition: border-color 0.2s ease;\n\n      &:focus {\n        outline: none;\n        border-color: #007bff;\n        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n      }\n    }\n  }\n\n  .editActions {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n    margin-top: 10px;\n  }\n\n  .saveButton, .cancelButton {\n    padding: 12px 24px;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  .saveButton {\n    background: #28a745;\n    color: white;\n\n    &:hover {\n      background: #218838;\n      transform: translateY(-1px);\n    }\n  }\n\n  .cancelButton {\n    background: #6c757d;\n    color: white;\n\n    &:hover {\n      background: #5a6268;\n      transform: translateY(-1px);\n    }\n  }\n  \n  .dataViewActions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-bottom: 30px;\n    flex-wrap: wrap;\n  }\n  \n  .dataList {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n    \n    .dataItem {\n      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n      border: 2px solid #dee2e6;\n      border-radius: 10px;\n      padding: 20px;\n      transition: all 0.3s ease;\n      \n      &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n        border-color: #1e3c72;\n      }\n      \n      h4 {\n        color: #1e3c72;\n        font-size: 18px;\n        margin: 0 0 15px 0;\n        font-weight: 600;\n      }\n      \n      p {\n        margin: 8px 0;\n        color: #495057;\n        font-size: 14px;\n        \n        &:first-of-type {\n          font-weight: 600;\n          color: #28a745;\n        }\n      }\n    }\n  }\n  \n  p {\n    text-align: center;\n    color: #6c757d;\n    font-size: 16px;\n    font-style: italic;\n  }\n}\n\n@media (max-width: 768px) {\n  .dataViewContainer {\n    padding: 20px;\n    margin: 15px 0;\n    \n    h3 {\n      font-size: 20px;\n    }\n    \n    .dataList {\n      grid-template-columns: 1fr;\n      gap: 15px;\n      \n      .dataItem {\n        padding: 15px;\n        \n        h4 {\n          font-size: 16px;\n        }\n        \n        p {\n          font-size: 13px;\n        }\n      }\n    }\n  }\n}\n\n.excelButton {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.excelButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.excelButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.summaryButton {\n  background: linear-gradient(135deg, #6f42c1 0%, #8e44ad 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.summaryButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #5a32a3 0%, #7d3c98 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.summaryButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.detailedReportButton {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.detailedReportButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.detailedReportButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.bulkDeleteButton {\n  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);\n  margin-left: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  \n  &:hover:not(:disabled) {\n    background: linear-gradient(135deg, #ff5252 0%, #d63031 100%);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);\n  }\n  \n  &:active {\n    transform: translateY(0);\n  }\n  \n  &:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n    opacity: 0.6;\n  }\n}\n\n.infoButton {\n  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.infoButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.infoButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.printButton {\n  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);\n  color: white;\n  border: none;\n  padding: 12px 30px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.printButton:hover:not(:disabled) {\n  background: linear-gradient(135deg, #138496 0%, #117a8b 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.printButton:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n// Checkbox Styles\n.dataTable th:first-child,\n.dataTable td:first-child {\n  text-align: center;\n  width: 50px;\n  \n  input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    accent-color: #007bff;\n    \n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n}\n\n// Settings Checkbox Styles\n.masterItemsHeader .headerCheckbox,\n.masterItem .itemCheckbox {\n  text-align: center;\n  width: 50px;\n  flex-shrink: 0;\n  \n  input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    accent-color: #007bff;\n    \n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n}\n\n// Filter Styles\n.filterContainer {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid #dee2e6;\n}\n\n.filterHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  \n  h4 {\n    color: #1e3c72;\n    font-size: 18px;\n    font-weight: bold;\n    margin: 0;\n  }\n}\n\n.filterToggle {\n  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filterToggle:hover {\n  background: linear-gradient(135deg, #5a6268 0%, #495057 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.filterForm {\n  border-top: 1px solid #dee2e6;\n  padding-top: 15px;\n}\n\n.filterRow {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.filterGroup {\n  flex: 1;\n  min-width: 200px;\n  \n  label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: bold;\n    color: #495057;\n    font-size: 14px;\n  }\n}\n\n.filterInput,\n.filterSelect {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  background: white;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n}\n\n.filterInput:focus,\n.filterSelect:focus {\n  outline: none;\n  border-color: #2c5aa0;\n  box-shadow: 0 0 0 3px rgba(44, 90, 160, 0.1);\n}\n\n.filterInput::placeholder {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.filterActions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.filterToggleButton {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n\n  &:hover:not(:disabled) {\n    background-color: #5a6268;\n  }\n\n  &:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n  }\n}\n\n.refreshButton {\n  background-color: #17a2b8;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n\n  &:hover:not(:disabled) {\n    background-color: #138496;\n  }\n\n  &:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n  }\n}\n\n.applyFilterButton {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.applyFilterButton:hover {\n  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.clearFilterButton {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.clearFilterButton:hover {\n  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.filterInfo {\n  background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%);\n  border: 1px solid #17a2b8;\n  border-radius: 6px;\n  padding: 15px;\n  margin-top: 20px;\n  text-align: center;\n  \n  p {\n    color: #0c5460;\n    font-weight: bold;\n    margin: 0;\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .filterContainer {\n    padding: 15px;\n  }\n  \n  .filterRow {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .filterGroup {\n    min-width: unset;\n  }\n  \n  .filterActions {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .filterToggle {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n}\n\n// ============================================================================\n// QUARTER SELECTOR AND ACTION BUTTONS\n// ============================================================================\n\n.quarterSelector {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.quarterButton {\n  padding: 0.75rem 1.5rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  color: #495057;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  \n  &:hover {\n    border-color: #667eea;\n    color: #667eea;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.2);\n  }\n  \n  &.active {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border-color: transparent;\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n  }\n}\n\n.actionButtons {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n  flex-wrap: wrap;\n}\n\n.addRowButton {\n  padding: 0.75rem 1.5rem;\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  \n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n  }\n}\n\n.submitButton {\n  padding: 0.75rem 1.5rem;\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  \n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n  }\n  \n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.resetButton {\n  padding: 0.75rem 1.5rem;\n  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  \n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\n  }\n  \n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.noData {\n  text-align: center;\n  padding: 3rem;\n  color: #6c757d;\n  \n  .noDataContent {\n    max-width: 600px;\n    margin: 0 auto;\n    \n    h3 {\n      color: #495057;\n      margin-bottom: 20px;\n      font-size: 24px;\n    }\n    \n    p {\n      margin: 15px 0;\n      font-size: 16px;\n      line-height: 1.6;\n    }\n  }\n  \n  .noDataActions {\n    margin-top: 30px;\n    \n    .primaryButton {\n      background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n      color: white;\n      border: none;\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 16px;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);\n      margin-bottom: 25px;\n      \n      &:hover:not(:disabled) {\n        transform: translateY(-2px);\n        box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\n      }\n      \n      &:disabled {\n        background: #6c757d;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n    \n    .noDataInstructions {\n      text-align: left;\n      background: #f8f9fa;\n      border: 1px solid #dee2e6;\n      border-radius: 8px;\n      padding: 20px;\n      margin-top: 20px;\n      \n      h4 {\n        color: #495057;\n        margin-bottom: 15px;\n        font-size: 18px;\n        text-align: center;\n      }\n      \n      ol {\n        margin: 0;\n        padding-left: 20px;\n        \n        li {\n          margin: 8px 0;\n          line-height: 1.5;\n          color: #6c757d;\n        }\n      }\n    }\n  }\n}\n\n.editForm {\n  margin-bottom: 1.5rem;\n  \n  .formRow {\n    display: flex;\n    margin-bottom: 0.75rem;\n    padding: 0.5rem 0;\n    border-bottom: 1px solid #e9ecef;\n    \n    label {\n      flex: 0 0 150px;\n      font-weight: 600;\n      color: #495057;\n    }\n    \n    span {\n      flex: 1;\n      color: #212529;\n      padding-left: 1rem;\n    }\n  }\n}\n\n.fiscalYearContainer {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 1rem 0;\n  \n  .fiscalYearLabel {\n    font-weight: 600;\n    color: #333;\n    white-space: nowrap;\n  }\n  \n  .fiscalYearSelect {\n    padding: 0.5rem;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 1rem;\n    background-color: white;\n    min-width: 200px;\n    \n    &:focus {\n      outline: none;\n      border-color: #007bff;\n      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n    }\n    \n    &.disabled {\n      background-color: #f8f9fa;\n      color: #6c757d;\n      cursor: not-allowed;\n      border-color: #dee2e6;\n    }\n  }\n\n  .fiscalYearLocked {\n    min-width: 200px;\n    padding: 0.55rem 0.9rem;\n    border: 1px solid #c5d4eb;\n    border-radius: 4px;\n    background: #eef4fb;\n    color: #1e3c72;\n    font-size: 1rem;\n    font-weight: 700;\n    text-align: center;\n    cursor: default;\n    user-select: none;\n  }\n}\n\n.toggleViewButton {\n  padding: 0.75rem 1.5rem;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-right: 1rem;\n  \n  &:hover {\n    background-color: #218838;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);\n  }\n  \n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.viewModeInfo {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  background-color: #e3f2fd;\n  border: 1px solid #2196f3;\n  border-radius: 6px;\n  \n  .viewModeText {\n    font-weight: 600;\n    color: #1976d2;\n    font-size: 1rem;\n  }\n}\n\n/* Popup Message Styles */\n.popupMessage {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n  animation: slideInRight 0.3s ease-out;\n}\n\n.popupContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 300px;\n  max-width: 400px;\n  position: relative;\n}\n\n.popupContent.success {\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.popupContent.error {\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.popupContent.warning {\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  color: #856404;\n}\n\n.popupContent.info {\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  color: #0c5460;\n}\n\n.popupText {\n  font-size: 14px;\n  font-weight: 500;\n  flex: 1;\n  margin-right: 12px;\n}\n\n.popupClose {\n  background: none;\n  border: none;\n  font-size: 20px;\n  font-weight: bold;\n  color: inherit;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n  \n  &:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideOutRight {\n  from {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  to {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n}\n\n.popupMessage.hiding {\n  animation: slideOutRight 0.3s ease-in;\n}\n\n.newDataButton {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  margin-right: 12px;\n  \n  &:hover:not(:disabled) {\n    background-color: #218838;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  &:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n  \n  &:active:not(:disabled) {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n}\n\n// Edit Form Styles - Full Width Popup Modal\n.editFormContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 20px;\n  overflow-y: auto;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.editFormContent {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  width: 100%;\n  max-width: 100%;\n  max-height: 95vh;\n  overflow-y: auto;\n  position: relative;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.editFormHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e9ecef;\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n  color: white;\n  border-radius: 12px 12px 0 0;\n  position: relative;\n  \n  h2 {\n    margin: 0;\n    color: white;\n    font-size: 28px;\n    font-weight: bold;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  }\n}\n\n.editFormActions {\n  display: flex;\n  gap: 15px;\n  margin-right: 60px; /* Add space for the close button */\n}\n\n.headerContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 10px;\n}\n\n.currentYearFormNote {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #d6eaf8;\n}\n\n.editFormYearSwitch {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 4px;\n\n  label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #e8f1fb;\n    white-space: nowrap;\n  }\n\n  select {\n    min-width: 180px;\n    padding: 6px 10px;\n    border: 1px solid rgba(255, 255, 255, 0.45);\n    border-radius: 6px;\n    background: rgba(255, 255, 255, 0.95);\n    color: #1e3c72;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n\n    &:disabled {\n      opacity: 0.7;\n      cursor: wait;\n    }\n  }\n}\n\n.yearSwitchLoading {\n  font-size: 12px;\n  color: #f8e9a1;\n}\n\n.successMessage {\n  background: rgba(40, 167, 69, 0.9);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  animation: slideDown 0.3s ease-out;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  position: absolute;\n  top: 15px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 20px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  \n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n    transform: scale(1.1);\n  }\n}\n\n.cancelButton {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  \n  &:hover:not(:disabled) {\n    background-color: #5a6268;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.saveButton {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  \n  &:hover:not(:disabled) {\n    background-color: #0056b3;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.downloadExcelButton {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  \n  &:hover:not(:disabled) {\n    background-color: #218838;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.editForm {\n  .section {\n    margin-bottom: 40px;\n    \n    h3 {\n      color: #2c3e50;\n      font-size: 20px;\n      margin-bottom: 20px;\n      padding-bottom: 10px;\n      border-bottom: 1px solid #dee2e6;\n    }\n  }\n  \n  .tableContainer {\n    overflow-x: auto;\n    margin-bottom: 20px;\n  }\n  \n  .expenditureTable {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    background: white;\n    \n    th, td {\n      padding: 12px 8px;\n      text-align: left;\n      border: 1px solid #dee2e6;\n      font-size: 14px;\n    }\n    \n    th {\n      background-color: #f8f9fa;\n      font-weight: 600;\n      color: #495057;\n    }\n    \n    td {\n      vertical-align: middle;\n    }\n    \n    .inputField {\n      width: 100%;\n      padding: 8px;\n      border: 1px solid #ced4da;\n      border-radius: 4px;\n      font-size: 14px;\n      \n      &:focus {\n        outline: none;\n        border-color: #007bff;\n        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n      }\n    }\n    \n    .remainingBalance {\n      background-color: #f8f9fa;\n      font-weight: 500;\n      color: #495057;\n    }\n    \n    .removeButton {\n      background-color: #dc3545;\n      color: white;\n      border: none;\n      padding: 6px 12px;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 12px;\n      transition: all 0.2s ease;\n      \n      &:hover {\n        background-color: #c82333;\n        transform: translateY(-1px);\n      }\n    }\n  }\n  \n  .addRowButton {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    \n    &:hover {\n      background-color: #218838;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    }\n  }\n}\n\n.itemActions {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.editButton, .deleteButton {\n  background: none;\n  border: none;\n  padding: 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: all 0.2s ease;\n\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n\n.editButton {\n  color: #007bff;\n  \n  &:hover {\n    background: #e3f2fd;\n  }\n}\n\n.deleteButton {\n  color: #dc3545;\n  \n  &:hover {\n    background: #ffebee;\n  }\n}\n\n.searchSection {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  border: 1px solid #e9ecef;\n}\n\n.searchInputContainer {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.searchInput {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n\n  &:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n  }\n\n  &::placeholder {\n    color: #6c757d;\n  }\n}\n\n.searchButton {\n  padding: 12px 20px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #0056b3;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n.clearSearchButton {\n  padding: 12px 20px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #5a6268;\n    transform: translateY(-1px);\n  }\n}\n\n.searchHint {\n  color: #6c757d;\n  font-size: 12px;\n  text-align: center;\n}\n\n.searchResults {\n  margin-top: 20px;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  h4 {\n    margin: 0 0 15px 0;\n    color: #333;\n    font-size: 16px;\n    text-align: center;\n  }\n}\n\n.resultsList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.resultItem {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #e9ecef;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n}\n\n.resultCode {\n  background: #007bff;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: bold;\n  min-width: 80px;\n  text-align: center;\n}\n\n.resultTitle {\n  flex: 1;\n  font-weight: 500;\n  color: #333;\n}\n\n.resultType {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n\n  &.capital {\n    background: #28a745;\n    color: white;\n  }\n\n  &.operational {\n    background: #ffc107;\n    color: #212529;\n  }\n}\n\n.populateButton {\n  padding: 8px 16px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #218838;\n    transform: translateY(-1px);\n  }\n}\n\n// Summary Report Styles\n.summaryReportSection {\n  background: white;\n  border-radius: 12px;\n  padding: 25px;\n  margin: 20px 0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n\n  .summaryHeader {\n    text-align: center;\n    margin-bottom: 30px;\n    padding-bottom: 20px;\n    border-bottom: 2px solid #f8f9fa;\n\n    h3 {\n      margin: 0 0 10px 0;\n      color: #2c3e50;\n      font-size: 24px;\n      font-weight: bold;\n    }\n\n    p {\n      margin: 0;\n      color: #6c757d;\n      font-size: 16px;\n    }\n  }\n\n  .summaryStats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 20px;\n    margin-bottom: 30px;\n\n    .statCard {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: white;\n      padding: 25px;\n      border-radius: 12px;\n      text-align: center;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      transition: all 0.3s ease;\n\n      &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n      }\n\n      .statTitle {\n        font-size: 14px;\n        font-weight: 600;\n        margin-bottom: 10px;\n        opacity: 0.9;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n      }\n\n      .statValue {\n        font-size: 28px;\n        font-weight: bold;\n        margin: 0;\n      }\n    }\n  }\n\n  .breakdownSection {\n    margin-bottom: 30px;\n\n    h4 {\n      color: #2c3e50;\n      font-size: 18px;\n      font-weight: bold;\n      margin: 0 0 20px 0;\n      padding-bottom: 10px;\n      border-bottom: 2px solid #e9ecef;\n    }\n\n    .statusBreakdown {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n      gap: 15px;\n\n      .statusItem {\n        background: #f8f9fa;\n        padding: 20px;\n        border-radius: 8px;\n        border: 1px solid #e9ecef;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: #e9ecef;\n          transform: translateY(-2px);\n        }\n\n        .statusName {\n          font-weight: 600;\n          color: #495057;\n        }\n\n        .statusCount {\n          background: #007bff;\n          color: white;\n          padding: 6px 12px;\n          border-radius: 20px;\n          font-weight: bold;\n          font-size: 14px;\n        }\n\n        .statusPercentage {\n          color: #6c757d;\n          font-size: 14px;\n          font-weight: 500;\n        }\n      }\n    }\n\n    .institutionBreakdown {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n      gap: 20px;\n\n      .institutionItem {\n        background: #f8f9fa;\n        border: 1px solid #e9ecef;\n        border-radius: 8px;\n        padding: 20px;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: #e9ecef;\n          transform: translateY(-2px);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        }\n\n        .institutionHeader {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          margin-bottom: 15px;\n          padding-bottom: 10px;\n          border-bottom: 1px solid #dee2e6;\n\n          .institutionName {\n            font-weight: bold;\n            color: #2c3e50;\n            font-size: 16px;\n          }\n\n          .institutionCount {\n            background: #28a745;\n            color: white;\n            padding: 4px 10px;\n            border-radius: 12px;\n            font-size: 12px;\n            font-weight: 600;\n          }\n        }\n\n        .institutionDetails {\n          .detailRow {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            margin-bottom: 8px;\n            padding: 8px 0;\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n\n            span:first-child {\n              color: #6c757d;\n              font-weight: 500;\n            }\n\n            span:last-child {\n              color: #2c3e50;\n              font-weight: 600;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// Detailed Report Styles\n.detailedReportSection {\n  background: white;\n  border-radius: 12px;\n  padding: 25px;\n  margin: 20px 0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n\n  .detailedHeader {\n    text-align: center;\n    margin-bottom: 30px;\n    padding-bottom: 20px;\n    border-bottom: 2px solid #f8f9fa;\n\n    h3 {\n      margin: 0 0 10px 0;\n      color: #2c3e50;\n      font-size: 24px;\n      font-weight: bold;\n    }\n\n    p {\n      margin: 0;\n      color: #6c757d;\n      font-size: 16px;\n    }\n  }\n\n  .detailedStats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 20px;\n    margin-bottom: 30px;\n\n    .statCard {\n      background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n      color: white;\n      padding: 25px;\n      border-radius: 12px;\n      text-align: center;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      transition: all 0.3s ease;\n\n      &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n      }\n\n      .statTitle {\n        font-size: 14px;\n        font-weight: 600;\n        margin-bottom: 10px;\n        opacity: 0.9;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n      }\n\n      .statValue {\n        font-size: 28px;\n        font-weight: bold;\n        margin: 0;\n      }\n    }\n  }\n\n  .detailedTableContainer {\n    margin-bottom: 30px;\n\n    h4 {\n      color: #2c3e50;\n      font-size: 18px;\n      font-weight: bold;\n      margin: 0 0 20px 0;\n      padding-bottom: 10px;\n      border-bottom: 2px solid #e9ecef;\n    }\n\n    .tableWrapper {\n      overflow-x: auto;\n      border-radius: 8px;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      \n      // Custom scrollbar styling\n      &::-webkit-scrollbar {\n        height: 8px;\n      }\n      \n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 4px;\n      }\n      \n      &::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 4px;\n        \n        &:hover {\n          background: #555;\n        }\n      }\n    }\n\n    .detailedTable {\n      width: 100%;\n      border-collapse: collapse;\n      background: white;\n      border-radius: 8px;\n      overflow: hidden;\n      min-width: 1200px; // Ensure enough width for all columns\n      \n      th {\n        background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n        color: white;\n        padding: 15px 12px;\n        text-align: left;\n        font-weight: 600;\n        font-size: 14px;\n        white-space: nowrap;\n        min-width: 120px;\n        \n        // Specific column widths for detailed table\n        &:nth-child(1) { min-width: 150px; } // संस्था\n        &:nth-child(2) { min-width: 140px; } // आर्थिक वर्ष\n        &:nth-child(3) { min-width: 120px; } // टोकन\n        &:nth-child(4) { min-width: 120px; } // स्थिति\n        &:nth-child(5) { min-width: 130px; } // कुल बजेट\n        &:nth-child(6) { min-width: 130px; } // कुल खर्च\n        &:nth-child(7) { min-width: 130px; } // शेष रकम\n        &:nth-child(8) { min-width: 130px; } // सिर्जना मिति\n        &:nth-child(9) { min-width: 130px; } // अन्तिम अपडेट\n        &:nth-child(10) { min-width: 200px; } // कार्यहरू\n        \n        &:hover {\n          background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);\n          transform: scale(1.02);\n          transition: all 0.2s ease;\n          z-index: 10;\n        }\n      }\n      \n      td {\n        padding: 12px;\n        border-bottom: 1px solid #dee2e6;\n        font-size: 14px;\n        color: #495057;\n        white-space: nowrap;\n      }\n      \n      .detailedRow {\n        transition: background-color 0.2s ease;\n        \n        &:hover {\n          background-color: #f8f9fa;\n        }\n        \n        .detailedActions {\n          display: flex;\n          gap: 5px;\n          flex-wrap: wrap;\n          \n          button {\n            padding: 6px 10px;\n            border: none;\n            border-radius: 4px;\n            font-size: 12px;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            \n            &:hover {\n              transform: translateY(-1px);\n            }\n            \n            &.viewButton {\n              background: #17a2b8;\n              color: white;\n            }\n            \n            &.editButton {\n              background: #ffc107;\n              color: #212529;\n            }\n            \n            &.exportButton {\n              background: #28a745;\n              color: white;\n            }\n            \n            &.printButton {\n              background: #6c757d;\n              color: white;\n            }\n            \n            &.deleteButton {\n              background: #dc3545;\n              color: white;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Summary.xlsx Format Table Styles\n  .summaryExcelTableContainer {\n    margin-bottom: 30px;\n\n    h4 {\n      color: #2c3e50;\n      font-size: 18px;\n      font-weight: bold;\n      margin: 0 0 20px 0;\n      padding-bottom: 10px;\n      border-bottom: 2px solid #e9ecef;\n    }\n\n    .tableWrapper {\n      overflow-x: auto;\n      border-radius: 8px;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      \n      // Custom scrollbar styling\n      &::-webkit-scrollbar {\n        height: 8px;\n      }\n      \n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 4px;\n      }\n      \n      &::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 4px;\n        \n        &:hover {\n          background: #555;\n        }\n      }\n    }\n\n    .summaryExcelTable {\n      width: 100%;\n      border-collapse: separate;\n      border-spacing: 0;\n      background: white;\n      border-radius: 8px;\n      overflow: visible;\n      min-width: 2000px; // Ensure enough width for all 22 columns\n      border: 2px solid #dee2e6;\n      \n      th {\n        background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n        color: white;\n        padding: 12px 8px;\n        text-align: center;\n        font-weight: 600;\n        font-size: 12px;\n        white-space: nowrap;\n        border: 1px solid #dee2e6;\n        \n        &.budgetCodeHeader {\n          min-width: 100px;\n          width: 100px;\n          background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n          position: sticky;\n          left: 0;\n          z-index: 5;\n        }\n        \n        &.budgetTitleHeader {\n          min-width: 300px;\n          width: 300px;\n          background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n          position: sticky;\n          left: 100px;\n          z-index: 5;\n          box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.2);\n        }\n        \n        &.codeNumberHeader {\n          min-width: 120px;\n          background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);\n        }\n        \n        &.institutionHeader {\n          min-width: 80px;\n          font-size: 11px;\n        }\n        \n        &.totalHeader {\n          min-width: 100px;\n          background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);\n        }\n      }\n      \n      td {\n        padding: 8px 6px;\n        border: 1px solid #dee2e6;\n        font-size: 12px;\n        text-align: center;\n        vertical-align: middle;\n        \n        &.budgetCode {\n          background: #f8f9fa;\n          font-weight: 600;\n          color: #2c3e50;\n          text-align: center;\n          position: sticky;\n          left: 0;\n          z-index: 3;\n          min-width: 100px;\n          width: 100px;\n        }\n        \n        &.budgetTitle {\n          background: #f8f9fa;\n          font-weight: 600;\n          color: #2c3e50;\n          text-align: left;\n          padding-left: 12px;\n          position: sticky;\n          left: 100px;\n          z-index: 3;\n          min-width: 300px;\n          width: 300px;\n          box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.12);\n        }\n\n        &.budgetCodeCell {\n          background: #f8f9fa;\n          font-weight: 600;\n          color: #2c3e50;\n          text-align: center;\n          position: sticky;\n          left: 0;\n          z-index: 3;\n          min-width: 100px;\n          width: 100px;\n        }\n\n        &.budgetTitleCell {\n          background: #f8f9fa;\n          font-weight: 600;\n          color: #2c3e50;\n          text-align: left;\n          padding-left: 12px;\n          position: sticky;\n          left: 100px;\n          z-index: 3;\n          min-width: 300px;\n          width: 300px;\n          box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.12);\n        }\n        \n        &.codeNumber {\n          background: #f0f8ff;\n          font-weight: 600;\n          color: #8e44ad;\n          text-align: center;\n        }\n        \n        &.institutionValue {\n          background: white;\n          color: #495057;\n          font-weight: 500;\n        }\n        \n        &.totalValue {\n          background: #e8f5e8;\n          font-weight: 600;\n          color: #27ae60;\n        }\n      }\n      \n      .sectionHeaderRow {\n        .sectionHeader {\n          background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n          color: white;\n          font-size: 14px;\n          text-align: left;\n          padding: 15px 8px;\n        }\n      }\n      \n      .subtotalRow {\n        background: #fff3cd;\n        \n        .budgetCode {\n          background: #fff3cd;\n        }\n        \n        .budgetTitle {\n          background: #fff3cd;\n        }\n        \n        .codeNumber {\n          background: #fff3cd;\n        }\n        \n        .institutionValue {\n          background: #fff3cd;\n          font-weight: 600;\n        }\n        \n        .totalValue {\n          background: #d4edda;\n          color: #155724;\n        }\n      }\n      \n      .dataRow {\n        &:hover {\n          background-color: #f8f9fa;\n        }\n      }\n      \n      .grandTotalRow {\n        background: #d1ecf1;\n        \n        .budgetTitle {\n          background: #d1ecf1;\n          font-size: 14px;\n        }\n        \n        .codeNumber {\n          background: #d1ecf1;\n        }\n        \n        .institutionValue {\n          background: #d1ecf1;\n          font-weight: 600;\n        }\n        \n        .totalValue {\n          background: #cce5ff;\n          color: #004085;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  // Budget Demand Table Styles\n.budgetDemandTable {\n  width: 100%;\n  overflow-x: auto;\n  margin: 20px 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-collapse: separate;\n  border-spacing: 0;\n\n  // When this class is on the <table> itself (BudgetDemandReport)\n  > thead > tr:first-child > th:nth-child(1),\n  > tbody > tr > td:nth-child(1) {\n    position: sticky;\n    left: 0;\n    z-index: 4;\n    background: #f5f7fa;\n    min-width: 70px;\n  }\n\n  > thead > tr:first-child > th:nth-child(2),\n  > tbody > tr > td:nth-child(2) {\n    position: sticky;\n    left: 70px;\n    z-index: 4;\n    background: #f5f7fa;\n    min-width: 250px;\n    box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.12);\n  }\n  \n  table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    font-size: 14px;\n    \n    th, td {\n      padding: 12px 8px;\n      text-align: center;\n      border: 1px solid #e0e0e0;\n      vertical-align: middle;\n    }\n    \n    th {\n      background-color: #f5f7fa;\n      font-weight: 600;\n      color: #2c3e50;\n      white-space: nowrap;\n      position: sticky;\n      top: 0;\n      z-index: 10;\n    }\n    \n    tbody tr {\n      transition: background-color 0.2s ease;\n      \n      &:nth-child(even) {\n        background-color: #f9f9f9;\n      }\n      \n      &:hover {\n        background-color: #f0f7ff;\n      }\n    }\n    \n    .expenseTitle {\n      text-align: left;\n      min-width: 250px;\n      max-width: 300px;\n      \n      .code {\n        font-weight: 600;\n        color: #2c3e50;\n        margin-bottom: 4px;\n        font-size: 13px;\n      }\n      \n      .title {\n        font-size: 12px;\n        color: #555;\n        line-height: 1.4;\n      }\n    }\n    \n    .budgetInput {\n      width: 80px;\n      padding: 6px 8px;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n      text-align: right;\n      font-family: monospace;\n      font-size: 13px;\n      transition: all 0.2s ease;\n      background-color: white;\n      \n      &:focus {\n        outline: none;\n        border-color: #4a90e2;\n        box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\n      }\n      \n      &:hover:not(:focus) {\n        border-color: #bbb;\n      }\n      \n      &:read-only {\n        background-color: #f8f9fa;\n        cursor: default;\n      }\n    }\n  }\n  \n  @media (max-width: 768px) {\n    table {\n      th, td {\n        padding: 8px 6px;\n        font-size: 13px;\n      }\n      \n      .expenseTitle {\n        min-width: 200px;\n        max-width: 250px;\n      }\n      \n      .budgetInput {\n        width: 70px;\n        padding: 4px 6px;\n      }\n    }\n  }\n}\n\n.exportSection {\n    text-align: center;\n    padding: 20px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    border: 1px solid #e9ecef;\n\n    h4 {\n      color: #2c3e50;\n      font-size: 18px;\n      font-weight: bold;\n      margin: 0 0 20px 0;\n    }\n\n    .exportButtons {\n      display: flex;\n      gap: 15px;\n      justify-content: center;\n      flex-wrap: wrap;\n\n      button {\n        padding: 12px 25px;\n        border: none;\n        border-radius: 6px;\n        font-size: 14px;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n        }\n\n        &.excelButton {\n          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n          color: white;\n        }\n\n        &.pdfButton {\n          background: #dc3545;\n          color: white;\n        }\n\n        &.printButton {\n          background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);\n          color: white;\n        }\n      }\n    }\n  }\n}\n\n// Responsive design for smaller screens\n@media (max-width: 768px) {\n  .editFormContainer {\n    padding: 10px;\n  }\n  \n  .editFormContent {\n    max-height: 98vh;\n  }\n  \n  .editFormHeader {\n    padding: 15px 20px;\n    \n    h2 {\n      font-size: 20px;\n    }\n  }\n  \n  .editForm {\n    padding: 0 20px 20px 20px;\n  }\n  \n  .editFormActions {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .successMessage {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n}\n\n.detailedReportTabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  padding: 0 20px;\n\n  .detailedTabButton {\n    padding: 10px 20px;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n    background: white;\n    color: #6c757d;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    &:hover {\n      border-color: #4a90e2;\n      color: #4a90e2;\n      transform: translateY(-1px);\n      box-shadow: 0 2px 8px rgba(74, 144, 226, 0.2);\n    }\n\n    &.activeDetailedTab {\n      background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);\n      color: white;\n      border-color: #4a90e2;\n      box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);\n    }\n  }\n}\n\n// Token Success Popup Styles\n.tokenPopupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(8px);\n  z-index: 10001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.tokenPopup {\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  max-width: 500px;\n  width: 100%;\n  overflow: hidden;\n  animation: slideInUp 0.4s ease-out;\n  border: 2px solid #e9ecef;\n}\n\n.tokenPopupHeader {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  padding: 30px 30px 20px 30px;\n  text-align: center;\n  position: relative;\n  \n  .tokenSuccessIcon {\n    font-size: 3rem;\n    margin-bottom: 15px;\n    animation: bounceIn 0.6s ease-out;\n  }\n  \n  h2 {\n    margin: 0 0 10px 0;\n    font-size: 1.8rem;\n    font-weight: 700;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  }\n  \n  p {\n    margin: 0;\n    font-size: 1rem;\n    opacity: 0.95;\n    line-height: 1.4;\n  }\n}\n\n.tokenDisplay {\n  padding: 30px;\n  background: white;\n  \n  .tokenLabel {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 15px;\n    text-align: center;\n  }\n  \n  .tokenValue {\n    background: linear-gradient(135deg, #6f42c1 0%, #e83e8c 100%);\n    color: white;\n    font-family: 'Courier New', monospace;\n    font-size: 1.5rem;\n    font-weight: bold;\n    padding: 20px;\n    border-radius: 12px;\n    text-align: center;\n    margin-bottom: 25px;\n    box-shadow: 0 8px 25px rgba(111, 66, 193, 0.3);\n    letter-spacing: 2px;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    animation: pulse 2s infinite;\n  }\n  \n  .tokenInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    \n    .tokenInfoItem {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 12px 16px;\n      background: #f8f9fa;\n      border-radius: 8px;\n      border: 1px solid #e9ecef;\n      \n      .tokenInfoLabel {\n        font-weight: 600;\n        color: #495057;\n        font-size: 0.95rem;\n      }\n      \n      .tokenInfoValue {\n        color: #6c757d;\n        font-weight: 500;\n        font-size: 0.95rem;\n      }\n    }\n  }\n}\n\n\n\n.tokenPopupActions {\n  padding: 0 30px 20px 30px;\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  \n  .tokenCopyButton, .tokenCloseButton {\n    padding: 12px 24px;\n    border: none;\n    border-radius: 25px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 0.95rem;\n    min-width: 140px;\n  }\n  \n  .tokenCopyButton {\n    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n    color: white;\n    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);\n    \n    &:hover {\n      background: linear-gradient(135deg, #0056b3 0%, #004085 100%);\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\n    }\n    \n    &:active {\n      transform: translateY(0);\n    }\n    \n    // Copy success state\n    &.copySuccess {\n      background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n      box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n      \n      &:hover {\n        background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);\n        box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);\n      }\n    }\n  }\n  \n  .tokenCloseButton {\n    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n    color: white;\n    box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);\n    \n    &:hover {\n      background: linear-gradient(135deg, #495057 0%, #343a40 100%);\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);\n    }\n    \n    &:active {\n      transform: translateY(0);\n    }\n  }\n}\n\n.tokenPopupFooter {\n  background: #fff3cd;\n  border-top: 1px solid #ffeaa7;\n  padding: 15px 30px;\n  text-align: center;\n  \n  p {\n    margin: 0;\n    color: #856404;\n    font-size: 0.9rem;\n    font-weight: 500;\n    line-height: 1.4;\n  }\n}\n\n.budgetActionOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  z-index: 1300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.budgetActionModal {\n  width: min(1180px, 100%);\n  max-height: calc(100vh - 32px);\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.28);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.budgetActionHeader {\n  padding: 14px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  border-bottom: 1px solid #e9ecef;\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  color: #ffffff;\n\n  h3 {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: 700;\n  }\n}\n\n.budgetActionClose {\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  font-size: 1.25rem;\n  line-height: 1;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.35);\n  }\n}\n\n.budgetActionMeta {\n  padding: 10px 18px;\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fb;\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  font-size: 0.9rem;\n  color: #334155;\n}\n\n.budgetActionBody {\n  padding: 10px 16px 0;\n  overflow: auto;\n}\n\n.budgetPopupInput {\n  width: 100%;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  padding: 6px 8px;\n  font-size: 0.85rem;\n  background: #ffffff;\n\n  &:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.12);\n  }\n}\n\n.budgetActionInfo {\n  margin: 10px 16px 0;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 0.88rem;\n  font-weight: 600;\n\n  &.success {\n    background: #eafaf1;\n    border: 1px solid #ccefdc;\n    color: #166534;\n  }\n\n  &.error {\n    background: #fff1f2;\n    border: 1px solid #ffd6de;\n    color: #9f1239;\n  }\n\n  &.info {\n    background: #eef2ff;\n    border: 1px solid #dbe4ff;\n    color: #1e3a8a;\n  }\n}\n\n.budgetActionActions {\n  padding: 12px 16px 16px;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  background: #ffffff;\n}\n\n.budgetActionButton {\n  border: none;\n  border-radius: 8px;\n  padding: 9px 14px;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  background: #e9ecef;\n  color: #334155;\n\n  &:hover {\n    background: #dfe3e8;\n  }\n}\n\n.budgetActionSave {\n  background: #e67e22;\n  color: #ffffff;\n\n  &:hover:not(:disabled) {\n    background: #d96f0f;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n// Animations for token popup\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n  70% {\n    transform: scale(0.9);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 8px 25px rgba(111, 66, 193, 0.3);\n  }\n  50% {\n    box-shadow: 0 8px 25px rgba(111, 66, 193, 0.6);\n  }\n  100% {\n    box-shadow: 0 8px 25px rgba(111, 66, 193, 0.3);\n  }\n}\n\n// Responsive design for token popup\n@media (max-width: 768px) {\n  .budgetActionOverlay {\n    padding: 8px;\n  }\n\n  .budgetActionModal {\n    max-height: calc(100vh - 16px);\n  }\n\n  .budgetActionHeader {\n    padding: 12px 14px;\n\n    h3 {\n      font-size: 0.95rem;\n    }\n  }\n\n  .budgetActionMeta {\n    padding: 10px 14px;\n    font-size: 0.85rem;\n    gap: 8px;\n  }\n\n  .budgetActionBody {\n    padding: 8px 10px 0;\n  }\n\n  .budgetActionActions {\n    padding: 10px 12px 12px;\n    flex-direction: column-reverse;\n  }\n\n  .budgetActionButton {\n    width: 100%;\n  }\n\n  .tokenPopup {\n    max-width: 95vw;\n    margin: 10px;\n  }\n  \n  .tokenPopupHeader {\n    padding: 25px 20px 15px 20px;\n    \n    h2 {\n      font-size: 1.5rem;\n    }\n    \n    p {\n      font-size: 0.9rem;\n    }\n  }\n  \n  .tokenDisplay {\n    padding: 20px;\n    \n    .tokenValue {\n      font-size: 1.2rem;\n      padding: 15px;\n      letter-spacing: 1px;\n    }\n  }\n  \n\n  \n  .tokenPopupActions {\n    padding: 0 20px 15px 20px;\n    flex-direction: column;\n    \n    .tokenCopyButton, .tokenCloseButton {\n      min-width: auto;\n      width: 100%;\n    }\n  }\n  \n  .tokenPopupFooter {\n    padding: 12px 20px;\n    \n    p {\n      font-size: 0.85rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"capitalExpenditureContainer": `capitalExpenditure_capitalExpenditureContainer__QFLet`,
	"header": `capitalExpenditure_header__01PDc`,
	"universityTitle": `capitalExpenditure_universityTitle__UMlaw`,
	"currentYearBanner": `capitalExpenditure_currentYearBanner__EBHiz`,
	"currentYearLabel": `capitalExpenditure_currentYearLabel__6EThY`,
	"currentYearValue": `capitalExpenditure_currentYearValue__4v6+V`,
	"navButtons": `capitalExpenditure_navButtons__zEVZ8`,
	"navButton": `capitalExpenditure_navButton__ssAwr`,
	"active": `capitalExpenditure_active__o+vnK`,
	"activeTab": `capitalExpenditure_activeTab__ToyLT`,
	"logoutButton": `capitalExpenditure_logoutButton__UY6yH`,
	"tabButton": `capitalExpenditure_tabButton__XOWV4`,
	"formInput": `capitalExpenditure_formInput__1GSMK`,
	"formSelect": `capitalExpenditure_formSelect__0Qiyk`,
	"formRow": `capitalExpenditure_formRow__QCC9C`,
	"modeIndicator": `capitalExpenditure_modeIndicator__5o6Kp`,
	"viewMode": `capitalExpenditure_viewMode__vd6i8`,
	"editMode": `capitalExpenditure_editMode__9NJy3`,
	"officeDropdownContainer": `capitalExpenditure_officeDropdownContainer__XJtsy`,
	"refreshButton": `capitalExpenditure_refreshButton__5DgQo`,
	"modalOverlay": `capitalExpenditure_modalOverlay__35Ny6`,
	"popupMessage": `capitalExpenditure_popupMessage__5f4NT`,
	"modalSlideIn": `capitalExpenditure_modalSlideIn__fCD6P`,
	"refresh": `capitalExpenditure_refresh__zWQ2+`,
	"refreshPopupHeader": `capitalExpenditure_refreshPopupHeader__ItWQo`,
	"refreshPopupBody": `capitalExpenditure_refreshPopupBody__cEiQB`,
	"refreshPopupActions": `capitalExpenditure_refreshPopupActions__ujuMt`,
	"confirmButton": `capitalExpenditure_confirmButton__fy16w`,
	"cancelButton": `capitalExpenditure_cancelButton__eUZxV`,
	"uploadSection": `capitalExpenditure_uploadSection__CPIBj`,
	"uploadLabel": `capitalExpenditure_uploadLabel__cOE-S`,
	"uploadInputContainer": `capitalExpenditure_uploadInputContainer__Z3QVI`,
	"uploadInput": `capitalExpenditure_uploadInput__DlWBo`,
	"uploadButton": `capitalExpenditure_uploadButton__X5JcD`,
	"downloadTemplateButton": `capitalExpenditure_downloadTemplateButton__Ai2Ic`,
	"selectedFileInfo": `capitalExpenditure_selectedFileInfo__DcgOD`,
	"clearFileButton": `capitalExpenditure_clearFileButton__geccq`,
	"uploadingNote": `capitalExpenditure_uploadingNote__WBFS8`,
	"uploadWarning": `capitalExpenditure_uploadWarning__ixjuH`,
	"uploadHint": `capitalExpenditure_uploadHint__oB38J`,
	"settingsContainer": `capitalExpenditure_settingsContainer__zrlJ2`,
	"settingsTitle": `capitalExpenditure_settingsTitle__wdE5k`,
	"subTabNavigation": `capitalExpenditure_subTabNavigation__bfJpT`,
	"subTabButton": `capitalExpenditure_subTabButton__E9qFQ`,
	"activeSubTab": `capitalExpenditure_activeSubTab__d3nDF`,
	"listSettingsContent": `capitalExpenditure_listSettingsContent__i6cnu`,
	"tokenSettingsContent": `capitalExpenditure_tokenSettingsContent__hDtPc`,
	"selectionInfo": `capitalExpenditure_selectionInfo__YItRo`,
	"infoBox": `capitalExpenditure_infoBox__0U68v`,
	"masterItemsSection": `capitalExpenditure_masterItemsSection__-5CY+`,
	"masterItemsTable": `capitalExpenditure_masterItemsTable__fH7PN`,
	"masterItemsHeader": `capitalExpenditure_masterItemsHeader__xseE1`,
	"headerCheckbox": `capitalExpenditure_headerCheckbox__VqEbV`,
	"headerCode": `capitalExpenditure_headerCode__gVq8i`,
	"headerTitle": `capitalExpenditure_headerTitle__Y4bIW`,
	"headerType": `capitalExpenditure_headerType__AAvn5`,
	"headerActions": `capitalExpenditure_headerActions__S8EFw`,
	"masterItemsList": `capitalExpenditure_masterItemsList__Zf45x`,
	"masterItem": `capitalExpenditure_masterItem__DGs9h`,
	"itemCode": `capitalExpenditure_itemCode__kdNIP`,
	"itemTitle": `capitalExpenditure_itemTitle__1BdIc`,
	"itemType": `capitalExpenditure_itemType__j8+pH`,
	"capital": `capitalExpenditure_capital__LJS4p`,
	"operational": `capitalExpenditure_operational__d+FP4`,
	"itemCheckbox": `capitalExpenditure_itemCheckbox__kaQ6D`,
	"itemActions": `capitalExpenditure_itemActions__33Pw1`,
	"successBox": `capitalExpenditure_successBox__c5HxQ`,
	"officeDropdown": `capitalExpenditure_officeDropdown__3vzAz`,
	"required": `capitalExpenditure_required__hp26l`,
	"selectedOffice": `capitalExpenditure_selectedOffice__Qahw4`,
	"dropdownArrow": `capitalExpenditure_dropdownArrow__tm1yu`,
	"officeDropdownMenu": `capitalExpenditure_officeDropdownMenu__6yp0r`,
	"slideDown": `capitalExpenditure_slideDown__b2SfC`,
	"searchContainer": `capitalExpenditure_searchContainer__4nM-0`,
	"officeSearchInput": `capitalExpenditure_officeSearchInput__EVy7L`,
	"officeOptionsList": `capitalExpenditure_officeOptionsList__vsEPR`,
	"officeOption": `capitalExpenditure_officeOption__SMLoi`,
	"selected": `capitalExpenditure_selected__Dxo2F`,
	"noResults": `capitalExpenditure_noResults__WeQG+`,
	"categoryDropdownContainer": `capitalExpenditure_categoryDropdownContainer__lZsnM`,
	"categoryDropdown": `capitalExpenditure_categoryDropdown__lrKkn`,
	"selectedCategory": `capitalExpenditure_selectedCategory__qrU1P`,
	"categoryDropdownMenu": `capitalExpenditure_categoryDropdownMenu__RuYqw`,
	"categoryOptionsList": `capitalExpenditure_categoryOptionsList__8VsWi`,
	"categoryOption": `capitalExpenditure_categoryOption__DbuAd`,
	"categorySearchInput": `capitalExpenditure_categorySearchInput__p6UAT`,
	"fiscalYear": `capitalExpenditure_fiscalYear__uykQQ`,
	"message": `capitalExpenditure_message__7yyix`,
	"slideIn": `capitalExpenditure_slideIn__63+TM`,
	"success": `capitalExpenditure_success__Z4Ssi`,
	"error": `capitalExpenditure_error__hJFf+`,
	"info": `capitalExpenditure_info__HTu4G`,
	"clearPrompt": `capitalExpenditure_clearPrompt__Jm3-g`,
	"fadeIn": `capitalExpenditure_fadeIn__pqSNr`,
	"clearPromptContent": `capitalExpenditure_clearPromptContent__60TwZ`,
	"scaleIn": `capitalExpenditure_scaleIn__TxtWp`,
	"clearPromptButtons": `capitalExpenditure_clearPromptButtons__PNbmF`,
	"clearButton": `capitalExpenditure_clearButton__vQ+AP`,
	"keepButton": `capitalExpenditure_keepButton__Y55VI`,
	"expenditureForm": `capitalExpenditure_expenditureForm__+1tXb`,
	"formHeader": `capitalExpenditure_formHeader__+qwZG`,
	"formInfo": `capitalExpenditure_formInfo__QTJSS`,
	"infoGroup": `capitalExpenditure_infoGroup__Z7TDy`,
	"fiscalYearSelect": `capitalExpenditure_fiscalYearSelect__rJNCC`,
	"tableContainer": `capitalExpenditure_tableContainer__esNEd`,
	"expenditureTable": `capitalExpenditure_expenditureTable__l2sPf`,
	"titleCell": `capitalExpenditure_titleCell__J04+V`,
	"inputField": `capitalExpenditure_inputField__PHrs1`,
	"dataViewYearBar": `capitalExpenditure_dataViewYearBar__YGYXb`,
	"dataViewContainer": `capitalExpenditure_dataViewContainer__QQhqR`,
	"filtersSection": `capitalExpenditure_filtersSection__0pO7p`,
	"filterActions": `capitalExpenditure_filterActions__5v2Wq`,
	"filterToggleButton": `capitalExpenditure_filterToggleButton__qA9TK`,
	"excelButton": `capitalExpenditure_excelButton__n202q`,
	"bulkDeleteButton": `capitalExpenditure_bulkDeleteButton__RIjk2`,
	"detailedReportTabs": `capitalExpenditure_detailedReportTabs__HM6h4`,
	"stickyCol1": `capitalExpenditure_stickyCol1__7+EKr`,
	"stickyCol2": `capitalExpenditure_stickyCol2__g5K+u`,
	"stickyCol3": `capitalExpenditure_stickyCol3__j-q5k`,
	"stickyCol4": `capitalExpenditure_stickyCol4__1Oa8l`,
	"stickyColGroup2": `capitalExpenditure_stickyColGroup2__tYUc+`,
	"stickyColGroup4": `capitalExpenditure_stickyColGroup4__kKzgv`,
	"categoryCellSticky": `capitalExpenditure_categoryCellSticky__9nadE`,
	"totalLabel": `capitalExpenditure_totalLabel__9A-h8`,
	"mainHeader": `capitalExpenditure_mainHeader__6k+NI`,
	"subHeader": `capitalExpenditure_subHeader__-3MiM`,
	"codeHeader": `capitalExpenditure_codeHeader__okuMw`,
	"titleHeader": `capitalExpenditure_titleHeader__0mlEY`,
	"budgetHeader": `capitalExpenditure_budgetHeader__JljXv`,
	"budgetHeaderSticky3": `capitalExpenditure_budgetHeaderSticky3__izyco`,
	"budgetHeaderSticky4": `capitalExpenditure_budgetHeaderSticky4__KBZVe`,
	"quarterHeader": `capitalExpenditure_quarterHeader__AdZ01`,
	"summaryHeader": `capitalExpenditure_summaryHeader__flOVC`,
	"differenceHeader": `capitalExpenditure_differenceHeader__+Cvdz`,
	"subHeaderCell": `capitalExpenditure_subHeaderCell__yQ4mv`,
	"addRowButtons": `capitalExpenditure_addRowButtons__K3WuB`,
	"addRowButton": `capitalExpenditure_addRowButton__sr6OW`,
	"codeColumn": `capitalExpenditure_codeColumn__PTlVn`,
	"titleColumn": `capitalExpenditure_titleColumn__2PMXm`,
	"budgetColumn": `capitalExpenditure_budgetColumn__hpw9z`,
	"actionColumn": `capitalExpenditure_actionColumn__5RhQC`,
	"categoryRow": `capitalExpenditure_categoryRow__2Iz+l`,
	"categoryCell": `capitalExpenditure_categoryCell__mDEXf`,
	"dataRow": `capitalExpenditure_dataRow__mbHll`,
	"codeCell": `capitalExpenditure_codeCell__yTp+Z`,
	"budgetCell": `capitalExpenditure_budgetCell__gzrPV`,
	"actionCell": `capitalExpenditure_actionCell__O56UO`,
	"removeButton": `capitalExpenditure_removeButton__ccmQJ`,
	"addRowContainer": `capitalExpenditure_addRowContainer__aX7rA`,
	"totalRow": `capitalExpenditure_totalRow__FpLdY`,
	"incomeRow": `capitalExpenditure_incomeRow__qm0va`,
	"incomeLabel": `capitalExpenditure_incomeLabel__PDokr`,
	"incomeCell": `capitalExpenditure_incomeCell__uy5qy`,
	"incomeSpacer": `capitalExpenditure_incomeSpacer__T47Xj`,
	"totalInputField": `capitalExpenditure_totalInputField__yafB7`,
	"buttonContainer": `capitalExpenditure_buttonContainer__Hj6ec`,
	"loadDataButton": `capitalExpenditure_loadDataButton__mW4Jw`,
	"submitButton": `capitalExpenditure_submitButton__9zYjC`,
	"resetButton": `capitalExpenditure_resetButton__dvWiu`,
	"updateButton": `capitalExpenditure_updateButton__bj4gQ`,
	"readOnly": `capitalExpenditure_readOnly__W73Cr`,
	"disabled": `capitalExpenditure_disabled__x00GS`,
	"viewButton": `capitalExpenditure_viewButton__yWxzg`,
	"editButton": `capitalExpenditure_editButton__wNa1b`,
	"deleteButton": `capitalExpenditure_deleteButton__vqJ8Y`,
	"actionButtons": `capitalExpenditure_actionButtons__1ELyy`,
	"quarterSection": `capitalExpenditure_quarterSection__6bUAz`,
	"financialSummaryCell": `capitalExpenditure_financialSummaryCell__VptoP`,
	"financialSummary": `capitalExpenditure_financialSummary__XUHM5`,
	"summaryRow": `capitalExpenditure_summaryRow__KBajU`,
	"summaryLabel": `capitalExpenditure_summaryLabel__Ak8Vb`,
	"summaryValue": `capitalExpenditure_summaryValue__9MquJ`,
	"summaryTotalRow": `capitalExpenditure_summaryTotalRow__TH3AD`,
	"highlightRow": `capitalExpenditure_highlightRow__Y8iu4`,
	"backButton": `capitalExpenditure_backButton__HkkB5`,
	"printButton": `capitalExpenditure_printButton__8Rlxw`,
	"applyFilterButton": `capitalExpenditure_applyFilterButton__b6Awq`,
	"clearFilterButton": `capitalExpenditure_clearFilterButton__Mnlxg`,
	"dataList": `capitalExpenditure_dataList__9j3y0`,
	"dataTableContainer": `capitalExpenditure_dataTableContainer__9Rybb`,
	"dataTable": `capitalExpenditure_dataTable__gzdMK`,
	"tokenDisplay": `capitalExpenditure_tokenDisplay__TjKzL`,
	"tokenInfo": `capitalExpenditure_tokenInfo__Fmmyc`,
	"tokenDetails": `capitalExpenditure_tokenDetails__U4olv`,
	"tokenNote": `capitalExpenditure_tokenNote__pBNS6`,
	"filtersContainer": `capitalExpenditure_filtersContainer__qZypt`,
	"filterRow": `capitalExpenditure_filterRow__VMr9G`,
	"filterGroup": `capitalExpenditure_filterGroup__EGvAK`,
	"applyFiltersButton": `capitalExpenditure_applyFiltersButton__-0+43`,
	"clearFiltersButton": `capitalExpenditure_clearFiltersButton__wwT6p`,
	"loading": `capitalExpenditure_loading__+AuQJ`,
	"statusBadge": `capitalExpenditure_statusBadge__2QpRH`,
	"draft": `capitalExpenditure_draft__mCoKY`,
	"submitted": `capitalExpenditure_submitted__C6bXG`,
	"approved": `capitalExpenditure_approved__9A176`,
	"rejected": `capitalExpenditure_rejected__QYLZ4`,
	"completed": `capitalExpenditure_completed__xtdo3`,
	"exportButton": `capitalExpenditure_exportButton__hMg65`,
	"noDataMessage": `capitalExpenditure_noDataMessage__v2TFg`,
	"editModal": `capitalExpenditure_editModal__pTj+C`,
	"editModalContent": `capitalExpenditure_editModalContent__GVsso`,
	"editForm": `capitalExpenditure_editForm__RozmY`,
	"formGroup": `capitalExpenditure_formGroup__bdAAB`,
	"editActions": `capitalExpenditure_editActions__1Kn6Z`,
	"saveButton": `capitalExpenditure_saveButton__4ekdK`,
	"dataViewActions": `capitalExpenditure_dataViewActions__kqN2U`,
	"dataItem": `capitalExpenditure_dataItem__eXR+m`,
	"summaryButton": `capitalExpenditure_summaryButton__dLMfW`,
	"detailedReportButton": `capitalExpenditure_detailedReportButton__uyKq1`,
	"infoButton": `capitalExpenditure_infoButton__Ta6-x`,
	"filterContainer": `capitalExpenditure_filterContainer__2BmI3`,
	"filterHeader": `capitalExpenditure_filterHeader__P3GKC`,
	"filterToggle": `capitalExpenditure_filterToggle__SFJkF`,
	"filterForm": `capitalExpenditure_filterForm__gkm5y`,
	"filterInput": `capitalExpenditure_filterInput__crZqj`,
	"filterSelect": `capitalExpenditure_filterSelect__TBPQZ`,
	"filterInfo": `capitalExpenditure_filterInfo__VcNEK`,
	"quarterSelector": `capitalExpenditure_quarterSelector__zBZhQ`,
	"quarterButton": `capitalExpenditure_quarterButton__TktiH`,
	"noData": `capitalExpenditure_noData__gcRDg`,
	"noDataContent": `capitalExpenditure_noDataContent__ND5yB`,
	"noDataActions": `capitalExpenditure_noDataActions__idzss`,
	"primaryButton": `capitalExpenditure_primaryButton__oF+wW`,
	"noDataInstructions": `capitalExpenditure_noDataInstructions__MfKZ9`,
	"fiscalYearContainer": `capitalExpenditure_fiscalYearContainer__kmp+V`,
	"fiscalYearLabel": `capitalExpenditure_fiscalYearLabel__JCLOi`,
	"fiscalYearLocked": `capitalExpenditure_fiscalYearLocked__4KDA8`,
	"toggleViewButton": `capitalExpenditure_toggleViewButton__8yyu6`,
	"viewModeInfo": `capitalExpenditure_viewModeInfo__gD6S2`,
	"viewModeText": `capitalExpenditure_viewModeText__1gqfy`,
	"slideInRight": `capitalExpenditure_slideInRight__Cu4Ap`,
	"popupContent": `capitalExpenditure_popupContent__Lwvjf`,
	"warning": `capitalExpenditure_warning__6rr3K`,
	"popupText": `capitalExpenditure_popupText__HGqtn`,
	"popupClose": `capitalExpenditure_popupClose__LHhoy`,
	"hiding": `capitalExpenditure_hiding__PBbi7`,
	"slideOutRight": `capitalExpenditure_slideOutRight__m9zmb`,
	"newDataButton": `capitalExpenditure_newDataButton__z0rMQ`,
	"editFormContainer": `capitalExpenditure_editFormContainer__Iw4Mf`,
	"editFormContent": `capitalExpenditure_editFormContent__27jWB`,
	"editFormHeader": `capitalExpenditure_editFormHeader__yl4B+`,
	"editFormActions": `capitalExpenditure_editFormActions__tVqTn`,
	"headerContent": `capitalExpenditure_headerContent__FxBbx`,
	"currentYearFormNote": `capitalExpenditure_currentYearFormNote__iUCeK`,
	"editFormYearSwitch": `capitalExpenditure_editFormYearSwitch__TeSOt`,
	"yearSwitchLoading": `capitalExpenditure_yearSwitchLoading__HtN+y`,
	"successMessage": `capitalExpenditure_successMessage__FGVbD`,
	"closeButton": `capitalExpenditure_closeButton__iTG3W`,
	"downloadExcelButton": `capitalExpenditure_downloadExcelButton__m3YdO`,
	"section": `capitalExpenditure_section__gi5Ix`,
	"remainingBalance": `capitalExpenditure_remainingBalance__tWQCl`,
	"searchSection": `capitalExpenditure_searchSection__Z7SiD`,
	"searchInputContainer": `capitalExpenditure_searchInputContainer__CJgWx`,
	"searchInput": `capitalExpenditure_searchInput__DzXz9`,
	"searchButton": `capitalExpenditure_searchButton__WoCr8`,
	"clearSearchButton": `capitalExpenditure_clearSearchButton__VncP0`,
	"searchHint": `capitalExpenditure_searchHint__jlh49`,
	"searchResults": `capitalExpenditure_searchResults__fNl+S`,
	"resultsList": `capitalExpenditure_resultsList__3WlGO`,
	"resultItem": `capitalExpenditure_resultItem__yaxC7`,
	"resultCode": `capitalExpenditure_resultCode__NlC9D`,
	"resultTitle": `capitalExpenditure_resultTitle__dG0H3`,
	"resultType": `capitalExpenditure_resultType__BEOFw`,
	"populateButton": `capitalExpenditure_populateButton__FCJiT`,
	"summaryReportSection": `capitalExpenditure_summaryReportSection__7Lkhw`,
	"summaryStats": `capitalExpenditure_summaryStats__M61k0`,
	"statCard": `capitalExpenditure_statCard__lxp19`,
	"statTitle": `capitalExpenditure_statTitle__ls5SV`,
	"statValue": `capitalExpenditure_statValue__9tV-F`,
	"breakdownSection": `capitalExpenditure_breakdownSection__nDAu0`,
	"statusBreakdown": `capitalExpenditure_statusBreakdown__H-Qcc`,
	"statusItem": `capitalExpenditure_statusItem__AImrh`,
	"statusName": `capitalExpenditure_statusName__UOqQO`,
	"statusCount": `capitalExpenditure_statusCount__JPDWv`,
	"statusPercentage": `capitalExpenditure_statusPercentage__KgxdC`,
	"institutionBreakdown": `capitalExpenditure_institutionBreakdown__3F0FM`,
	"institutionItem": `capitalExpenditure_institutionItem__8FDZP`,
	"institutionHeader": `capitalExpenditure_institutionHeader__uxHGq`,
	"institutionName": `capitalExpenditure_institutionName__VvFNC`,
	"institutionCount": `capitalExpenditure_institutionCount__jYheF`,
	"institutionDetails": `capitalExpenditure_institutionDetails__5sW2J`,
	"detailRow": `capitalExpenditure_detailRow__Di7wB`,
	"detailedReportSection": `capitalExpenditure_detailedReportSection__JC3qt`,
	"detailedHeader": `capitalExpenditure_detailedHeader__0IoSx`,
	"detailedStats": `capitalExpenditure_detailedStats__L0hWY`,
	"detailedTableContainer": `capitalExpenditure_detailedTableContainer__0vl4z`,
	"tableWrapper": `capitalExpenditure_tableWrapper__bU+bA`,
	"detailedTable": `capitalExpenditure_detailedTable__HZuj5`,
	"detailedRow": `capitalExpenditure_detailedRow__OSXem`,
	"detailedActions": `capitalExpenditure_detailedActions__lMz5C`,
	"summaryExcelTableContainer": `capitalExpenditure_summaryExcelTableContainer__ftEfd`,
	"summaryExcelTable": `capitalExpenditure_summaryExcelTable__BGTxN`,
	"budgetCodeHeader": `capitalExpenditure_budgetCodeHeader__h5-Fg`,
	"budgetTitleHeader": `capitalExpenditure_budgetTitleHeader__ObctZ`,
	"codeNumberHeader": `capitalExpenditure_codeNumberHeader__KeDHL`,
	"totalHeader": `capitalExpenditure_totalHeader__g208+`,
	"budgetCode": `capitalExpenditure_budgetCode__JAxXu`,
	"budgetTitle": `capitalExpenditure_budgetTitle__hPEHk`,
	"budgetCodeCell": `capitalExpenditure_budgetCodeCell__33UhY`,
	"budgetTitleCell": `capitalExpenditure_budgetTitleCell__MfOqE`,
	"codeNumber": `capitalExpenditure_codeNumber__Yd-1c`,
	"institutionValue": `capitalExpenditure_institutionValue__LmtAm`,
	"totalValue": `capitalExpenditure_totalValue__Nmhpl`,
	"sectionHeaderRow": `capitalExpenditure_sectionHeaderRow__cZdrR`,
	"sectionHeader": `capitalExpenditure_sectionHeader__dNSfb`,
	"subtotalRow": `capitalExpenditure_subtotalRow__+YVNr`,
	"grandTotalRow": `capitalExpenditure_grandTotalRow__8cFqn`,
	"budgetDemandTable": `capitalExpenditure_budgetDemandTable__jniZ0`,
	"expenseTitle": `capitalExpenditure_expenseTitle__hWSc8`,
	"code": `capitalExpenditure_code__+f1U7`,
	"title": `capitalExpenditure_title__MJLdo`,
	"budgetInput": `capitalExpenditure_budgetInput__DwZeO`,
	"exportSection": `capitalExpenditure_exportSection__vOA7K`,
	"exportButtons": `capitalExpenditure_exportButtons__fAQ2M`,
	"pdfButton": `capitalExpenditure_pdfButton__hf-X+`,
	"detailedTabButton": `capitalExpenditure_detailedTabButton__oN50C`,
	"activeDetailedTab": `capitalExpenditure_activeDetailedTab__cQbQY`,
	"tokenPopupOverlay": `capitalExpenditure_tokenPopupOverlay__xX2RQ`,
	"tokenPopup": `capitalExpenditure_tokenPopup__xPGqp`,
	"slideInUp": `capitalExpenditure_slideInUp__CxLSA`,
	"tokenPopupHeader": `capitalExpenditure_tokenPopupHeader__F7u0t`,
	"tokenSuccessIcon": `capitalExpenditure_tokenSuccessIcon__5r+id`,
	"bounceIn": `capitalExpenditure_bounceIn__zLpY6`,
	"tokenLabel": `capitalExpenditure_tokenLabel__GBH-U`,
	"tokenValue": `capitalExpenditure_tokenValue__Q28fO`,
	"pulse": `capitalExpenditure_pulse__Lll+m`,
	"tokenInfoItem": `capitalExpenditure_tokenInfoItem__fZGZZ`,
	"tokenInfoLabel": `capitalExpenditure_tokenInfoLabel__ygDfi`,
	"tokenInfoValue": `capitalExpenditure_tokenInfoValue__h7Hp8`,
	"tokenPopupActions": `capitalExpenditure_tokenPopupActions__SbHjP`,
	"tokenCopyButton": `capitalExpenditure_tokenCopyButton__COtIX`,
	"tokenCloseButton": `capitalExpenditure_tokenCloseButton__hDbMw`,
	"copySuccess": `capitalExpenditure_copySuccess__E4Eik`,
	"tokenPopupFooter": `capitalExpenditure_tokenPopupFooter__zpyRL`,
	"budgetActionOverlay": `capitalExpenditure_budgetActionOverlay__90cP1`,
	"budgetActionModal": `capitalExpenditure_budgetActionModal__0K9ud`,
	"budgetActionHeader": `capitalExpenditure_budgetActionHeader__ftmcX`,
	"budgetActionClose": `capitalExpenditure_budgetActionClose__y2j8i`,
	"budgetActionMeta": `capitalExpenditure_budgetActionMeta__nRjqx`,
	"budgetActionBody": `capitalExpenditure_budgetActionBody__lPuHO`,
	"budgetPopupInput": `capitalExpenditure_budgetPopupInput__spUaq`,
	"budgetActionInfo": `capitalExpenditure_budgetActionInfo__SbZGf`,
	"budgetActionActions": `capitalExpenditure_budgetActionActions__Xcb7r`,
	"budgetActionButton": `capitalExpenditure_budgetActionButton__-gauP`,
	"budgetActionSave": `capitalExpenditure_budgetActionSave__5q4l-`
};
export default ___CSS_LOADER_EXPORT___;
